var _defs, _rect, _rect2, _rect3, _text, _text2, _text3, _text4, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _rect9, _path2, _g, _g2, _path3, _path4, _path5, _path6, _g3, _g4, _path7, _rect10, _path8, _path9, _path10, _g5, _g6, _g7, _path11, _g8, _g9, _rect11, _rect12, _g10, _rect13, _rect14, _g11, _g12, _g13, _g14, _g15, _path12, _path13, _path14, _path15, _rect15, _rect16, _rect17, _rect18, _rect19, _path16, _rect20, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _rect21, _path26, _rect22, _rect23, _rect24, _path27, _path28, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _rect25, _rect26, _text5, _rect27, _rect28, _rect29, _rect30, _rect31, _g26, _text6, _text7, _text8, _rect32, _path29, _path30, _path31, _path32, _path33, _g27, _path34, _g28, _g29, _g30, _g31, _g32, _g33, _path35, _path36, _g34, _g35, _g36, _g37, _g38, _path37, _path38, _g39, _g40, _g41, _rect33, _path39, _path40, _g42, _path41, _path42, _path43, _g43, _path44, _path45, _path46, _g44, _path47, _path48, _path49, _g45, _path50, _path51, _path52, _g46, _path53, _path54, _path55, _g47, _path56, _path57, _g48, _path58, _path59, _path60, _path61, _path62, _path63, _g49, _path64, _path65, _path66, _g50, _path67, _path68, _path69, _g51, _path70, _path71, _path72, _g52, _path73, _path74, _path75, _g53, _path76, _path77, _path78, _g54, _path79, _path80, _g55, _path81, _path82, _circle, _path83, _rect34, _path84, _path85, _g56, _path86, _path87, _path88, _g57, _path89, _path90, _path91, _g58, _path92, _path93, _path94, _g59, _path95, _path96, _path97, _g60, _path98, _path99, _path100, _g61, _path101, _path102, _g62, _path103, _path104, _path105, _path106, _path107, _path108, _g63, _path109, _path110, _path111, _g64, _path112, _path113, _path114, _g65, _path115, _path116, _path117, _g66, _path118, _path119, _path120, _g67, _path121, _path122, _path123, _g68, _path124, _path125, _g69, _path126, _path127, _circle2, _path128, _rect35, _path129, _path130, _g70, _path131, _path132, _path133, _g71, _path134, _path135, _path136, _g72, _path137, _path138, _path139, _g73, _path140, _path141, _path142, _g74, _path143, _path144, _path145, _g75, _path146, _path147, _g76, _path148, _path149, _path150, _path151, _path152, _path153, _g77, _path154, _path155, _path156, _g78, _path157, _path158, _path159, _g79, _path160, _path161, _path162, _g80, _path163, _path164, _path165, _g81, _path166, _path167, _path168, _g82, _path169, _path170, _g83, _path171, _path172, _path173, _path174, _rect36, _path175, _path176, _g84, _path177, _path178, _path179, _g85, _path180, _path181, _path182, _g86, _path183, _path184, _path185, _g87, _path186, _path187, _path188, _g88, _path189, _path190, _path191, _g89, _path192, _path193, _g90, _path194, _path195, _path196, _path197, _path198, _path199, _g91, _path200, _path201, _path202, _g92, _path203, _path204, _path205, _g93, _path206, _path207, _path208, _g94, _path209, _path210, _path211, _g95, _path212, _path213, _path214, _g96, _path215, _path216, _g97, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _g98, _path229, _g99, _g100, _g101, _g102, _g103, _g104, _path230, _path231, _g105, _g106, _g107, _g108, _g109, _path232, _path233, _g110, _g111, _g112, _rect37, _path234, _path235, _g113, _path236, _path237, _path238, _g114, _path239, _path240, _path241, _g115, _path242, _path243, _path244, _g116, _path245, _path246, _path247, _g117, _path248, _path249, _path250, _g118, _path251, _path252, _g119, _path253, _path254, _path255, _path256, _path257, _path258, _g120, _path259, _path260, _path261, _g121, _path262, _path263, _path264, _g122, _path265, _path266, _path267, _g123, _path268, _path269, _path270, _g124, _path271, _path272, _path273, _g125, _path274, _path275, _g126, _path276, _path277, _circle3, _path278, _rect38, _path279, _path280, _g127, _path281, _path282, _path283, _g128, _path284, _path285, _path286, _g129, _path287, _path288, _path289, _g130, _path290, _path291, _path292, _g131, _path293, _path294, _path295, _g132, _path296, _path297, _g133, _path298, _path299, _path300, _path301, _path302, _path303, _g134, _path304, _path305, _path306, _g135, _path307, _path308, _path309, _g136, _path310, _path311, _path312, _g137, _path313, _path314, _path315, _g138, _path316, _path317, _path318, _g139, _path319, _path320, _g140, _path321, _path322, _circle4, _path323, _rect39, _path324, _path325, _g141, _path326, _path327, _path328, _g142, _path329, _path330, _path331, _g143, _path332, _path333, _path334, _g144, _path335, _path336, _path337, _g145, _path338, _path339, _path340, _g146, _path341, _path342, _g147, _path343, _path344, _path345, _path346, _path347, _path348, _g148, _path349, _path350, _path351, _g149, _path352, _path353, _path354, _g150, _path355, _path356, _path357, _g151, _path358, _path359, _path360, _g152, _path361, _path362, _path363, _g153, _path364, _path365, _g154, _path366, _path367, _path368, _path369, _rect40, _path370, _path371, _g155, _path372, _path373, _path374, _g156, _path375, _path376, _path377, _g157, _path378, _path379, _path380, _g158, _path381, _path382, _path383, _g159, _path384, _path385, _path386, _g160, _path387, _path388, _g161, _path389, _path390, _path391, _path392, _path393, _path394, _g162, _path395, _path396, _path397, _g163, _path398, _path399, _path400, _g164, _path401, _path402, _path403, _g165, _path404, _path405, _path406, _g166, _path407, _path408, _path409, _g167, _path410, _path411, _g168, _path412, _path413, _path414, _path415, _path416, _path417, _path418;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 852.263,
    height: 387.52,
    viewBox: "0 0 852.263 387.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.525,
    y1: 0.5,
    x2: 1.525,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39b54a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.502,
    y1: 0.612,
    x2: 0.485,
    y2: -0.389,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f44522"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -22.591,
    y1: 0.5,
    x2: 23.591,
    y2: 0.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.516,
    y1: 0.985,
    x2: 0.476,
    y2: -0.235,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    y1: -0.032,
    x2: 0.5,
    y2: 0.876,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -1.545,
    y1: 0.5,
    x2: 2.545,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0071bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -0.276,
    y1: 1.036,
    x2: 0.153,
    y2: 0.479,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -4.298,
    y1: 0.5,
    x2: 5.298,
    y2: 0.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.812,
    y1: 1.2,
    x2: 0.541,
    y2: 0.201,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_898",
    "data-name": "\\uC0AC\\uAC01\\uD615 898",
    width: 3.92,
    height: 6.943,
    transform: "translate(756.961 4112.348)",
    fill: "#e13d0f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11692",
    "data-name": "\\uD328\\uC2A4 11692",
    d: "M1048.045,4354.476l0,2.982a.333.333,0,0,0,.194.271,1.039,1.039,0,0,0,.94,0,.333.333,0,0,0,.2-.275l0-2.982a.335.335,0,0,1-.2.274,1.035,1.035,0,0,1-.941,0A.331.331,0,0,1,1048.045,4354.476Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11697",
    "data-name": "\\uD328\\uC2A4 11697",
    d: "M1046.788,4354.359l0,.5a.954.954,0,0,0,.559.781,2.993,2.993,0,0,0,2.718,0,.962.962,0,0,0,.567-.793v-.5a.962.962,0,0,1-.568.793,2.993,2.993,0,0,1-2.718,0A.956.956,0,0,1,1046.788,4354.359Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11702",
    "data-name": "\\uD328\\uC2A4 11702",
    d: "M1047.119,4353.732v.412a.792.792,0,0,0,.463.647,2.482,2.482,0,0,0,2.251,0,.8.8,0,0,0,.47-.657v-.412a.8.8,0,0,1-.47.656,2.477,2.477,0,0,1-2.251,0A.791.791,0,0,1,1047.119,4353.732Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11707",
    "data-name": "\\uD328\\uC2A4 11707",
    d: "M1046.8,4353.1v.5a.951.951,0,0,0,.557.778,2.98,2.98,0,0,0,2.709,0,.958.958,0,0,0,.566-.79v-.5a.957.957,0,0,1-.566.79,2.98,2.98,0,0,1-2.709,0A.948.948,0,0,1,1046.8,4353.1Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11712",
    "data-name": "\\uD328\\uC2A4 11712",
    d: "M1047.119,4352.58v.412a.792.792,0,0,0,.463.647,2.482,2.482,0,0,0,2.251,0,.8.8,0,0,0,.47-.657v-.412a.8.8,0,0,1-.47.657,2.482,2.482,0,0,1-2.251,0A.792.792,0,0,1,1047.119,4352.58Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11717",
    "data-name": "\\uD328\\uC2A4 11717",
    d: "M1046.815,4351.955l0,.49a.939.939,0,0,0,.551.771,2.95,2.95,0,0,0,2.68,0,.949.949,0,0,0,.56-.782l0-.49a.949.949,0,0,1-.56.782,2.953,2.953,0,0,1-2.68,0A.944.944,0,0,1,1046.815,4351.955Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11721",
    "data-name": "\\uD328\\uC2A4 11721",
    d: "M1048.088,4350.251l-.92,1.513a.767.767,0,0,0,.448.627,2.4,2.4,0,0,0,2.182,0,.772.772,0,0,0,.456-.636l-.931-1.507a.31.31,0,0,1-.182.254.959.959,0,0,1-.873,0A.307.307,0,0,1,1048.088,4350.251Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11725",
    "data-name": "\\uD328\\uC2A4 11725",
    d: "M1048.093,4349.6l0,.651a.308.308,0,0,0,.179.252.963.963,0,0,0,.875,0,.312.312,0,0,0,.183-.255l0-.606a.309.309,0,0,1-.183.255.963.963,0,0,1-.875,0A.367.367,0,0,1,1048.093,4349.6Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11730",
    "data-name": "\\uD328\\uC2A4 11730",
    d: "M1041.869,4358.368l0,2.983a.331.331,0,0,0,.194.27,1.033,1.033,0,0,0,.94,0,.332.332,0,0,0,.2-.274l0-2.983a.335.335,0,0,1-.2.275,1.041,1.041,0,0,1-.941,0A.332.332,0,0,1,1041.869,4358.368Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11735",
    "data-name": "\\uD328\\uC2A4 11735",
    d: "M1040.612,4358.252l0,.5a.954.954,0,0,0,.559.781,3,3,0,0,0,2.718,0,.963.963,0,0,0,.567-.793v-.5a.964.964,0,0,1-.568.793,3,3,0,0,1-2.718,0A.954.954,0,0,1,1040.612,4358.252Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11740",
    "data-name": "\\uD328\\uC2A4 11740",
    d: "M1040.943,4357.624v.413a.792.792,0,0,0,.463.647,2.482,2.482,0,0,0,2.251,0,.8.8,0,0,0,.47-.657v-.412a.8.8,0,0,1-.47.657,2.479,2.479,0,0,1-2.251,0A.789.789,0,0,1,1040.943,4357.624Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11745",
    "data-name": "\\uD328\\uC2A4 11745",
    d: "M1040.619,4357v.5a.951.951,0,0,0,.557.779,2.983,2.983,0,0,0,2.709,0,.959.959,0,0,0,.566-.791v-.5a.961.961,0,0,1-.566.791,2.983,2.983,0,0,1-2.709,0A.951.951,0,0,1,1040.619,4357Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11750",
    "data-name": "\\uD328\\uC2A4 11750",
    d: "M1040.943,4356.473v.412a.792.792,0,0,0,.463.647,2.479,2.479,0,0,0,2.251,0,.8.8,0,0,0,.47-.656v-.412a.8.8,0,0,1-.47.656,2.479,2.479,0,0,1-2.251,0A.792.792,0,0,1,1040.943,4356.473Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11755",
    "data-name": "\\uD328\\uC2A4 11755",
    d: "M1040.639,4355.847l0,.491a.937.937,0,0,0,.551.77,2.95,2.95,0,0,0,2.68,0,.95.95,0,0,0,.56-.782l0-.491a.948.948,0,0,1-.56.782,2.953,2.953,0,0,1-2.68,0A.944.944,0,0,1,1040.639,4355.847Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11759",
    "data-name": "\\uD328\\uC2A4 11759",
    d: "M1041.913,4354.144l-.921,1.512a.769.769,0,0,0,.448.628,2.407,2.407,0,0,0,2.182,0,.775.775,0,0,0,.456-.636l-.931-1.507a.309.309,0,0,1-.182.254.959.959,0,0,1-.873,0A.3.3,0,0,1,1041.913,4354.144Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11763",
    "data-name": "\\uD328\\uC2A4 11763",
    d: "M1041.917,4353.488l0,.651a.306.306,0,0,0,.179.251.966.966,0,0,0,.875,0,.311.311,0,0,0,.183-.255l0-.6a.311.311,0,0,1-.183.255.966.966,0,0,1-.875,0A.369.369,0,0,1,1041.917,4353.488Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11767",
    "data-name": "\\uD328\\uC2A4 11767",
    d: "M1051.883,4356.534l0,2.982a.332.332,0,0,0,.193.271,1.041,1.041,0,0,0,.941,0,.335.335,0,0,0,.2-.275l0-2.982a.332.332,0,0,1-.2.274,1.041,1.041,0,0,1-.941,0A.332.332,0,0,1,1051.883,4356.534Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11772",
    "data-name": "\\uD328\\uC2A4 11772",
    d: "M1050.626,4356.417l0,.5a.951.951,0,0,0,.559.781,2.993,2.993,0,0,0,2.718,0,.961.961,0,0,0,.567-.793v-.5a.963.963,0,0,1-.568.793,3,3,0,0,1-2.718,0A.957.957,0,0,1,1050.626,4356.417Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11777",
    "data-name": "\\uD328\\uC2A4 11777",
    d: "M1050.957,4355.79v.412a.792.792,0,0,0,.463.647,2.479,2.479,0,0,0,2.251,0,.8.8,0,0,0,.47-.656v-.412a.8.8,0,0,1-.471.656,2.477,2.477,0,0,1-2.25,0A.79.79,0,0,1,1050.957,4355.79Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11782",
    "data-name": "\\uD328\\uC2A4 11782",
    d: "M1050.633,4355.162v.5a.95.95,0,0,0,.557.778,2.98,2.98,0,0,0,2.709,0,.957.957,0,0,0,.566-.79v-.5a.96.96,0,0,1-.566.79,2.981,2.981,0,0,1-2.709,0A.947.947,0,0,1,1050.633,4355.162Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11787",
    "data-name": "\\uD328\\uC2A4 11787",
    d: "M1050.957,4354.638v.412a.791.791,0,0,0,.463.647,2.48,2.48,0,0,0,2.251,0,.8.8,0,0,0,.47-.657v-.412a.8.8,0,0,1-.471.657,2.48,2.48,0,0,1-2.25,0A.79.79,0,0,1,1050.957,4354.638Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11792",
    "data-name": "\\uD328\\uC2A4 11792",
    d: "M1050.653,4354.013v.49a.942.942,0,0,0,.552.771,2.95,2.95,0,0,0,2.68,0,.95.95,0,0,0,.56-.782l0-.49a.949.949,0,0,1-.56.782,2.953,2.953,0,0,1-2.68,0A.942.942,0,0,1,1050.653,4354.013Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11796",
    "data-name": "\\uD328\\uC2A4 11796",
    d: "M1051.926,4352.309l-.92,1.513a.765.765,0,0,0,.448.627,2.407,2.407,0,0,0,2.182,0,.776.776,0,0,0,.456-.636l-.931-1.507a.31.31,0,0,1-.182.254.959.959,0,0,1-.873,0A.307.307,0,0,1,1051.926,4352.309Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11800",
    "data-name": "\\uD328\\uC2A4 11800",
    d: "M1051.931,4351.653l0,.651a.312.312,0,0,0,.18.252.966.966,0,0,0,.875,0,.312.312,0,0,0,.183-.256l0-.6a.311.311,0,0,1-.183.255.966.966,0,0,1-.875,0A.368.368,0,0,1,1051.931,4351.653Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11805",
    "data-name": "\\uD328\\uC2A4 11805",
    d: "M1045.707,4360.426l0,2.983a.332.332,0,0,0,.193.27,1.035,1.035,0,0,0,.941,0,.334.334,0,0,0,.2-.274l0-2.983a.331.331,0,0,1-.2.275,1.038,1.038,0,0,1-.941,0A.331.331,0,0,1,1045.707,4360.426Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11810",
    "data-name": "\\uD328\\uC2A4 11810",
    d: "M1044.45,4360.31l0,.5a.955.955,0,0,0,.559.781,2.993,2.993,0,0,0,2.718,0,.962.962,0,0,0,.567-.793v-.5a.962.962,0,0,1-.568.793,2.993,2.993,0,0,1-2.718,0A.954.954,0,0,1,1044.45,4360.31Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11815",
    "data-name": "\\uD328\\uC2A4 11815",
    d: "M1044.781,4359.682v.412a.789.789,0,0,0,.463.647,2.479,2.479,0,0,0,2.251,0,.8.8,0,0,0,.47-.657v-.412a.8.8,0,0,1-.471.657,2.477,2.477,0,0,1-2.25,0A.791.791,0,0,1,1044.781,4359.682Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11820",
    "data-name": "\\uD328\\uC2A4 11820",
    d: "M1044.457,4359.054v.5a.951.951,0,0,0,.557.779,2.983,2.983,0,0,0,2.709,0,.959.959,0,0,0,.566-.791v-.5a.961.961,0,0,1-.566.791,2.983,2.983,0,0,1-2.709,0A.95.95,0,0,1,1044.457,4359.054Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11825",
    "data-name": "\\uD328\\uC2A4 11825",
    d: "M1044.781,4358.531v.412a.791.791,0,0,0,.463.647,2.476,2.476,0,0,0,2.251,0,.8.8,0,0,0,.47-.656v-.412a.8.8,0,0,1-.471.656,2.477,2.477,0,0,1-2.25,0A.792.792,0,0,1,1044.781,4358.531Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11830",
    "data-name": "\\uD328\\uC2A4 11830",
    d: "M1044.477,4357.9l0,.491a.938.938,0,0,0,.551.77,2.95,2.95,0,0,0,2.68,0,.947.947,0,0,0,.559-.782v-.491a.948.948,0,0,1-.56.782,2.95,2.95,0,0,1-2.68,0A.942.942,0,0,1,1044.477,4357.9Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11834",
    "data-name": "\\uD328\\uC2A4 11834",
    d: "M1045.75,4356.2l-.92,1.512a.767.767,0,0,0,.448.628,2.4,2.4,0,0,0,2.182,0,.774.774,0,0,0,.456-.637l-.931-1.507a.31.31,0,0,1-.182.255.962.962,0,0,1-.873,0A.308.308,0,0,1,1045.75,4356.2Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11838",
    "data-name": "\\uD328\\uC2A4 11838",
    d: "M1045.755,4355.546l0,.651a.31.31,0,0,0,.18.251.966.966,0,0,0,.875,0,.311.311,0,0,0,.183-.255l0-.6a.311.311,0,0,1-.183.255.963.963,0,0,1-.875,0A.368.368,0,0,1,1045.755,4355.546Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11842",
    "data-name": "\\uD328\\uC2A4 11842",
    d: "M1015.919,4335.652l0,2.982a.332.332,0,0,0,.194.271,1.038,1.038,0,0,0,.941,0,.333.333,0,0,0,.2-.275l0-2.982a.332.332,0,0,1-.2.274,1.032,1.032,0,0,1-.941,0A.332.332,0,0,1,1015.919,4335.652Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11847",
    "data-name": "\\uD328\\uC2A4 11847",
    d: "M1014.663,4335.535v.5a.954.954,0,0,0,.559.781,2.993,2.993,0,0,0,2.718,0,.964.964,0,0,0,.568-.793l0-.5a.959.959,0,0,1-.568.793,2.99,2.99,0,0,1-2.718,0A.954.954,0,0,1,1014.663,4335.535Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11852",
    "data-name": "\\uD328\\uC2A4 11852",
    d: "M1014.993,4334.908v.412a.791.791,0,0,0,.463.647,2.479,2.479,0,0,0,2.251,0,.8.8,0,0,0,.47-.657v-.412a.8.8,0,0,1-.47.657,2.482,2.482,0,0,1-2.251,0A.792.792,0,0,1,1014.993,4334.908Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11857",
    "data-name": "\\uD328\\uC2A4 11857",
    d: "M1014.669,4334.28v.5a.952.952,0,0,0,.557.778,2.983,2.983,0,0,0,2.709,0,.959.959,0,0,0,.566-.79v-.5a.958.958,0,0,1-.566.79,2.983,2.983,0,0,1-2.709,0A.952.952,0,0,1,1014.669,4334.28Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11862",
    "data-name": "\\uD328\\uC2A4 11862",
    d: "M1014.993,4333.756v.412a.791.791,0,0,0,.463.647,2.479,2.479,0,0,0,2.251,0,.8.8,0,0,0,.47-.657v-.412a.8.8,0,0,1-.47.657,2.479,2.479,0,0,1-2.251,0A.791.791,0,0,1,1014.993,4333.756Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11867",
    "data-name": "\\uD328\\uC2A4 11867",
    d: "M1014.689,4333.131l0,.49a.942.942,0,0,0,.551.771,2.953,2.953,0,0,0,2.68,0,.948.948,0,0,0,.56-.781l0-.491a.949.949,0,0,1-.559.782,2.952,2.952,0,0,1-2.681,0A.943.943,0,0,1,1014.689,4333.131Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11871",
    "data-name": "\\uD328\\uC2A4 11871",
    d: "M1015.963,4331.427l-.921,1.513a.766.766,0,0,0,.448.627,2.406,2.406,0,0,0,2.183,0,.77.77,0,0,0,.455-.636l-.931-1.507a.31.31,0,0,1-.182.254.962.962,0,0,1-.873,0A.306.306,0,0,1,1015.963,4331.427Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11875",
    "data-name": "\\uD328\\uC2A4 11875",
    d: "M1015.967,4330.771l0,.651a.308.308,0,0,0,.179.252.965.965,0,0,0,.876,0,.311.311,0,0,0,.182-.255l0-.606a.31.31,0,0,1-.183.255.963.963,0,0,1-.875,0A.367.367,0,0,1,1015.967,4330.771Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11880",
    "data-name": "\\uD328\\uC2A4 11880",
    d: "M1009.743,4339.544l0,2.983a.326.326,0,0,0,.193.27,1.032,1.032,0,0,0,.941,0,.332.332,0,0,0,.2-.274l0-2.983a.335.335,0,0,1-.2.275,1.039,1.039,0,0,1-.94,0A.33.33,0,0,1,1009.743,4339.544Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11885",
    "data-name": "\\uD328\\uC2A4 11885",
    d: "M1008.487,4339.428v.5a.955.955,0,0,0,.559.781,2.993,2.993,0,0,0,2.718,0,.965.965,0,0,0,.568-.793l0-.5a.96.96,0,0,1-.568.793,2.993,2.993,0,0,1-2.718,0A.95.95,0,0,1,1008.487,4339.428Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11890",
    "data-name": "\\uD328\\uC2A4 11890",
    d: "M1008.817,4338.8v.413a.791.791,0,0,0,.463.647,2.479,2.479,0,0,0,2.251,0,.8.8,0,0,0,.47-.657v-.412a.8.8,0,0,1-.47.657,2.482,2.482,0,0,1-2.251,0A.792.792,0,0,1,1008.817,4338.8Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11895",
    "data-name": "\\uD328\\uC2A4 11895",
    d: "M1008.493,4338.172v.5a.952.952,0,0,0,.557.779,2.985,2.985,0,0,0,2.709,0,.96.96,0,0,0,.566-.791v-.5a.96.96,0,0,1-.566.791,2.986,2.986,0,0,1-2.709,0A.951.951,0,0,1,1008.493,4338.172Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11900",
    "data-name": "\\uD328\\uC2A4 11900",
    d: "M1008.817,4337.649v.412a.792.792,0,0,0,.463.647,2.479,2.479,0,0,0,2.251,0,.8.8,0,0,0,.47-.656v-.412a.8.8,0,0,1-.47.656,2.477,2.477,0,0,1-2.251,0A.791.791,0,0,1,1008.817,4337.649Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11905",
    "data-name": "\\uD328\\uC2A4 11905",
    d: "M1008.513,4337.023l0,.491a.941.941,0,0,0,.551.77,2.953,2.953,0,0,0,2.68,0,.949.949,0,0,0,.56-.782l0-.491a.948.948,0,0,1-.559.782,2.952,2.952,0,0,1-2.681,0A.943.943,0,0,1,1008.513,4337.023Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11909",
    "data-name": "\\uD328\\uC2A4 11909",
    d: "M1009.787,4335.32l-.921,1.512a.767.767,0,0,0,.448.628,2.406,2.406,0,0,0,2.183,0,.771.771,0,0,0,.455-.636l-.931-1.507a.309.309,0,0,1-.182.254.959.959,0,0,1-.873,0A.3.3,0,0,1,1009.787,4335.32Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11913",
    "data-name": "\\uD328\\uC2A4 11913",
    d: "M1009.791,4334.664l0,.651a.3.3,0,0,0,.18.251.963.963,0,0,0,.875,0,.308.308,0,0,0,.182-.255l0-.6a.31.31,0,0,1-.183.255.963.963,0,0,1-.875,0A.367.367,0,0,1,1009.791,4334.664Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11918",
    "data-name": "\\uD328\\uC2A4 11918",
    d: "M1019.757,4337.709l0,2.983a.332.332,0,0,0,.194.271,1.039,1.039,0,0,0,.94,0,.332.332,0,0,0,.2-.275l0-2.982a.335.335,0,0,1-.2.274,1.035,1.035,0,0,1-.941,0A.332.332,0,0,1,1019.757,4337.709Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11923",
    "data-name": "\\uD328\\uC2A4 11923",
    d: "M1018.5,4337.593l0,.5a.954.954,0,0,0,.559.781,2.993,2.993,0,0,0,2.718,0,.965.965,0,0,0,.568-.793l0-.5a.961.961,0,0,1-.568.793,2.993,2.993,0,0,1-2.718,0A.955.955,0,0,1,1018.5,4337.593Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11928",
    "data-name": "\\uD328\\uC2A4 11928",
    d: "M1018.831,4336.966v.412a.791.791,0,0,0,.463.647,2.48,2.48,0,0,0,2.251,0,.8.8,0,0,0,.47-.657v-.412a.8.8,0,0,1-.47.656,2.476,2.476,0,0,1-2.251,0A.791.791,0,0,1,1018.831,4336.966Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11933",
    "data-name": "\\uD328\\uC2A4 11933",
    d: "M1018.507,4336.338v.5a.951.951,0,0,0,.557.778,2.98,2.98,0,0,0,2.709,0,.958.958,0,0,0,.566-.79v-.5a.959.959,0,0,1-.566.79,2.983,2.983,0,0,1-2.709,0A.95.95,0,0,1,1018.507,4336.338Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11938",
    "data-name": "\\uD328\\uC2A4 11938",
    d: "M1018.831,4335.814v.412a.792.792,0,0,0,.463.647,2.482,2.482,0,0,0,2.251,0,.8.8,0,0,0,.47-.657v-.412a.8.8,0,0,1-.47.657,2.482,2.482,0,0,1-2.251,0A.791.791,0,0,1,1018.831,4335.814Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11943",
    "data-name": "\\uD328\\uC2A4 11943",
    d: "M1018.527,4335.189l0,.49a.94.94,0,0,0,.551.771,2.953,2.953,0,0,0,2.68,0,.948.948,0,0,0,.56-.782l0-.49a.948.948,0,0,1-.56.782,2.95,2.95,0,0,1-2.68,0A.943.943,0,0,1,1018.527,4335.189Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11947",
    "data-name": "\\uD328\\uC2A4 11947",
    d: "M1019.8,4333.485l-.921,1.513a.766.766,0,0,0,.448.627,2.4,2.4,0,0,0,2.182,0,.769.769,0,0,0,.456-.636l-.931-1.507a.309.309,0,0,1-.182.254.959.959,0,0,1-.873,0A.3.3,0,0,1,1019.8,4333.485Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11951",
    "data-name": "\\uD328\\uC2A4 11951",
    d: "M1019.8,4332.829l0,.651a.308.308,0,0,0,.179.252.963.963,0,0,0,.875,0,.311.311,0,0,0,.183-.255l0-.606a.31.31,0,0,1-.183.255.963.963,0,0,1-.875,0A.367.367,0,0,1,1019.8,4332.829Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11956",
    "data-name": "\\uD328\\uC2A4 11956",
    d: "M1013.581,4341.6l0,2.983a.33.33,0,0,0,.194.27,1.033,1.033,0,0,0,.94,0,.332.332,0,0,0,.2-.274l0-2.983a.335.335,0,0,1-.2.275,1.041,1.041,0,0,1-.941,0A.332.332,0,0,1,1013.581,4341.6Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11961",
    "data-name": "\\uD328\\uC2A4 11961",
    d: "M1012.324,4341.486l0,.5a.956.956,0,0,0,.559.781,2.993,2.993,0,0,0,2.718,0,.967.967,0,0,0,.568-.793l0-.5a.961.961,0,0,1-.568.793,2.993,2.993,0,0,1-2.718,0A.955.955,0,0,1,1012.324,4341.486Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11966",
    "data-name": "\\uD328\\uC2A4 11966",
    d: "M1012.655,4340.858v.412a.792.792,0,0,0,.463.648,2.482,2.482,0,0,0,2.251,0,.8.8,0,0,0,.47-.657v-.412a.8.8,0,0,1-.47.657,2.476,2.476,0,0,1-2.251,0A.79.79,0,0,1,1012.655,4340.858Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11971",
    "data-name": "\\uD328\\uC2A4 11971",
    d: "M1012.331,4340.23v.5a.953.953,0,0,0,.557.779,2.984,2.984,0,0,0,2.709,0,.959.959,0,0,0,.566-.791v-.5a.961.961,0,0,1-.566.791,2.983,2.983,0,0,1-2.709,0A.95.95,0,0,1,1012.331,4340.23Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11976",
    "data-name": "\\uD328\\uC2A4 11976",
    d: "M1012.655,4339.707v.412a.792.792,0,0,0,.463.647,2.479,2.479,0,0,0,2.251,0,.8.8,0,0,0,.47-.656v-.412a.8.8,0,0,1-.47.656,2.479,2.479,0,0,1-2.251,0A.792.792,0,0,1,1012.655,4339.707Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11981",
    "data-name": "\\uD328\\uC2A4 11981",
    d: "M1012.351,4339.081l0,.491a.937.937,0,0,0,.551.77,2.95,2.95,0,0,0,2.68,0,.95.95,0,0,0,.56-.782l0-.491a.948.948,0,0,1-.559.782,2.955,2.955,0,0,1-2.681,0A.945.945,0,0,1,1012.351,4339.081Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11985",
    "data-name": "\\uD328\\uC2A4 11985",
    d: "M1013.625,4337.378l-.921,1.512a.767.767,0,0,0,.448.628,2.4,2.4,0,0,0,2.182,0,.773.773,0,0,0,.456-.636l-.931-1.508a.31.31,0,0,1-.182.255.959.959,0,0,1-.873,0A.3.3,0,0,1,1013.625,4337.378Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11989",
    "data-name": "\\uD328\\uC2A4 11989",
    d: "M1013.629,4336.722l0,.651a.306.306,0,0,0,.179.251.963.963,0,0,0,.875,0,.31.31,0,0,0,.183-.255l0-.6a.31.31,0,0,1-.183.255.963.963,0,0,1-.875,0A.368.368,0,0,1,1013.629,4336.722Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12022",
    "data-name": "\\uD328\\uC2A4 12022",
    d: "M1089.045,4354.476l0,2.982a.333.333,0,0,0,.194.271,1.039,1.039,0,0,0,.94,0,.333.333,0,0,0,.2-.275l0-2.982a.335.335,0,0,1-.2.274,1.035,1.035,0,0,1-.941,0A.331.331,0,0,1,1089.045,4354.476Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12027",
    "data-name": "\\uD328\\uC2A4 12027",
    d: "M1087.788,4354.359l0,.5a.954.954,0,0,0,.559.781,2.993,2.993,0,0,0,2.718,0,.962.962,0,0,0,.567-.793v-.5a.962.962,0,0,1-.568.793,2.993,2.993,0,0,1-2.718,0A.956.956,0,0,1,1087.788,4354.359Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12032",
    "data-name": "\\uD328\\uC2A4 12032",
    d: "M1088.119,4353.732v.412a.792.792,0,0,0,.463.647,2.482,2.482,0,0,0,2.251,0,.8.8,0,0,0,.47-.657v-.412a.8.8,0,0,1-.47.656,2.477,2.477,0,0,1-2.251,0A.791.791,0,0,1,1088.119,4353.732Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12037",
    "data-name": "\\uD328\\uC2A4 12037",
    d: "M1087.8,4353.1v.5a.951.951,0,0,0,.557.778,2.98,2.98,0,0,0,2.709,0,.958.958,0,0,0,.566-.79v-.5a.957.957,0,0,1-.566.79,2.98,2.98,0,0,1-2.709,0A.948.948,0,0,1,1087.8,4353.1Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12042",
    "data-name": "\\uD328\\uC2A4 12042",
    d: "M1088.119,4352.58v.412a.792.792,0,0,0,.463.647,2.482,2.482,0,0,0,2.251,0,.8.8,0,0,0,.47-.657v-.412a.8.8,0,0,1-.47.657,2.482,2.482,0,0,1-2.251,0A.792.792,0,0,1,1088.119,4352.58Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12047",
    "data-name": "\\uD328\\uC2A4 12047",
    d: "M1087.815,4351.955l0,.49a.939.939,0,0,0,.551.771,2.95,2.95,0,0,0,2.68,0,.949.949,0,0,0,.56-.782l0-.49a.949.949,0,0,1-.56.782,2.953,2.953,0,0,1-2.68,0A.944.944,0,0,1,1087.815,4351.955Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12051",
    "data-name": "\\uD328\\uC2A4 12051",
    d: "M1089.088,4350.251l-.92,1.513a.767.767,0,0,0,.448.627,2.4,2.4,0,0,0,2.182,0,.772.772,0,0,0,.456-.636l-.931-1.507a.31.31,0,0,1-.182.254.959.959,0,0,1-.873,0A.307.307,0,0,1,1089.088,4350.251Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12055",
    "data-name": "\\uD328\\uC2A4 12055",
    d: "M1089.093,4349.6l0,.651a.308.308,0,0,0,.179.252.963.963,0,0,0,.875,0,.312.312,0,0,0,.183-.255l0-.606a.309.309,0,0,1-.183.255.963.963,0,0,1-.875,0A.367.367,0,0,1,1089.093,4349.6Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12060",
    "data-name": "\\uD328\\uC2A4 12060",
    d: "M1082.869,4358.368l0,2.983a.331.331,0,0,0,.194.27,1.033,1.033,0,0,0,.94,0,.332.332,0,0,0,.2-.274l0-2.983a.335.335,0,0,1-.2.275,1.041,1.041,0,0,1-.941,0A.332.332,0,0,1,1082.869,4358.368Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12065",
    "data-name": "\\uD328\\uC2A4 12065",
    d: "M1081.612,4358.252l0,.5a.954.954,0,0,0,.559.781,3,3,0,0,0,2.718,0,.963.963,0,0,0,.567-.793v-.5a.964.964,0,0,1-.568.793,3,3,0,0,1-2.718,0A.954.954,0,0,1,1081.612,4358.252Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12070",
    "data-name": "\\uD328\\uC2A4 12070",
    d: "M1081.943,4357.624v.413a.792.792,0,0,0,.463.647,2.482,2.482,0,0,0,2.251,0,.8.8,0,0,0,.47-.657v-.412a.8.8,0,0,1-.47.657,2.479,2.479,0,0,1-2.251,0A.789.789,0,0,1,1081.943,4357.624Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12075",
    "data-name": "\\uD328\\uC2A4 12075",
    d: "M1081.619,4357v.5a.951.951,0,0,0,.557.779,2.983,2.983,0,0,0,2.709,0,.959.959,0,0,0,.566-.791v-.5a.961.961,0,0,1-.566.791,2.983,2.983,0,0,1-2.709,0A.951.951,0,0,1,1081.619,4357Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12080",
    "data-name": "\\uD328\\uC2A4 12080",
    d: "M1081.943,4356.473v.412a.792.792,0,0,0,.463.647,2.479,2.479,0,0,0,2.251,0,.8.8,0,0,0,.47-.656v-.412a.8.8,0,0,1-.47.656,2.479,2.479,0,0,1-2.251,0A.792.792,0,0,1,1081.943,4356.473Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12085",
    "data-name": "\\uD328\\uC2A4 12085",
    d: "M1081.639,4355.847l0,.491a.937.937,0,0,0,.551.77,2.95,2.95,0,0,0,2.68,0,.95.95,0,0,0,.56-.782l0-.491a.948.948,0,0,1-.56.782,2.953,2.953,0,0,1-2.68,0A.944.944,0,0,1,1081.639,4355.847Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12089",
    "data-name": "\\uD328\\uC2A4 12089",
    d: "M1082.913,4354.144l-.921,1.512a.769.769,0,0,0,.448.628,2.407,2.407,0,0,0,2.182,0,.775.775,0,0,0,.456-.636l-.931-1.507a.309.309,0,0,1-.182.254.959.959,0,0,1-.873,0A.3.3,0,0,1,1082.913,4354.144Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12093",
    "data-name": "\\uD328\\uC2A4 12093",
    d: "M1082.917,4353.488l0,.651a.306.306,0,0,0,.179.251.966.966,0,0,0,.875,0,.311.311,0,0,0,.183-.255l0-.6a.311.311,0,0,1-.183.255.966.966,0,0,1-.875,0A.369.369,0,0,1,1082.917,4353.488Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12097",
    "data-name": "\\uD328\\uC2A4 12097",
    d: "M1092.883,4356.534l0,2.982a.332.332,0,0,0,.193.271,1.041,1.041,0,0,0,.941,0,.335.335,0,0,0,.2-.275l0-2.982a.332.332,0,0,1-.2.274,1.041,1.041,0,0,1-.941,0A.332.332,0,0,1,1092.883,4356.534Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12102",
    "data-name": "\\uD328\\uC2A4 12102",
    d: "M1091.626,4356.417l0,.5a.951.951,0,0,0,.559.781,2.993,2.993,0,0,0,2.718,0,.961.961,0,0,0,.567-.793v-.5a.963.963,0,0,1-.568.793,3,3,0,0,1-2.718,0A.957.957,0,0,1,1091.626,4356.417Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12107",
    "data-name": "\\uD328\\uC2A4 12107",
    d: "M1091.957,4355.79v.412a.792.792,0,0,0,.463.647,2.479,2.479,0,0,0,2.251,0,.8.8,0,0,0,.47-.656v-.412a.8.8,0,0,1-.471.656,2.477,2.477,0,0,1-2.25,0A.79.79,0,0,1,1091.957,4355.79Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12112",
    "data-name": "\\uD328\\uC2A4 12112",
    d: "M1091.633,4355.162v.5a.95.95,0,0,0,.557.778,2.98,2.98,0,0,0,2.709,0,.957.957,0,0,0,.566-.79v-.5a.96.96,0,0,1-.566.79,2.981,2.981,0,0,1-2.709,0A.947.947,0,0,1,1091.633,4355.162Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12117",
    "data-name": "\\uD328\\uC2A4 12117",
    d: "M1091.957,4354.638v.412a.791.791,0,0,0,.463.647,2.48,2.48,0,0,0,2.251,0,.8.8,0,0,0,.47-.657v-.412a.8.8,0,0,1-.471.657,2.48,2.48,0,0,1-2.25,0A.79.79,0,0,1,1091.957,4354.638Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12122",
    "data-name": "\\uD328\\uC2A4 12122",
    d: "M1091.653,4354.013v.49a.942.942,0,0,0,.552.771,2.95,2.95,0,0,0,2.68,0,.95.95,0,0,0,.56-.782l0-.49a.949.949,0,0,1-.56.782,2.953,2.953,0,0,1-2.68,0A.942.942,0,0,1,1091.653,4354.013Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12126",
    "data-name": "\\uD328\\uC2A4 12126",
    d: "M1092.926,4352.309l-.92,1.513a.765.765,0,0,0,.448.627,2.407,2.407,0,0,0,2.182,0,.776.776,0,0,0,.456-.636l-.931-1.507a.31.31,0,0,1-.182.254.959.959,0,0,1-.873,0A.307.307,0,0,1,1092.926,4352.309Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12130",
    "data-name": "\\uD328\\uC2A4 12130",
    d: "M1092.931,4351.653l0,.651a.312.312,0,0,0,.18.252.966.966,0,0,0,.875,0,.312.312,0,0,0,.183-.256l0-.6a.311.311,0,0,1-.183.255.966.966,0,0,1-.875,0A.368.368,0,0,1,1092.931,4351.653Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12135",
    "data-name": "\\uD328\\uC2A4 12135",
    d: "M1086.707,4360.426l0,2.983a.332.332,0,0,0,.193.27,1.035,1.035,0,0,0,.941,0,.334.334,0,0,0,.2-.274l0-2.983a.331.331,0,0,1-.2.275,1.038,1.038,0,0,1-.941,0A.331.331,0,0,1,1086.707,4360.426Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12140",
    "data-name": "\\uD328\\uC2A4 12140",
    d: "M1085.45,4360.31l0,.5a.955.955,0,0,0,.559.781,2.993,2.993,0,0,0,2.718,0,.962.962,0,0,0,.567-.793v-.5a.962.962,0,0,1-.568.793,2.993,2.993,0,0,1-2.718,0A.954.954,0,0,1,1085.45,4360.31Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12145",
    "data-name": "\\uD328\\uC2A4 12145",
    d: "M1085.781,4359.682v.412a.789.789,0,0,0,.463.647,2.479,2.479,0,0,0,2.251,0,.8.8,0,0,0,.47-.657v-.412a.8.8,0,0,1-.471.657,2.477,2.477,0,0,1-2.25,0A.791.791,0,0,1,1085.781,4359.682Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12150",
    "data-name": "\\uD328\\uC2A4 12150",
    d: "M1085.457,4359.054v.5a.951.951,0,0,0,.557.779,2.983,2.983,0,0,0,2.709,0,.959.959,0,0,0,.566-.791v-.5a.961.961,0,0,1-.566.791,2.983,2.983,0,0,1-2.709,0A.95.95,0,0,1,1085.457,4359.054Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12155",
    "data-name": "\\uD328\\uC2A4 12155",
    d: "M1085.781,4358.531v.412a.791.791,0,0,0,.463.647,2.476,2.476,0,0,0,2.251,0,.8.8,0,0,0,.47-.656v-.412a.8.8,0,0,1-.471.656,2.477,2.477,0,0,1-2.25,0A.792.792,0,0,1,1085.781,4358.531Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-95"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12160",
    "data-name": "\\uD328\\uC2A4 12160",
    d: "M1085.477,4357.9l0,.491a.938.938,0,0,0,.551.77,2.95,2.95,0,0,0,2.68,0,.947.947,0,0,0,.559-.782v-.491a.948.948,0,0,1-.56.782,2.95,2.95,0,0,1-2.68,0A.942.942,0,0,1,1085.477,4357.9Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12164",
    "data-name": "\\uD328\\uC2A4 12164",
    d: "M1086.75,4356.2l-.92,1.512a.767.767,0,0,0,.448.628,2.4,2.4,0,0,0,2.182,0,.774.774,0,0,0,.456-.637l-.931-1.507a.31.31,0,0,1-.182.255.962.962,0,0,1-.873,0A.308.308,0,0,1,1086.75,4356.2Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12168",
    "data-name": "\\uD328\\uC2A4 12168",
    d: "M1086.755,4355.546l0,.651a.31.31,0,0,0,.18.251.966.966,0,0,0,.875,0,.311.311,0,0,0,.183-.255l0-.6a.311.311,0,0,1-.183.255.963.963,0,0,1-.875,0A.368.368,0,0,1,1086.755,4355.546Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12172",
    "data-name": "\\uD328\\uC2A4 12172",
    d: "M1056.919,4335.652l0,2.982a.332.332,0,0,0,.194.271,1.038,1.038,0,0,0,.941,0,.333.333,0,0,0,.2-.275l0-2.982a.332.332,0,0,1-.2.274,1.032,1.032,0,0,1-.941,0A.332.332,0,0,1,1056.919,4335.652Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12177",
    "data-name": "\\uD328\\uC2A4 12177",
    d: "M1055.663,4335.535v.5a.954.954,0,0,0,.559.781,2.993,2.993,0,0,0,2.718,0,.964.964,0,0,0,.568-.793l0-.5a.959.959,0,0,1-.568.793,2.99,2.99,0,0,1-2.718,0A.954.954,0,0,1,1055.663,4335.535Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12182",
    "data-name": "\\uD328\\uC2A4 12182",
    d: "M1055.993,4334.908v.412a.791.791,0,0,0,.463.647,2.479,2.479,0,0,0,2.251,0,.8.8,0,0,0,.47-.657v-.412a.8.8,0,0,1-.47.657,2.482,2.482,0,0,1-2.251,0A.792.792,0,0,1,1055.993,4334.908Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12187",
    "data-name": "\\uD328\\uC2A4 12187",
    d: "M1055.669,4334.28v.5a.952.952,0,0,0,.557.778,2.983,2.983,0,0,0,2.709,0,.959.959,0,0,0,.566-.79v-.5a.958.958,0,0,1-.566.79,2.984,2.984,0,0,1-2.709,0A.953.953,0,0,1,1055.669,4334.28Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12192",
    "data-name": "\\uD328\\uC2A4 12192",
    d: "M1055.993,4333.756v.412a.791.791,0,0,0,.463.647,2.479,2.479,0,0,0,2.251,0,.8.8,0,0,0,.47-.657v-.412a.8.8,0,0,1-.47.657,2.479,2.479,0,0,1-2.251,0A.79.79,0,0,1,1055.993,4333.756Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12197",
    "data-name": "\\uD328\\uC2A4 12197",
    d: "M1055.689,4333.131l0,.49a.941.941,0,0,0,.551.771,2.953,2.953,0,0,0,2.68,0,.948.948,0,0,0,.56-.781l0-.491a.949.949,0,0,1-.559.782,2.952,2.952,0,0,1-2.681,0A.943.943,0,0,1,1055.689,4333.131Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12201",
    "data-name": "\\uD328\\uC2A4 12201",
    d: "M1056.963,4331.427l-.921,1.513a.766.766,0,0,0,.448.627,2.406,2.406,0,0,0,2.183,0,.77.77,0,0,0,.455-.636l-.931-1.507a.31.31,0,0,1-.182.254.962.962,0,0,1-.873,0A.306.306,0,0,1,1056.963,4331.427Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12205",
    "data-name": "\\uD328\\uC2A4 12205",
    d: "M1056.967,4330.771l0,.651a.308.308,0,0,0,.179.252.965.965,0,0,0,.876,0,.311.311,0,0,0,.182-.255l0-.606a.31.31,0,0,1-.183.255.963.963,0,0,1-.875,0A.367.367,0,0,1,1056.967,4330.771Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12210",
    "data-name": "\\uD328\\uC2A4 12210",
    d: "M1050.743,4339.544l0,2.983a.327.327,0,0,0,.193.27,1.032,1.032,0,0,0,.941,0,.332.332,0,0,0,.2-.274l0-2.983a.335.335,0,0,1-.2.275,1.039,1.039,0,0,1-.94,0A.33.33,0,0,1,1050.743,4339.544Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12215",
    "data-name": "\\uD328\\uC2A4 12215",
    d: "M1049.487,4339.428v.5a.955.955,0,0,0,.559.781,2.993,2.993,0,0,0,2.718,0,.965.965,0,0,0,.568-.793l0-.5a.96.96,0,0,1-.568.793,2.993,2.993,0,0,1-2.718,0A.95.95,0,0,1,1049.487,4339.428Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12220",
    "data-name": "\\uD328\\uC2A4 12220",
    d: "M1049.817,4338.8v.413a.791.791,0,0,0,.463.647,2.479,2.479,0,0,0,2.251,0,.8.8,0,0,0,.47-.657v-.412a.8.8,0,0,1-.47.657,2.482,2.482,0,0,1-2.251,0A.792.792,0,0,1,1049.817,4338.8Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12225",
    "data-name": "\\uD328\\uC2A4 12225",
    d: "M1049.493,4338.172v.5a.952.952,0,0,0,.557.779,2.985,2.985,0,0,0,2.709,0,.96.96,0,0,0,.566-.791v-.5a.96.96,0,0,1-.566.791,2.986,2.986,0,0,1-2.709,0A.951.951,0,0,1,1049.493,4338.172Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12230",
    "data-name": "\\uD328\\uC2A4 12230",
    d: "M1049.817,4337.649v.412a.792.792,0,0,0,.463.647,2.479,2.479,0,0,0,2.251,0,.8.8,0,0,0,.47-.656v-.412a.8.8,0,0,1-.47.656,2.477,2.477,0,0,1-2.251,0A.791.791,0,0,1,1049.817,4337.649Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12235",
    "data-name": "\\uD328\\uC2A4 12235",
    d: "M1049.513,4337.023l0,.491a.941.941,0,0,0,.551.77,2.953,2.953,0,0,0,2.68,0,.949.949,0,0,0,.56-.782l0-.491a.947.947,0,0,1-.559.782,2.952,2.952,0,0,1-2.681,0A.944.944,0,0,1,1049.513,4337.023Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12239",
    "data-name": "\\uD328\\uC2A4 12239",
    d: "M1050.787,4335.32l-.921,1.512a.767.767,0,0,0,.448.628,2.406,2.406,0,0,0,2.183,0,.771.771,0,0,0,.455-.636l-.931-1.507a.309.309,0,0,1-.182.254.959.959,0,0,1-.873,0A.305.305,0,0,1,1050.787,4335.32Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12243",
    "data-name": "\\uD328\\uC2A4 12243",
    d: "M1050.791,4334.664l0,.651a.305.305,0,0,0,.18.251.963.963,0,0,0,.875,0,.308.308,0,0,0,.182-.255l0-.6a.31.31,0,0,1-.183.255.963.963,0,0,1-.875,0A.367.367,0,0,1,1050.791,4334.664Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12248",
    "data-name": "\\uD328\\uC2A4 12248",
    d: "M1060.757,4337.709l0,2.983a.332.332,0,0,0,.194.271,1.039,1.039,0,0,0,.94,0,.332.332,0,0,0,.2-.275l0-2.982a.335.335,0,0,1-.2.274,1.035,1.035,0,0,1-.941,0A.332.332,0,0,1,1060.757,4337.709Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-115"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12253",
    "data-name": "\\uD328\\uC2A4 12253",
    d: "M1059.5,4337.593l0,.5a.955.955,0,0,0,.559.781,2.993,2.993,0,0,0,2.718,0,.965.965,0,0,0,.568-.793l0-.5a.961.961,0,0,1-.568.793,2.993,2.993,0,0,1-2.718,0A.955.955,0,0,1,1059.5,4337.593Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12258",
    "data-name": "\\uD328\\uC2A4 12258",
    d: "M1059.831,4336.966v.412a.791.791,0,0,0,.463.647,2.48,2.48,0,0,0,2.251,0,.8.8,0,0,0,.47-.657v-.412a.8.8,0,0,1-.47.656,2.476,2.476,0,0,1-2.251,0A.79.79,0,0,1,1059.831,4336.966Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12263",
    "data-name": "\\uD328\\uC2A4 12263",
    d: "M1059.507,4336.338v.5a.95.95,0,0,0,.557.778,2.981,2.981,0,0,0,2.709,0,.958.958,0,0,0,.566-.79v-.5a.959.959,0,0,1-.566.79,2.983,2.983,0,0,1-2.709,0A.95.95,0,0,1,1059.507,4336.338Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12268",
    "data-name": "\\uD328\\uC2A4 12268",
    d: "M1059.831,4335.814v.412a.792.792,0,0,0,.463.647,2.482,2.482,0,0,0,2.251,0,.8.8,0,0,0,.47-.657v-.412a.8.8,0,0,1-.47.657,2.482,2.482,0,0,1-2.251,0A.791.791,0,0,1,1059.831,4335.814Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12273",
    "data-name": "\\uD328\\uC2A4 12273",
    d: "M1059.527,4335.189l0,.49a.94.94,0,0,0,.551.771,2.953,2.953,0,0,0,2.68,0,.947.947,0,0,0,.56-.782l0-.49a.948.948,0,0,1-.56.782,2.95,2.95,0,0,1-2.68,0A.943.943,0,0,1,1059.527,4335.189Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12277",
    "data-name": "\\uD328\\uC2A4 12277",
    d: "M1060.8,4333.485l-.921,1.513a.766.766,0,0,0,.448.627,2.4,2.4,0,0,0,2.182,0,.769.769,0,0,0,.456-.636l-.931-1.507a.309.309,0,0,1-.182.254.959.959,0,0,1-.873,0A.3.3,0,0,1,1060.8,4333.485Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12281",
    "data-name": "\\uD328\\uC2A4 12281",
    d: "M1060.805,4332.829l0,.651a.308.308,0,0,0,.179.252.963.963,0,0,0,.875,0,.311.311,0,0,0,.183-.255l0-.606a.31.31,0,0,1-.183.255.963.963,0,0,1-.875,0A.367.367,0,0,1,1060.805,4332.829Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12286",
    "data-name": "\\uD328\\uC2A4 12286",
    d: "M1054.581,4341.6l0,2.983a.33.33,0,0,0,.194.27,1.033,1.033,0,0,0,.94,0,.331.331,0,0,0,.2-.274l0-2.983a.335.335,0,0,1-.2.275,1.041,1.041,0,0,1-.941,0A.331.331,0,0,1,1054.581,4341.6Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12291",
    "data-name": "\\uD328\\uC2A4 12291",
    d: "M1053.324,4341.486l0,.5a.955.955,0,0,0,.559.781,2.993,2.993,0,0,0,2.718,0,.966.966,0,0,0,.568-.793l0-.5a.96.96,0,0,1-.568.793,2.993,2.993,0,0,1-2.718,0A.954.954,0,0,1,1053.324,4341.486Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12296",
    "data-name": "\\uD328\\uC2A4 12296",
    d: "M1053.655,4340.858v.412a.792.792,0,0,0,.463.648,2.482,2.482,0,0,0,2.251,0,.8.8,0,0,0,.47-.657v-.412a.8.8,0,0,1-.47.657,2.476,2.476,0,0,1-2.251,0A.79.79,0,0,1,1053.655,4340.858Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12301",
    "data-name": "\\uD328\\uC2A4 12301",
    d: "M1053.331,4340.23v.5a.953.953,0,0,0,.557.779,2.983,2.983,0,0,0,2.709,0,.959.959,0,0,0,.566-.791v-.5a.961.961,0,0,1-.566.791,2.984,2.984,0,0,1-2.709,0A.95.95,0,0,1,1053.331,4340.23Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12306",
    "data-name": "\\uD328\\uC2A4 12306",
    d: "M1053.655,4339.707v.412a.792.792,0,0,0,.463.647,2.479,2.479,0,0,0,2.251,0,.8.8,0,0,0,.47-.656v-.412a.8.8,0,0,1-.47.656,2.479,2.479,0,0,1-2.251,0A.792.792,0,0,1,1053.655,4339.707Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12311",
    "data-name": "\\uD328\\uC2A4 12311",
    d: "M1053.351,4339.081l0,.491a.937.937,0,0,0,.551.77,2.95,2.95,0,0,0,2.68,0,.95.95,0,0,0,.56-.782l0-.491a.948.948,0,0,1-.559.782,2.955,2.955,0,0,1-2.681,0A.945.945,0,0,1,1053.351,4339.081Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12315",
    "data-name": "\\uD328\\uC2A4 12315",
    d: "M1054.625,4337.378l-.921,1.512a.767.767,0,0,0,.448.628,2.4,2.4,0,0,0,2.182,0,.773.773,0,0,0,.456-.636l-.931-1.508a.31.31,0,0,1-.182.255.959.959,0,0,1-.873,0A.305.305,0,0,1,1054.625,4337.378Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12319",
    "data-name": "\\uD328\\uC2A4 12319",
    d: "M1054.629,4336.722l0,.651a.306.306,0,0,0,.179.251.963.963,0,0,0,.875,0,.31.31,0,0,0,.183-.255l0-.6a.31.31,0,0,1-.183.255.963.963,0,0,1-.875,0A.369.369,0,0,1,1054.629,4336.722Z",
    fill: "#e4e6f0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8542",
    "data-name": "\\uADF8\\uB8F9 8542",
    transform: "translate(-254.201 -605.266)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_796",
    "data-name": "\\uC0AC\\uAC01\\uD615 796",
    width: 11,
    height: 22.553,
    transform: "translate(798.688 676.29) rotate(90)",
    fill: "url(#linear-gradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_797",
    "data-name": "\\uC0AC\\uAC01\\uD615 797",
    width: 11,
    height: 43,
    transform: "translate(1059.134 801.111)",
    fill: "url(#linear-gradient-2)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_798",
    "data-name": "\\uC0AC\\uAC01\\uD615 798",
    width: 11,
    height: 508,
    transform: "translate(1068.134 647.29) rotate(90)",
    fill: "url(#linear-gradient-3)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "\\uD0DC\\uC591\\uAD11_\\uD328\\uB110",
    "data-name": "\\uD0DC\\uC591\\uAD11 \\uD328\\uB110",
    transform: "translate(293.193 989.786)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uD0DC\uC591\uAD11 \uD328\uB110"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "AC\\uBD80\\uD558",
    transform: "translate(679.193 989.786)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "AC\uBD80\uD558"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "\\uC778\\uBC84\\uD130",
    transform: "translate(457.193 732.286)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC778\uBC84\uD130"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    id: "\\uD55C\\uC804\\uACC4\\uD1B5",
    transform: "translate(1019.193 989.786)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uD55C\uC804\uACC4\uD1B5"))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_799",
    "data-name": "\\uC0AC\\uAC01\\uD615 799",
    width: 11,
    height: 29.512,
    transform: "translate(697.134 851.778)",
    fill: "url(#linear-gradient-4)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_800",
    "data-name": "\\uC0AC\\uAC01\\uD615 800",
    width: 11,
    height: 153,
    transform: "translate(697.134 696.29)",
    fill: "url(#linear-gradient-5)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_801",
    "data-name": "\\uC0AC\\uAC01\\uD615 801",
    width: 11,
    height: 152,
    transform: "translate(1059.134 647.29)",
    fill: "#f44522"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_802",
    "data-name": "\\uC0AC\\uAC01\\uD615 802",
    width: 11,
    height: 167.821,
    transform: "translate(1030.134 676.29)",
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_803",
    "data-name": "\\uC0AC\\uAC01\\uD615 803",
    width: 11,
    height: 45,
    transform: "translate(468.134 647.29) rotate(90)",
    fill: "url(#linear-gradient-6)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11445",
    "data-name": "\\uD328\\uC2A4 11445",
    d: "M423.134,4125.29h-80v200h11v-189h69Z",
    transform: "translate(0 -3478)",
    fill: "url(#linear-gradient-7)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_804",
    "data-name": "\\uC0AC\\uAC01\\uD615 804",
    width: 11,
    height: 105.553,
    transform: "translate(603.688 647.29) rotate(90)",
    fill: "url(#linear-gradient-8)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11446",
    "data-name": "\\uD328\\uC2A4 11446",
    d: "M1030.134,4154.29h-230v11h230v100h11v-111Z",
    transform: "translate(0 -3478)",
    fill: "url(#linear-gradient-9)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1780",
    "data-name": "\\uADF8\\uB8F9 1780",
    transform: "translate(0 -3478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1779",
    "data-name": "\\uADF8\\uB8F9 1779"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_805",
    "data-name": "\\uC0AC\\uAC01\\uD615 805",
    width: 13.475,
    height: 85.252,
    transform: "translate(332.21 4353.292)",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1778",
    "data-name": "\\uADF8\\uB8F9 1778"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11447",
    "data-name": "\\uD328\\uC2A4 11447",
    d: "M403.47,4402.483H257.235l-3.034-3.734,30.725-78.469,143.2-3.733,3.034,3.733Z",
    fill: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11448",
    "data-name": "\\uD328\\uC2A4 11448",
    d: "M400.436,4398.749H254.2l27.691-82.2H428.128Z",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11449",
    "data-name": "\\uD328\\uC2A4 11449",
    d: "M285.334,4321.738H316.5l-7.226,21.451H278.108Z",
    fill: "#1c75bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11450",
    "data-name": "\\uD328\\uC2A4 11450",
    d: "M320.23,4321.738h31.163l-7.226,21.451H313Z",
    fill: "#1c75bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11451",
    "data-name": "\\uD328\\uC2A4 11451",
    d: "M355.127,4321.738H386.29l-7.226,21.451H347.9Z",
    fill: "#1c75bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11452",
    "data-name": "\\uD328\\uC2A4 11452",
    d: "M390.024,4321.738h31.163l-7.226,21.451H382.8Z",
    fill: "#1c75bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11453",
    "data-name": "\\uD328\\uC2A4 11453",
    d: "M276.85,4346.923h31.163l-7.226,21.451H269.624Z",
    fill: "#1c75bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11454",
    "data-name": "\\uD328\\uC2A4 11454",
    d: "M311.747,4346.923H342.91l-7.226,21.451H304.521Z",
    fill: "#1c75bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11455",
    "data-name": "\\uD328\\uC2A4 11455",
    d: "M346.643,4346.923h31.163l-7.226,21.451H339.417Z",
    fill: "#1c75bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11456",
    "data-name": "\\uD328\\uC2A4 11456",
    d: "M381.54,4346.923H412.7l-7.226,21.451H374.314Z",
    fill: "#1c75bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11457",
    "data-name": "\\uD328\\uC2A4 11457",
    d: "M268.366,4372.107h31.163l-7.226,21.451H261.14Z",
    fill: "#1c75bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11458",
    "data-name": "\\uD328\\uC2A4 11458",
    d: "M303.263,4372.107h31.163l-7.226,21.451H296.037Z",
    fill: "#1c75bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11459",
    "data-name": "\\uD328\\uC2A4 11459",
    d: "M338.159,4372.107h31.163l-7.226,21.451H330.934Z",
    fill: "#1c75bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11460",
    "data-name": "\\uD328\\uC2A4 11460",
    d: "M373.056,4372.107h31.163l-7.226,21.451H365.83Z",
    fill: "#1c75bc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11461",
    "data-name": "\\uD328\\uC2A4 11461",
    d: "M359.016,4438.544H318.879a6.572,6.572,0,0,0-6.573,6.572v3.695h53.283v-3.695A6.572,6.572,0,0,0,359.016,4438.544Z",
    fill: "#9d9d9c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11462",
    "data-name": "\\uD328\\uC2A4 11462",
    d: "M421.187,4321.738,261.14,4393.559H396.993Z",
    fill: "#fff",
    opacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1791",
    "data-name": "\\uADF8\\uB8F9 1791",
    transform: "translate(0 -3478)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_806",
    "data-name": "\\uC0AC\\uAC01\\uD615 806",
    width: 57.867,
    height: 82.387,
    transform: "translate(451.201 4090.29)",
    fill: "#dddbd6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_807",
    "data-name": "\\uC0AC\\uAC01\\uD615 807",
    width: 57.867,
    height: 2.37,
    transform: "translate(451.201 4090.29)",
    fill: "#fefcf7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_808",
    "data-name": "\\uC0AC\\uAC01\\uD615 808",
    width: 21.98,
    height: 17.486,
    transform: "translate(469.569 4103.773)",
    fill: "#414e5f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_809",
    "data-name": "\\uC0AC\\uAC01\\uD615 809",
    width: 21.98,
    height: 0.334,
    transform: "translate(469.569 4103.773)",
    fill: "#bebcb7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_810",
    "data-name": "\\uC0AC\\uAC01\\uD615 810",
    width: 21.98,
    height: 0.334,
    transform: "translate(469.569 4120.926)",
    fill: "#fefcf7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_811",
    "data-name": "\\uC0AC\\uAC01\\uD615 811",
    width: 13.714,
    height: 6.915,
    transform: "translate(473.844 4106.899)",
    fill: "#58625b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_812",
    "data-name": "\\uC0AC\\uAC01\\uD615 812",
    width: 13.306,
    height: 6.507,
    transform: "translate(474.048 4107.103)",
    fill: "#7e8881"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_813",
    "data-name": "\\uC0AC\\uAC01\\uD615 813",
    width: 57.867,
    height: 9.613,
    transform: "translate(451.201 4172.677)",
    fill: "#29333f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_814",
    "data-name": "\\uC0AC\\uAC01\\uD615 814",
    width: 57.867,
    height: 2.515,
    transform: "translate(451.201 4172.677)",
    fill: "#414e5f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_815",
    "data-name": "\\uC0AC\\uAC01\\uD615 815",
    width: 1.784,
    height: 56.998,
    transform: "translate(509.067 4098.267)",
    fill: "#414e5f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_816",
    "data-name": "\\uC0AC\\uAC01\\uD615 816",
    width: 1.784,
    height: 56.998,
    transform: "translate(449.417 4098.267)",
    fill: "#414e5f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1782",
    "data-name": "\\uADF8\\uB8F9 1782"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1781",
    "data-name": "\\uADF8\\uB8F9 1781"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11463",
    "data-name": "\\uD328\\uC2A4 11463",
    d: "M477.833,4109.167h-.893l-.105.105.105.105h.893l.106-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11464",
    "data-name": "\\uD328\\uC2A4 11464",
    d: "M477.833,4107.991h-.893l-.105.105.105.105h.893l.106-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11465",
    "data-name": "\\uD328\\uC2A4 11465",
    d: "M477.833,4110.343h-.893l-.105.105.105.1h.893l.106-.1Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11466",
    "data-name": "\\uD328\\uC2A4 11466",
    d: "M476.8,4108.132l-.1.105v.894l.1.106.106-.106v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11467",
    "data-name": "\\uD328\\uC2A4 11467",
    d: "M477.974,4108.132l-.105.105v.894l.105.106.105-.106v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11468",
    "data-name": "\\uD328\\uC2A4 11468",
    d: "M476.8,4109.308l-.1.106v.894l.1.105.106-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11469",
    "data-name": "\\uD328\\uC2A4 11469",
    d: "M477.974,4109.308l-.105.106v.894l.105.105.105-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11470",
    "data-name": "\\uD328\\uC2A4 11470",
    d: "M476.134,4109.167h-.893l-.1.105.1.105h.893l.106-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11471",
    "data-name": "\\uD328\\uC2A4 11471",
    d: "M476.134,4107.991h-.893l-.1.105.1.105h.893l.106-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11472",
    "data-name": "\\uD328\\uC2A4 11472",
    d: "M476.134,4110.343h-.893l-.1.105.1.1h.893l.106-.1Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11473",
    "data-name": "\\uD328\\uC2A4 11473",
    d: "M475.1,4108.132l-.106.105v.894l.106.106.1-.106v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11474",
    "data-name": "\\uD328\\uC2A4 11474",
    d: "M476.275,4108.132l-.105.105v.894l.105.106.106-.106v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11475",
    "data-name": "\\uD328\\uC2A4 11475",
    d: "M475.1,4109.308l-.106.106v.894l.106.105.1-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11476",
    "data-name": "\\uD328\\uC2A4 11476",
    d: "M476.275,4109.308l-.105.106v.894l.105.105.106-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11477",
    "data-name": "\\uD328\\uC2A4 11477",
    d: "M481.823,4109.167h-.893l-.106.105.106.105h.893l.105-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11478",
    "data-name": "\\uD328\\uC2A4 11478",
    d: "M481.823,4107.991h-.893l-.106.105.106.105h.893l.105-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11479",
    "data-name": "\\uD328\\uC2A4 11479",
    d: "M481.823,4110.343h-.893l-.106.105.106.1h.893l.105-.1Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11480",
    "data-name": "\\uD328\\uC2A4 11480",
    d: "M480.788,4108.132l-.106.105v.894l.106.106.105-.106v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11481",
    "data-name": "\\uD328\\uC2A4 11481",
    d: "M481.964,4108.132l-.106.105v.894l.106.106.105-.106v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11482",
    "data-name": "\\uD328\\uC2A4 11482",
    d: "M480.788,4109.308l-.106.106v.894l.106.105.105-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11483",
    "data-name": "\\uD328\\uC2A4 11483",
    d: "M481.964,4109.308l-.106.106v.894l.106.105.105-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11484",
    "data-name": "\\uD328\\uC2A4 11484",
    d: "M480.124,4109.167h-.893l-.106.105.106.105h.893l.105-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11485",
    "data-name": "\\uD328\\uC2A4 11485",
    d: "M480.124,4107.991h-.893l-.106.105.106.105h.893l.105-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11486",
    "data-name": "\\uD328\\uC2A4 11486",
    d: "M480.124,4110.343h-.893l-.106.105.106.1h.893l.105-.1Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11487",
    "data-name": "\\uD328\\uC2A4 11487",
    d: "M479.089,4108.132l-.105.105v.894l.105.106.1-.106v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11488",
    "data-name": "\\uD328\\uC2A4 11488",
    d: "M480.265,4108.132l-.106.105v.894l.106.106.105-.106v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11489",
    "data-name": "\\uD328\\uC2A4 11489",
    d: "M479.089,4109.308l-.105.106v.894l.105.105.1-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11490",
    "data-name": "\\uD328\\uC2A4 11490",
    d: "M480.265,4109.308l-.106.106v.894l.106.105.105-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_817",
    "data-name": "\\uC0AC\\uAC01\\uD615 817",
    width: 0.21,
    height: 0.21,
    transform: "translate(478.431 4110.343)",
    fill: "#414e52"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11491",
    "data-name": "\\uD328\\uC2A4 11491",
    d: "M485.81,4109.167h-.894l-.106.105.106.105h.894l.105-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11492",
    "data-name": "\\uD328\\uC2A4 11492",
    d: "M485.81,4107.991h-.894l-.106.105.106.105h.894l.105-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11493",
    "data-name": "\\uD328\\uC2A4 11493",
    d: "M485.81,4110.343h-.894l-.106.105.106.1h.894l.105-.1Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11494",
    "data-name": "\\uD328\\uC2A4 11494",
    d: "M484.776,4108.132l-.105.105v.894l.105.106.106-.106v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11495",
    "data-name": "\\uD328\\uC2A4 11495",
    d: "M485.952,4108.132l-.106.105v.894l.106.106.105-.106v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11496",
    "data-name": "\\uD328\\uC2A4 11496",
    d: "M484.776,4109.308l-.105.106v.894l.105.105.106-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11497",
    "data-name": "\\uD328\\uC2A4 11497",
    d: "M485.952,4109.308l-.106.106v.894l.106.105.105-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11498",
    "data-name": "\\uD328\\uC2A4 11498",
    d: "M484.112,4109.167h-.894l-.105.105.105.105h.894l.1-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11499",
    "data-name": "\\uD328\\uC2A4 11499",
    d: "M484.112,4107.991h-.894l-.105.105.105.105h.894l.1-.105Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11500",
    "data-name": "\\uD328\\uC2A4 11500",
    d: "M484.112,4110.343h-.894l-.105.105.105.1h.894l.1-.1Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11501",
    "data-name": "\\uD328\\uC2A4 11501",
    d: "M483.077,4108.132l-.106.105v.894l.106.106.1-.106v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11502",
    "data-name": "\\uD328\\uC2A4 11502",
    d: "M484.253,4108.132l-.105.105v.894l.105.106.105-.106v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11503",
    "data-name": "\\uD328\\uC2A4 11503",
    d: "M483.077,4109.308l-.106.106v.894l.106.105.1-.105v-.894Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11504",
    "data-name": "\\uD328\\uC2A4 11504",
    d: "M484.253,4109.308l-.105.106v.894l.105.105.105-.105v-.894Z",
    fill: "#414e52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1783",
    "data-name": "\\uADF8\\uB8F9 1783"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11505",
    "data-name": "\\uD328\\uC2A4 11505",
    d: "M475.153,4118.506a1.354,1.354,0,1,1,1.354-1.354A1.355,1.355,0,0,1,475.153,4118.506Zm0-2.619a1.264,1.264,0,1,0,1.264,1.265A1.265,1.265,0,0,0,475.153,4115.887Z",
    fill: "#d4dbdf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1784",
    "data-name": "\\uADF8\\uB8F9 1784"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11506",
    "data-name": "\\uD328\\uC2A4 11506",
    d: "M478.861,4118.506a1.354,1.354,0,1,1,1.354-1.354A1.355,1.355,0,0,1,478.861,4118.506Zm0-2.619a1.264,1.264,0,1,0,1.264,1.265A1.266,1.266,0,0,0,478.861,4115.887Z",
    fill: "#d4dbdf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1785",
    "data-name": "\\uADF8\\uB8F9 1785"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11507",
    "data-name": "\\uD328\\uC2A4 11507",
    d: "M482.568,4118.506a1.354,1.354,0,1,1,1.355-1.354A1.356,1.356,0,0,1,482.568,4118.506Zm0-2.619a1.264,1.264,0,1,0,1.265,1.265A1.266,1.266,0,0,0,482.568,4115.887Z",
    fill: "#d4dbdf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1786",
    "data-name": "\\uADF8\\uB8F9 1786"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11508",
    "data-name": "\\uD328\\uC2A4 11508",
    d: "M486.275,4118.506a1.354,1.354,0,1,1,1.356-1.354A1.356,1.356,0,0,1,486.275,4118.506Zm0-2.619a1.264,1.264,0,1,0,1.266,1.265A1.265,1.265,0,0,0,486.275,4115.887Z",
    fill: "#d4dbdf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1787",
    "data-name": "\\uADF8\\uB8F9 1787"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11509",
    "data-name": "\\uD328\\uC2A4 11509",
    d: "M472.6,4108.623a.633.633,0,1,1-.633-.632A.633.633,0,0,1,472.6,4108.623Z",
    fill: "#29333f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11510",
    "data-name": "\\uD328\\uC2A4 11510",
    d: "M472.514,4108.623a.543.543,0,1,1-.543-.542A.543.543,0,0,1,472.514,4108.623Z",
    fill: "red",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11511",
    "data-name": "\\uD328\\uC2A4 11511",
    d: "M472.378,4108.623a.407.407,0,1,1-.407-.407A.406.406,0,0,1,472.378,4108.623Z",
    fill: "red",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11512",
    "data-name": "\\uD328\\uC2A4 11512",
    d: "M472.269,4108.623a.3.3,0,1,1-.3-.3A.3.3,0,0,1,472.269,4108.623Z",
    fill: "red"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1788",
    "data-name": "\\uADF8\\uB8F9 1788"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11513",
    "data-name": "\\uD328\\uC2A4 11513",
    d: "M472.6,4111.743a.633.633,0,1,1-.633-.632A.634.634,0,0,1,472.6,4111.743Z",
    fill: "#29333f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11514",
    "data-name": "\\uD328\\uC2A4 11514",
    d: "M472.514,4111.743a.543.543,0,1,1-.543-.542A.544.544,0,0,1,472.514,4111.743Z",
    fill: "lime",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11515",
    "data-name": "\\uD328\\uC2A4 11515",
    d: "M472.378,4111.743a.407.407,0,1,1-.407-.406A.407.407,0,0,1,472.378,4111.743Z",
    fill: "lime",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11516",
    "data-name": "\\uD328\\uC2A4 11516",
    d: "M472.269,4111.743a.3.3,0,1,1-.3-.3A.3.3,0,0,1,472.269,4111.743Z",
    fill: "lime"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1789",
    "data-name": "\\uADF8\\uB8F9 1789"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11517",
    "data-name": "\\uD328\\uC2A4 11517",
    d: "M489.915,4108.623a.633.633,0,1,1-.633-.632A.632.632,0,0,1,489.915,4108.623Z",
    fill: "#29333f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11518",
    "data-name": "\\uD328\\uC2A4 11518",
    d: "M489.825,4108.623a.543.543,0,1,1-.543-.542A.542.542,0,0,1,489.825,4108.623Z",
    fill: "lime",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11519",
    "data-name": "\\uD328\\uC2A4 11519",
    d: "M489.689,4108.623a.407.407,0,1,1-.407-.407A.406.406,0,0,1,489.689,4108.623Z",
    fill: "lime",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11520",
    "data-name": "\\uD328\\uC2A4 11520",
    d: "M489.58,4108.623a.3.3,0,1,1-.3-.3A.3.3,0,0,1,489.58,4108.623Z",
    fill: "lime"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1790",
    "data-name": "\\uADF8\\uB8F9 1790"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11521",
    "data-name": "\\uD328\\uC2A4 11521",
    d: "M489.915,4111.743a.633.633,0,1,1-.633-.632A.633.633,0,0,1,489.915,4111.743Z",
    fill: "#29333f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11522",
    "data-name": "\\uD328\\uC2A4 11522",
    d: "M489.825,4111.743a.543.543,0,1,1-.543-.542A.543.543,0,0,1,489.825,4111.743Z",
    fill: "lime",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11523",
    "data-name": "\\uD328\\uC2A4 11523",
    d: "M489.689,4111.743a.407.407,0,1,1-.407-.406A.407.407,0,0,1,489.689,4111.743Z",
    fill: "lime",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11524",
    "data-name": "\\uD328\\uC2A4 11524",
    d: "M489.58,4111.743a.3.3,0,1,1-.3-.3A.3.3,0,0,1,489.58,4111.743Z",
    fill: "lime"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11525",
    "data-name": "\\uD328\\uC2A4 11525",
    d: "M475.887,4112.545a.394.394,0,1,1-.394-.394A.393.393,0,0,1,475.887,4112.545Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11526",
    "data-name": "\\uD328\\uC2A4 11526",
    d: "M477.228,4112.545a.394.394,0,1,1-.394-.394A.393.393,0,0,1,477.228,4112.545Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11527",
    "data-name": "\\uD328\\uC2A4 11527",
    d: "M486.152,4112.545a.394.394,0,1,1-.394-.394A.393.393,0,0,1,486.152,4112.545Z",
    fill: "#414e52"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11528",
    "data-name": "\\uD328\\uC2A4 11528",
    d: "M602.726,4140.073l14.288-9.481-14.713-9.057Z",
    transform: "translate(0 -3478)",
    fill: "#f44522"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11529",
    "data-name": "\\uD328\\uC2A4 11529",
    d: "M801.688,4150.593l-14.5,9.151,14.5,9.392Z",
    transform: "translate(0 -3478)",
    fill: "#39b54a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11530",
    "data-name": "\\uD328\\uC2A4 11530",
    d: "M1055.416,4275.778l9.152,14.5,9.391-14.5Z",
    transform: "translate(0 -3478)",
    fill: "#f44522"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11531",
    "data-name": "\\uD328\\uC2A4 11531",
    d: "M693.194,4324.29l9.152,14.5,9.391-14.5Z",
    transform: "translate(0 -3478)",
    fill: "#f44522"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1802",
    "data-name": "\\uADF8\\uB8F9 1802",
    transform: "translate(0 -3478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1796",
    "data-name": "\\uADF8\\uB8F9 1796"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_818",
    "data-name": "\\uC0AC\\uAC01\\uD615 818",
    width: 79.294,
    height: 103.095,
    transform: "translate(702.781 4186.361) rotate(180)",
    fill: "#ebebe9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11532",
    "data-name": "\\uD328\\uC2A4 11532",
    d: "M630.244,4179.012h.845l.807-86.746,64.128-.44v-1.211H630.244Z",
    fill: "#f5f5f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1792",
    "data-name": "\\uADF8\\uB8F9 1792"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11533",
    "data-name": "\\uD328\\uC2A4 11533",
    d: "M696.381,4179.429H629.887V4090.2h66.494Zm-65.706-.788h64.919v-87.655H630.675Z",
    fill: "#828280"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11534",
    "data-name": "\\uD328\\uC2A4 11534",
    d: "M623.487,4186.361h0l1.651-101.444,77.643-.44v-1.211H623.487Z",
    fill: "#f5f5f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1795",
    "data-name": "\\uADF8\\uB8F9 1795"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1793",
    "data-name": "\\uADF8\\uB8F9 1793"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_61",
    "data-name": "\\uD0C0\\uC6D0 61",
    cx: 2.679,
    cy: 2.679,
    r: 2.679,
    transform: "translate(634.201 4136.997) rotate(-82.924)",
    fill: "#828280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11535",
    "data-name": "\\uD328\\uC2A4 11535",
    d: "M638.115,4132.154a2.951,2.951,0,0,0-.541-.05,2.924,2.924,0,0,0-2.822,3.678,2.682,2.682,0,0,1,3.363-3.628Z",
    fill: "#8c8c8c"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_62",
    "data-name": "\\uD0C0\\uC6D0 62",
    cx: 1.963,
    cy: 1.963,
    r: 1.963,
    transform: "translate(635.22 4132.713)",
    fill: "#adadaa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1794",
    "data-name": "\\uADF8\\uB8F9 1794"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11536",
    "data-name": "\\uD328\\uC2A4 11536",
    d: "M636.4,4141.9l.3.583a.111.111,0,0,1-.008.115l-.1.14a.109.109,0,0,0-.01.113l.122.253a.108.108,0,0,1,0,.094l-.127.278a.112.112,0,0,0,.006.1l.111.182a.111.111,0,0,1,.01.094l-.148.419a.113.113,0,0,0,0,.083l.139.3a.113.113,0,0,1,0,.1l-.116.222a.109.109,0,0,0,0,.1l.107.192a.111.111,0,0,1,0,.114l-.091.142a.11.11,0,0,0,.012.136l.308.33a.4.4,0,0,0,.6-.013l.351-.414a.108.108,0,0,0,.021-.1l-.138-.433a.114.114,0,0,1,0-.066l.152-.5a.111.111,0,0,0-.005-.078l-.154-.34a.113.113,0,0,1,.006-.1l.141-.235a.113.113,0,0,0,0-.108l-.107-.2a.11.11,0,0,1-.006-.087l.121-.349a.111.111,0,0,0,0-.076l-.155-.4a.116.116,0,0,1,.005-.091l.288-.555a.111.111,0,0,0-.1-.162l-1.436.054A.11.11,0,0,0,636.4,4141.9Z",
    fill: "#adadaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11537",
    "data-name": "\\uD328\\uC2A4 11537",
    d: "M637.3,4141.741v4.38a.414.414,0,0,1-.143.007v-4.387Z",
    fill: "#636675"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11538",
    "data-name": "\\uD328\\uC2A4 11538",
    d: "M637.3,4141.741v4.38a.414.414,0,0,1-.143.007v-4.387Z",
    fill: "#828280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11539",
    "data-name": "\\uD328\\uC2A4 11539",
    d: "M639.377,4138.871a.568.568,0,0,0-.5-.5,12.231,12.231,0,0,0-3.293,0,.57.57,0,0,0-.505.5c-.049.422-.115,1.03-.115,1.287s.058.81.106,1.215a.572.572,0,0,0,.568.5h3.184a.572.572,0,0,0,.568-.5c.048-.407.106-.955.106-1.221S639.427,4139.292,639.377,4138.871Zm-2.151.909a.532.532,0,1,1,.532-.532A.532.532,0,0,1,637.226,4139.78Z",
    fill: "#302f27"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11540",
    "data-name": "\\uD328\\uC2A4 11540",
    d: "M639.492,4134.675h0a.329.329,0,0,1-.329.329h-3.874a.329.329,0,0,1-.329-.329h0a.328.328,0,0,1,.329-.329h3.874A.329.329,0,0,1,639.492,4134.675Z",
    fill: "#302f27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11541",
    "data-name": "\\uD328\\uC2A4 11541",
    d: "M637.226,4139.1h0a.151.151,0,0,1-.151-.151v-4.939a.151.151,0,0,1,.151-.151h0a.151.151,0,0,1,.151.151v4.939A.151.151,0,0,1,637.226,4139.1Z",
    fill: "#8c8c8c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1801",
    "data-name": "\\uADF8\\uB8F9 1801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1799",
    "data-name": "\\uADF8\\uB8F9 1799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1798",
    "data-name": "\\uADF8\\uB8F9 1798"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11542",
    "data-name": "\\uD328\\uC2A4 11542",
    d: "M661.435,4106.251l-7.8,13.628a2.179,2.179,0,0,0,1.891,3.262h15.6a2.179,2.179,0,0,0,1.891-3.261l-7.8-13.629A2.18,2.18,0,0,0,661.435,4106.251Z",
    fill: "#fbd008"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1797",
    "data-name": "\\uADF8\\uB8F9 1797"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11543",
    "data-name": "\\uD328\\uC2A4 11543",
    d: "M671.145,4122.272H655.5a1.333,1.333,0,0,1-1.157-2l7.789-13.6a1.363,1.363,0,0,1,1.194-.692h0a1.363,1.363,0,0,1,1.194.693l7.781,13.6a1.333,1.333,0,0,1-1.156,2Zm-8.689-15.412.324.185-7.789,13.6a.587.587,0,0,0,.509.878h15.645a.587.587,0,0,0,.509-.878l-7.782-13.6a.622.622,0,0,0-.546-.317h0a.623.623,0,0,0-.546.316Z",
    fill: "#1f1a02"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1800",
    "data-name": "\\uADF8\\uB8F9 1800"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11544",
    "data-name": "\\uD328\\uC2A4 11544",
    d: "M663.072,4120.628l-.664-3.072,1.081.925,1.349-.452Z",
    fill: "#1a1602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11545",
    "data-name": "\\uD328\\uC2A4 11545",
    d: "M665.223,4113.352l-1.548,5.7-.595-.137.843-4.016-3.2,1.517,2.038-6.336,1.29.031-1.727,4.7Z",
    fill: "#1f1a02"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1920",
    "data-name": "\\uADF8\\uB8F9 1920",
    transform: "translate(0 -3478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1808",
    "data-name": "\\uADF8\\uB8F9 1808"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1804",
    "data-name": "\\uADF8\\uB8F9 1804"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_819",
    "data-name": "\\uC0AC\\uAC01\\uD615 819",
    width: 79.221,
    height: 103,
    transform: "translate(781.745 4186.313) rotate(180)",
    fill: "#e4e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11546",
    "data-name": "\\uD328\\uC2A4 11546",
    d: "M709.036,4179.27v1.037l59.045-1.036Z",
    fill: "#eef0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11547",
    "data-name": "\\uD328\\uC2A4 11547",
    d: "M702.524,4186.313h0l1.65-101.35,77.571-.44v-1.21H702.524Z",
    fill: "#eef0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_820",
    "data-name": "\\uC0AC\\uAC01\\uD615 820",
    width: 66.196,
    height: 88.912,
    transform: "translate(775.232 4179.27) rotate(180)",
    fill: "#084559"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_821",
    "data-name": "\\uC0AC\\uAC01\\uD615 821",
    width: 66.196,
    height: 88.912,
    transform: "translate(775.232 4179.27) rotate(180)",
    fill: "#adadaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11548",
    "data-name": "\\uD328\\uC2A4 11548",
    d: "M709.036,4158.637h64.587l-.041-8.81H709.036Z",
    fill: "#d5d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11549",
    "data-name": "\\uD328\\uC2A4 11549",
    d: "M709.036,4150.272l59.322-.445H709.036Z",
    fill: "#e4e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11550",
    "data-name": "\\uD328\\uC2A4 11550",
    d: "M709.036,4120.094h64.587l-.041-8.81H709.036Z",
    fill: "#d5d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11551",
    "data-name": "\\uD328\\uC2A4 11551",
    d: "M709.036,4111.729l59.322-.445H709.036Z",
    fill: "#e4e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11552",
    "data-name": "\\uD328\\uC2A4 11552",
    d: "M709.036,4113.429h64.587l-.041-.457H709.036Z",
    fill: "#adadaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11553",
    "data-name": "\\uD328\\uC2A4 11553",
    d: "M709.036,4118.408h64.587l-.041-.457H709.036Z",
    fill: "#adadaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11554",
    "data-name": "\\uD328\\uC2A4 11554",
    d: "M709.036,4152h64.587l-.041-.457H709.036Z",
    fill: "#adadaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11555",
    "data-name": "\\uD328\\uC2A4 11555",
    d: "M709.036,4156.974h64.587l-.041-.457H709.036Z",
    fill: "#adadaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11556",
    "data-name": "\\uD328\\uC2A4 11556",
    d: "M709.036,4111.233v-21.008h61.226v3.629l-59.577-.2Z",
    fill: "#828280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11557",
    "data-name": "\\uD328\\uC2A4 11557",
    d: "M709.036,4149.312v-29.218h61.41v10.655l-59.761.239Z",
    fill: "#828280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11558",
    "data-name": "\\uD328\\uC2A4 11558",
    d: "M709.036,4178.995v-20.357l61.226.028V4169.3l-59.577.232Z",
    fill: "#828280"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_822",
    "data-name": "\\uC0AC\\uAC01\\uD615 822",
    width: 4.253,
    height: 88.362,
    transform: "translate(774.957 4178.995) rotate(180)",
    fill: "#e4e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11559",
    "data-name": "\\uD328\\uC2A4 11559",
    d: "M770.7,4178.995l1.615-86.747,2.409-.941.229-.673H770.7Z",
    fill: "#eef0f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1803",
    "data-name": "\\uADF8\\uB8F9 1803"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11560",
    "data-name": "\\uD328\\uC2A4 11560",
    d: "M775.351,4179.229H770.31v-88.99h5.041Zm-4.254-.787h3.467v-87.416H771.1Z",
    fill: "#828280"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1805",
    "data-name": "\\uADF8\\uB8F9 1805"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11561",
    "data-name": "\\uD328\\uC2A4 11561",
    d: "M776.554,4135.033l-.582.3a.111.111,0,0,1-.115-.009l.1,1.049a.106.106,0,0,1,.091,0l.554.287a.111.111,0,0,0,.162-.1l-.054-1.434A.111.111,0,0,0,776.554,4135.033Z",
    fill: "#adadaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11562",
    "data-name": "\\uD328\\uC2A4 11562",
    d: "M776.717,4135.931h-.831a.412.412,0,0,1-.008-.144h.839Z",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11563",
    "data-name": "\\uD328\\uC2A4 11563",
    d: "M779.585,4138.01a.567.567,0,0,0,.5-.5,12.249,12.249,0,0,0,0-3.29.573.573,0,0,0-.5-.5c-.422-.049-1.03-.114-1.286-.114s-.81.058-1.215.106a.57.57,0,0,0-.5.567v3.182a.571.571,0,0,0,.5.567c.407.048.955.106,1.221.106S779.164,4138.06,779.585,4138.01Zm-.908-2.149a.531.531,0,1,1,.531.531A.531.531,0,0,1,778.677,4135.861Z",
    fill: "#302f27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1807",
    "data-name": "\\uADF8\\uB8F9 1807"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1806",
    "data-name": "\\uADF8\\uB8F9 1806"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11564",
    "data-name": "\\uD328\\uC2A4 11564",
    d: "M778.421,4143.1l.3.583a.111.111,0,0,1-.008.115l-.1.139a.11.11,0,0,0-.01.113l.122.253a.106.106,0,0,1,0,.094l-.127.278a.113.113,0,0,0,.006.1l.111.181a.114.114,0,0,1,.01.1l-.148.418a.113.113,0,0,0,0,.083l.139.3a.11.11,0,0,1,0,.1l-.116.223a.109.109,0,0,0,0,.1l.107.191a.112.112,0,0,1,0,.114l-.091.142a.109.109,0,0,0,.012.135l.308.331a.4.4,0,0,0,.6-.014l.351-.413a.108.108,0,0,0,.021-.1l-.138-.433a.113.113,0,0,1,0-.066l.152-.494a.109.109,0,0,0-.005-.078l-.154-.34a.111.111,0,0,1,.006-.1l.14-.235a.112.112,0,0,0,0-.108l-.107-.2a.11.11,0,0,1-.006-.087l.121-.349a.109.109,0,0,0,0-.076l-.154-.4a.112.112,0,0,1,.005-.09l.287-.555a.11.11,0,0,0-.1-.161l-1.435.053A.111.111,0,0,0,778.421,4143.1Z",
    fill: "#adadaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11565",
    "data-name": "\\uD328\\uC2A4 11565",
    d: "M779.318,4142.943v4.375a.4.4,0,0,1-.143.008v-4.383Z",
    fill: "#636675"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11566",
    "data-name": "\\uD328\\uC2A4 11566",
    d: "M779.318,4142.943v4.375a.4.4,0,0,1-.143.008v-4.383Z",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11567",
    "data-name": "\\uD328\\uC2A4 11567",
    d: "M781.4,4140.075a.571.571,0,0,0-.5-.5,12.316,12.316,0,0,0-3.29,0,.573.573,0,0,0-.505.5c-.049.422-.115,1.029-.115,1.286s.058.809.107,1.214a.57.57,0,0,0,.567.5h3.181a.57.57,0,0,0,.567-.5c.048-.407.107-.954.107-1.22S781.448,4140.5,781.4,4140.075Zm-2.15.908a.531.531,0,1,1,.532-.532A.531.531,0,0,1,779.248,4140.983Z",
    fill: "#302f27"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11568",
    "data-name": "\\uD328\\uC2A4 11568",
    d: "M779.248,4140.3h0a.15.15,0,0,1-.15-.151v-4.09a.151.151,0,0,1,.15-.151h0a.151.151,0,0,1,.151.151v4.09A.15.15,0,0,1,779.248,4140.3Z",
    fill: "#8c8c8c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11569",
    "data-name": "\\uD328\\uC2A4 11569",
    d: "M775.369,4133.339v5.044l.675-.422v-4.227Z",
    fill: "#575755"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11570",
    "data-name": "\\uD328\\uC2A4 11570",
    d: "M770.253,4133.366v5.044l-.675-.422v-4.227Z",
    fill: "#575755"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11571",
    "data-name": "\\uD328\\uC2A4 11571",
    d: "M769.354,4130.143v2.637l-.827-.35v-2.287a.413.413,0,0,1,.405-.413h0A.413.413,0,0,1,769.354,4130.143Z",
    fill: "#575755"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11572",
    "data-name": "\\uD328\\uC2A4 11572",
    d: "M770.253,4133.366l-.675.4-1.051-1.331.642-.446Z",
    fill: "#575755"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1919",
    "data-name": "\\uADF8\\uB8F9 1919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1819",
    "data-name": "\\uADF8\\uB8F9 1819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1809",
    "data-name": "\\uADF8\\uB8F9 1809"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_823",
    "data-name": "\\uC0AC\\uAC01\\uD615 823",
    width: 0.472,
    height: 11.369,
    transform: "translate(715.333 4129.73)",
    fill: "#575755"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1810",
    "data-name": "\\uADF8\\uB8F9 1810"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_824",
    "data-name": "\\uC0AC\\uAC01\\uD615 824",
    width: 0.472,
    height: 11.395,
    transform: "translate(715.333 4167.875)",
    fill: "#575755"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1811",
    "data-name": "\\uADF8\\uB8F9 1811"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_825",
    "data-name": "\\uC0AC\\uAC01\\uD615 825",
    width: 0.472,
    height: 11.395,
    transform: "translate(723.35 4167.875)",
    fill: "#575755"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1812",
    "data-name": "\\uADF8\\uB8F9 1812"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_826",
    "data-name": "\\uC0AC\\uAC01\\uD615 826",
    width: 0.472,
    height: 11.395,
    transform: "translate(731.198 4167.875)",
    fill: "#575755"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1813",
    "data-name": "\\uADF8\\uB8F9 1813"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_827",
    "data-name": "\\uC0AC\\uAC01\\uD615 827",
    width: 0.472,
    height: 11.369,
    transform: "translate(723.266 4129.73)",
    fill: "#575755"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1814",
    "data-name": "\\uADF8\\uB8F9 1814"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_828",
    "data-name": "\\uC0AC\\uAC01\\uD615 828",
    width: 0.472,
    height: 11.369,
    transform: "translate(739.215 4129.73)",
    fill: "#575755"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1815",
    "data-name": "\\uADF8\\uB8F9 1815"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_829",
    "data-name": "\\uC0AC\\uAC01\\uD615 829",
    width: 0.472,
    height: 11.369,
    transform: "translate(731.198 4129.73)",
    fill: "#575755"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1816",
    "data-name": "\\uADF8\\uB8F9 1816"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_830",
    "data-name": "\\uC0AC\\uAC01\\uD615 830",
    width: 0.472,
    height: 11.369,
    transform: "translate(764.533 4129.73)",
    fill: "#575755"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1817",
    "data-name": "\\uADF8\\uB8F9 1817"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_831",
    "data-name": "\\uC0AC\\uAC01\\uD615 831",
    width: 0.472,
    height: 11.369,
    transform: "translate(751.199 4129.73)",
    fill: "#575755"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1818",
    "data-name": "\\uADF8\\uB8F9 1818"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11573",
    "data-name": "\\uD328\\uC2A4 11573",
    d: "M747.231,4173.657h-3.575a4.446,4.446,0,0,1-4.441-4.441V4162.9h.473v6.321a3.974,3.974,0,0,0,3.968,3.969h3.575a3.973,3.973,0,0,0,3.968-3.969V4162.9h.472v6.321A4.446,4.446,0,0,1,747.231,4173.657Z",
    fill: "#575755"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1828",
    "data-name": "\\uADF8\\uB8F9 1828"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_832",
    "data-name": "\\uC0AC\\uAC01\\uD615 832",
    width: 7.933,
    height: 28.463,
    transform: "translate(711.605 4140)",
    fill: "#e4e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_833",
    "data-name": "\\uC0AC\\uAC01\\uD615 833",
    width: 7.595,
    height: 19.13,
    transform: "translate(711.774 4144.667)",
    fill: "#f9fafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_834",
    "data-name": "\\uC0AC\\uAC01\\uD615 834",
    width: 6.92,
    height: 1.724,
    transform: "translate(712.112 4145.089)",
    fill: "#fbd008"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_835",
    "data-name": "\\uC0AC\\uAC01\\uD615 835",
    width: 6.245,
    height: 9.242,
    transform: "translate(712.449 4147.621)",
    fill: "#e4e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1820",
    "data-name": "\\uADF8\\uB8F9 1820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11574",
    "data-name": "\\uD328\\uC2A4 11574",
    d: "M717.218,4156.258h-3.292v-7.613h3.292Zm-2.978-.314H716.9v-6.984H714.24Z",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_836",
    "data-name": "\\uC0AC\\uAC01\\uD615 836",
    width: 6.92,
    height: 1.519,
    transform: "translate(712.112 4147.621)",
    fill: "#302f27"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_837",
    "data-name": "\\uC0AC\\uAC01\\uD615 837",
    width: 6.195,
    height: 1.519,
    transform: "translate(712.474 4148.802)",
    fill: "#302f27"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1823",
    "data-name": "\\uADF8\\uB8F9 1823"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_63",
    "data-name": "\\uD0C0\\uC6D0 63",
    cx: 1.266,
    cy: 1.266,
    r: 1.266,
    transform: "translate(714.304 4141.099)",
    fill: "#575755"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1821",
    "data-name": "\\uADF8\\uB8F9 1821"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_838",
    "data-name": "\\uC0AC\\uAC01\\uD615 838",
    width: 0.315,
    height: 1.753,
    transform: "matrix(0.88, -0.476, 0.476, 0.88, 715.014, 4141.669)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1822",
    "data-name": "\\uADF8\\uB8F9 1822"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_839",
    "data-name": "\\uC0AC\\uAC01\\uD615 839",
    width: 1.753,
    height: 0.315,
    transform: "translate(714.724 4142.644) rotate(-28.405)",
    fill: "#adadaa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1826",
    "data-name": "\\uADF8\\uB8F9 1826"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_64",
    "data-name": "\\uD0C0\\uC6D0 64",
    cx: 1.266,
    cy: 1.266,
    r: 1.266,
    transform: "translate(714.304 4165.101)",
    fill: "#575755"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1824",
    "data-name": "\\uADF8\\uB8F9 1824"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_840",
    "data-name": "\\uC0AC\\uAC01\\uD615 840",
    width: 0.315,
    height: 1.753,
    transform: "translate(714.679 4166.344) rotate(-78.376)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1825",
    "data-name": "\\uADF8\\uB8F9 1825"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_841",
    "data-name": "\\uC0AC\\uAC01\\uD615 841",
    width: 1.753,
    height: 0.315,
    transform: "translate(715.239 4167.193) rotate(-78.365)",
    fill: "#adadaa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1827",
    "data-name": "\\uADF8\\uB8F9 1827"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_842",
    "data-name": "\\uC0AC\\uAC01\\uD615 842",
    width: 5.257,
    height: 0.315,
    transform: "translate(712.893 4161.722)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11575",
    "data-name": "\\uD328\\uC2A4 11575",
    d: "M711.605,4144.264h0l.553-3.626,7.38-.018V4140h-7.933Z",
    fill: "#eef0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1837",
    "data-name": "\\uADF8\\uB8F9 1837"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_843",
    "data-name": "\\uC0AC\\uAC01\\uD615 843",
    width: 7.933,
    height: 28.463,
    transform: "translate(719.538 4140)",
    fill: "#e4e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_844",
    "data-name": "\\uC0AC\\uAC01\\uD615 844",
    width: 7.595,
    height: 19.13,
    transform: "translate(719.707 4144.667)",
    fill: "#f9fafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_845",
    "data-name": "\\uC0AC\\uAC01\\uD615 845",
    width: 6.92,
    height: 1.724,
    transform: "translate(720.044 4145.089)",
    fill: "#fbd008"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_846",
    "data-name": "\\uC0AC\\uAC01\\uD615 846",
    width: 6.245,
    height: 9.242,
    transform: "translate(720.382 4147.621)",
    fill: "#e4e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1829",
    "data-name": "\\uADF8\\uB8F9 1829"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11576",
    "data-name": "\\uD328\\uC2A4 11576",
    d: "M725.15,4156.258h-3.292v-7.613h3.292Zm-2.977-.314h2.662v-6.984h-2.662Z",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_847",
    "data-name": "\\uC0AC\\uAC01\\uD615 847",
    width: 6.92,
    height: 1.519,
    transform: "translate(720.044 4147.621)",
    fill: "#302f27"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_848",
    "data-name": "\\uC0AC\\uAC01\\uD615 848",
    width: 6.195,
    height: 1.519,
    transform: "translate(720.407 4148.802)",
    fill: "#302f27"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1832",
    "data-name": "\\uADF8\\uB8F9 1832"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_65",
    "data-name": "\\uD0C0\\uC6D0 65",
    cx: 1.266,
    cy: 1.266,
    r: 1.266,
    transform: "translate(722.236 4141.099)",
    fill: "#575755"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1830",
    "data-name": "\\uADF8\\uB8F9 1830"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_849",
    "data-name": "\\uC0AC\\uAC01\\uD615 849",
    width: 1.753,
    height: 0.315,
    transform: "matrix(0.194, -0.981, 0.981, 0.194, 723.178, 4143.194)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1831",
    "data-name": "\\uADF8\\uB8F9 1831"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_850",
    "data-name": "\\uC0AC\\uAC01\\uD615 850",
    width: 0.315,
    height: 1.753,
    transform: "translate(722.612 4142.35) rotate(-78.834)",
    fill: "#adadaa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1835",
    "data-name": "\\uADF8\\uB8F9 1835"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_66",
    "data-name": "\\uD0C0\\uC6D0 66",
    cx: 1.266,
    cy: 1.266,
    r: 1.266,
    transform: "translate(722.236 4165.101)",
    fill: "#575755"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1833",
    "data-name": "\\uADF8\\uB8F9 1833"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_851",
    "data-name": "\\uC0AC\\uAC01\\uD615 851",
    width: 1.753,
    height: 0.315,
    transform: "matrix(0.965, -0.263, 0.263, 0.965, 722.615, 4166.445)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1834",
    "data-name": "\\uADF8\\uB8F9 1834"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_852",
    "data-name": "\\uC0AC\\uAC01\\uD615 852",
    width: 0.315,
    height: 1.753,
    transform: "translate(723.12 4165.562) rotate(-15.262)",
    fill: "#adadaa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1836",
    "data-name": "\\uADF8\\uB8F9 1836"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_853",
    "data-name": "\\uC0AC\\uAC01\\uD615 853",
    width: 5.257,
    height: 0.315,
    transform: "translate(720.825 4161.722)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11577",
    "data-name": "\\uD328\\uC2A4 11577",
    d: "M719.536,4144.264h0l.553-3.626,7.38-.018V4140h-7.933Z",
    fill: "#eef0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1846",
    "data-name": "\\uADF8\\uB8F9 1846"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_854",
    "data-name": "\\uC0AC\\uAC01\\uD615 854",
    width: 7.933,
    height: 28.463,
    transform: "translate(711.605 4101.458)",
    fill: "#e4e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_855",
    "data-name": "\\uC0AC\\uAC01\\uD615 855",
    width: 7.595,
    height: 19.13,
    transform: "translate(711.774 4106.124)",
    fill: "#f9fafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_856",
    "data-name": "\\uC0AC\\uAC01\\uD615 856",
    width: 6.92,
    height: 1.724,
    transform: "translate(712.112 4106.546)",
    fill: "#e13d0f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_857",
    "data-name": "\\uC0AC\\uAC01\\uD615 857",
    width: 6.245,
    height: 9.242,
    transform: "translate(712.449 4109.078)",
    fill: "#e4e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1838",
    "data-name": "\\uADF8\\uB8F9 1838"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11578",
    "data-name": "\\uD328\\uC2A4 11578",
    d: "M717.218,4117.716h-3.292V4110.1h3.292Zm-2.978-.315H716.9v-6.984H714.24Z",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_858",
    "data-name": "\\uC0AC\\uAC01\\uD615 858",
    width: 6.92,
    height: 1.519,
    transform: "translate(719.032 4118.276) rotate(180)",
    fill: "#302f27"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_859",
    "data-name": "\\uC0AC\\uAC01\\uD615 859",
    width: 6.195,
    height: 1.519,
    transform: "translate(718.669 4117.095) rotate(180)",
    fill: "#302f27"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1841",
    "data-name": "\\uADF8\\uB8F9 1841"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_67",
    "data-name": "\\uD0C0\\uC6D0 67",
    cx: 1.266,
    cy: 1.266,
    r: 1.266,
    transform: "translate(714.304 4102.556)",
    fill: "#575755"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1839",
    "data-name": "\\uADF8\\uB8F9 1839"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_860",
    "data-name": "\\uC0AC\\uAC01\\uD615 860",
    width: 0.315,
    height: 1.753,
    transform: "matrix(0.88, -0.476, 0.476, 0.88, 715.014, 4103.126)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1840",
    "data-name": "\\uADF8\\uB8F9 1840"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_861",
    "data-name": "\\uC0AC\\uAC01\\uD615 861",
    width: 1.753,
    height: 0.315,
    transform: "translate(714.724 4104.1) rotate(-28.398)",
    fill: "#adadaa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1844",
    "data-name": "\\uADF8\\uB8F9 1844"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_68",
    "data-name": "\\uD0C0\\uC6D0 68",
    cx: 1.266,
    cy: 1.266,
    r: 1.266,
    transform: "translate(714.304 4126.558)",
    fill: "#575755"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1842",
    "data-name": "\\uADF8\\uB8F9 1842"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_862",
    "data-name": "\\uC0AC\\uAC01\\uD615 862",
    width: 0.315,
    height: 1.753,
    transform: "translate(714.679 4127.801) rotate(-78.374)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1843",
    "data-name": "\\uADF8\\uB8F9 1843"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_863",
    "data-name": "\\uC0AC\\uAC01\\uD615 863",
    width: 1.753,
    height: 0.315,
    transform: "translate(715.239 4128.65) rotate(-78.381)",
    fill: "#adadaa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1845",
    "data-name": "\\uADF8\\uB8F9 1845"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_864",
    "data-name": "\\uC0AC\\uAC01\\uD615 864",
    width: 5.257,
    height: 0.315,
    transform: "translate(712.893 4123.179)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11579",
    "data-name": "\\uD328\\uC2A4 11579",
    d: "M711.605,4105.721h0l.553-3.626,7.375-.018v-.619h-7.927Z",
    fill: "#eef0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1855",
    "data-name": "\\uADF8\\uB8F9 1855"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_865",
    "data-name": "\\uC0AC\\uAC01\\uD615 865",
    width: 7.933,
    height: 28.463,
    transform: "translate(719.538 4101.458)",
    fill: "#e4e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_866",
    "data-name": "\\uC0AC\\uAC01\\uD615 866",
    width: 7.595,
    height: 19.13,
    transform: "translate(719.707 4106.124)",
    fill: "#f9fafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_867",
    "data-name": "\\uC0AC\\uAC01\\uD615 867",
    width: 6.92,
    height: 1.724,
    transform: "translate(720.044 4106.546)",
    fill: "#e13d0f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_868",
    "data-name": "\\uC0AC\\uAC01\\uD615 868",
    width: 6.245,
    height: 9.242,
    transform: "translate(720.382 4109.078)",
    fill: "#e4e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1847",
    "data-name": "\\uADF8\\uB8F9 1847"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11580",
    "data-name": "\\uD328\\uC2A4 11580",
    d: "M725.15,4117.716h-3.292V4110.1h3.292Zm-2.977-.315h2.662v-6.984h-2.662Z",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_869",
    "data-name": "\\uC0AC\\uAC01\\uD615 869",
    width: 6.92,
    height: 1.519,
    transform: "translate(726.964 4118.276) rotate(180)",
    fill: "#302f27"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_870",
    "data-name": "\\uC0AC\\uAC01\\uD615 870",
    width: 6.195,
    height: 1.519,
    transform: "translate(726.602 4117.095) rotate(180)",
    fill: "#302f27"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1850",
    "data-name": "\\uADF8\\uB8F9 1850"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_69",
    "data-name": "\\uD0C0\\uC6D0 69",
    cx: 1.266,
    cy: 1.266,
    r: 1.266,
    transform: "translate(722.236 4102.556)",
    fill: "#575755"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1848",
    "data-name": "\\uADF8\\uB8F9 1848"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_871",
    "data-name": "\\uC0AC\\uAC01\\uD615 871",
    width: 1.753,
    height: 0.315,
    transform: "translate(723.178 4104.651) rotate(-78.836)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1849",
    "data-name": "\\uADF8\\uB8F9 1849"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_872",
    "data-name": "\\uC0AC\\uAC01\\uD615 872",
    width: 0.315,
    height: 1.753,
    transform: "translate(722.612 4103.807) rotate(-78.834)",
    fill: "#adadaa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1853",
    "data-name": "\\uADF8\\uB8F9 1853"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_70",
    "data-name": "\\uD0C0\\uC6D0 70",
    cx: 1.266,
    cy: 1.266,
    r: 1.266,
    transform: "translate(722.236 4126.558)",
    fill: "#575755"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1851",
    "data-name": "\\uADF8\\uB8F9 1851"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_873",
    "data-name": "\\uC0AC\\uAC01\\uD615 873",
    width: 1.753,
    height: 0.315,
    transform: "translate(722.615 4127.902) rotate(-15.257)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1852",
    "data-name": "\\uADF8\\uB8F9 1852"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_874",
    "data-name": "\\uC0AC\\uAC01\\uD615 874",
    width: 0.315,
    height: 1.753,
    transform: "translate(723.12 4127.019) rotate(-15.262)",
    fill: "#adadaa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1854",
    "data-name": "\\uADF8\\uB8F9 1854"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_875",
    "data-name": "\\uC0AC\\uAC01\\uD615 875",
    width: 5.257,
    height: 0.315,
    transform: "translate(720.825 4123.179)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11581",
    "data-name": "\\uD328\\uC2A4 11581",
    d: "M719.539,4105.721h0l.553-3.626,7.375-.018v-.619h-7.927Z",
    fill: "#eef0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1882",
    "data-name": "\\uADF8\\uB8F9 1882"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_876",
    "data-name": "\\uC0AC\\uAC01\\uD615 876",
    width: 38.119,
    height: 28.463,
    transform: "translate(729.596 4101.458)",
    fill: "#e4e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_877",
    "data-name": "\\uC0AC\\uAC01\\uD615 877",
    width: 34.327,
    height: 19.164,
    transform: "translate(731.492 4106.124)",
    fill: "#f9fafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1881",
    "data-name": "\\uADF8\\uB8F9 1881"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1856",
    "data-name": "\\uADF8\\uB8F9 1856"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_878",
    "data-name": "\\uC0AC\\uAC01\\uD615 878",
    width: 18.462,
    height: 0.315,
    transform: "translate(736.301 4110.339)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1857",
    "data-name": "\\uADF8\\uB8F9 1857"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_879",
    "data-name": "\\uC0AC\\uAC01\\uD615 879",
    width: 17.169,
    height: 0.315,
    transform: "translate(736.301 4124.01)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1858",
    "data-name": "\\uADF8\\uB8F9 1858"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_880",
    "data-name": "\\uC0AC\\uAC01\\uD615 880",
    width: 11.388,
    height: 0.315,
    transform: "translate(736.301 4122.491)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1859",
    "data-name": "\\uADF8\\uB8F9 1859"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_881",
    "data-name": "\\uC0AC\\uAC01\\uD615 881",
    width: 21.842,
    height: 0.315,
    transform: "translate(736.301 4120.972)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_882",
    "data-name": "\\uC0AC\\uAC01\\uD615 882",
    width: 23.195,
    height: 6.943,
    transform: "translate(736.271 4112.348)",
    fill: "#adadaa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_883",
    "data-name": "\\uC0AC\\uAC01\\uD615 883",
    width: 3.92,
    height: 6.943,
    transform: "translate(736.271 4112.348)",
    fill: "#302f27"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1862",
    "data-name": "\\uADF8\\uB8F9 1862"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11582",
    "data-name": "\\uD328\\uC2A4 11582",
    d: "M733.523,4104.649a1.266,1.266,0,1,1-.169-1.783A1.265,1.265,0,0,1,733.523,4104.649Z",
    fill: "#575755"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1860",
    "data-name": "\\uADF8\\uB8F9 1860"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_884",
    "data-name": "\\uC0AC\\uAC01\\uD615 884",
    width: 1.753,
    height: 0.315,
    transform: "matrix(0.194, -0.981, 0.981, 0.194, 732.223, 4104.671)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1861",
    "data-name": "\\uADF8\\uB8F9 1861"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_885",
    "data-name": "\\uC0AC\\uAC01\\uD615 885",
    width: 0.315,
    height: 1.753,
    transform: "translate(731.658 4103.827) rotate(-78.834)",
    fill: "#adadaa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1865",
    "data-name": "\\uADF8\\uB8F9 1865"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_71",
    "data-name": "\\uD0C0\\uC6D0 71",
    cx: 1.266,
    cy: 1.266,
    r: 1.266,
    transform: "translate(731.198 4126.578)",
    fill: "#575755"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1863",
    "data-name": "\\uADF8\\uB8F9 1863"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_886",
    "data-name": "\\uC0AC\\uAC01\\uD615 886",
    width: 1.753,
    height: 0.315,
    transform: "matrix(0.965, -0.263, 0.263, 0.965, 731.576, 4127.922)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1864",
    "data-name": "\\uADF8\\uB8F9 1864"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_887",
    "data-name": "\\uC0AC\\uAC01\\uD615 887",
    width: 0.315,
    height: 1.753,
    transform: "matrix(0.965, -0.263, 0.263, 0.965, 732.081, 4127.04)",
    fill: "#adadaa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1868",
    "data-name": "\\uADF8\\uB8F9 1868"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11583",
    "data-name": "\\uD328\\uC2A4 11583",
    d: "M765.943,4104.084a1.266,1.266,0,1,1-1-1.484A1.267,1.267,0,0,1,765.943,4104.084Z",
    fill: "#575755"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1866",
    "data-name": "\\uADF8\\uB8F9 1866"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_888",
    "data-name": "\\uC0AC\\uAC01\\uD615 888",
    width: 0.315,
    height: 1.753,
    transform: "matrix(0.954, -0.299, 0.299, 0.954, 764.289, 4103.053)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1867",
    "data-name": "\\uADF8\\uB8F9 1867"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_889",
    "data-name": "\\uC0AC\\uAC01\\uD615 889",
    width: 1.753,
    height: 0.315,
    transform: "translate(763.817 4103.954) rotate(-17.386)",
    fill: "#adadaa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1871",
    "data-name": "\\uADF8\\uB8F9 1871"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11584",
    "data-name": "\\uD328\\uC2A4 11584",
    d: "M765.55,4126.9a1.266,1.266,0,1,1-1.788.089A1.266,1.266,0,0,1,765.55,4126.9Z",
    fill: "#575755"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1869",
    "data-name": "\\uADF8\\uB8F9 1869"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_890",
    "data-name": "\\uC0AC\\uAC01\\uD615 890",
    width: 0.315,
    height: 1.753,
    transform: "translate(763.812 4127.789) rotate(-76.26)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1870",
    "data-name": "\\uADF8\\uB8F9 1870"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_891",
    "data-name": "\\uC0AC\\uAC01\\uD615 891",
    width: 1.753,
    height: 0.315,
    transform: "translate(764.339 4128.657) rotate(-76.255)",
    fill: "#adadaa"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_892",
    "data-name": "\\uC0AC\\uAC01\\uD615 892",
    width: 24.498,
    height: 1.821,
    transform: "translate(736.33 4107.522)",
    fill: "#adadaa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1872",
    "data-name": "\\uADF8\\uB8F9 1872"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11585",
    "data-name": "\\uD328\\uC2A4 11585",
    d: "M739.415,4115.55c0,1.162-.431,1.8-1.188,1.8-.668,0-1.121-.626-1.131-1.756,0-1.147.494-1.778,1.188-1.778C739.005,4113.82,739.415,4114.462,739.415,4115.55Zm-1.856.053c0,.889.273,1.393.694,1.393.473,0,.7-.552.7-1.425,0-.841-.215-1.393-.694-1.393C737.853,4114.178,737.559,4114.672,737.559,4115.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_893",
    "data-name": "\\uC0AC\\uAC01\\uD615 893",
    width: 3.92,
    height: 6.943,
    transform: "translate(740.409 4112.348)",
    fill: "#302f27"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1873",
    "data-name": "\\uADF8\\uB8F9 1873"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11586",
    "data-name": "\\uD328\\uC2A4 11586",
    d: "M743.553,4115.55c0,1.162-.431,1.8-1.188,1.8-.668,0-1.121-.626-1.131-1.756,0-1.147.494-1.778,1.189-1.778C743.143,4113.82,743.553,4114.462,743.553,4115.55Zm-1.856.053c0,.889.273,1.393.694,1.393.473,0,.7-.552.7-1.425,0-.841-.215-1.393-.694-1.393C741.991,4114.178,741.7,4114.672,741.7,4115.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_894",
    "data-name": "\\uC0AC\\uAC01\\uD615 894",
    width: 3.92,
    height: 6.943,
    transform: "translate(744.547 4112.348)",
    fill: "#302f27"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1874",
    "data-name": "\\uADF8\\uB8F9 1874"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11587",
    "data-name": "\\uD328\\uC2A4 11587",
    d: "M747.691,4115.55c0,1.162-.431,1.8-1.188,1.8-.668,0-1.12-.626-1.131-1.756,0-1.147.495-1.778,1.189-1.778C747.281,4113.82,747.691,4114.462,747.691,4115.55Zm-1.856.053c0,.889.273,1.393.694,1.393.474,0,.7-.552.7-1.425,0-.841-.216-1.393-.7-1.393C746.13,4114.178,745.835,4114.672,745.835,4115.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_895",
    "data-name": "\\uC0AC\\uAC01\\uD615 895",
    width: 3.92,
    height: 6.943,
    transform: "translate(748.685 4112.348)",
    fill: "#302f27"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1875",
    "data-name": "\\uADF8\\uB8F9 1875"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11588",
    "data-name": "\\uD328\\uC2A4 11588",
    d: "M751.83,4115.55c0,1.162-.432,1.8-1.189,1.8-.668,0-1.12-.626-1.131-1.756,0-1.147.495-1.778,1.189-1.778C751.419,4113.82,751.83,4114.462,751.83,4115.55Zm-1.857.053c0,.889.274,1.393.694,1.393.474,0,.7-.552.7-1.425,0-.841-.216-1.393-.694-1.393C750.268,4114.178,749.973,4114.672,749.973,4115.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_896",
    "data-name": "\\uC0AC\\uAC01\\uD615 896",
    width: 3.92,
    height: 6.943,
    transform: "translate(752.823 4112.348)",
    fill: "#302f27"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1876",
    "data-name": "\\uADF8\\uB8F9 1876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11589",
    "data-name": "\\uD328\\uC2A4 11589",
    d: "M755.968,4115.55c0,1.162-.431,1.8-1.189,1.8-.668,0-1.12-.626-1.13-1.756,0-1.147.494-1.778,1.188-1.778C755.558,4113.82,755.968,4114.462,755.968,4115.55Zm-1.857.053c0,.889.274,1.393.7,1.393.473,0,.7-.552.7-1.425,0-.841-.216-1.393-.694-1.393C754.406,4114.178,754.111,4114.672,754.111,4115.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1880",
    "data-name": "\\uADF8\\uB8F9 1880"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_897",
    "data-name": "\\uC0AC\\uAC01\\uD615 897",
    width: 3.92,
    height: 6.943,
    transform: "translate(756.961 4112.348)",
    fill: "#e13d0f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1879",
    "data-name": "\\uADF8\\uB8F9 1879",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1877",
    "data-name": "\\uADF8\\uB8F9 1877"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11590",
    "data-name": "\\uD328\\uC2A4 11590",
    d: "M757.945,4117.963a1.544,1.544,0,0,0,.757.216c.594,0,.778-.379.773-.663-.005-.479-.437-.684-.884-.684h-.257v-.347h.257c.337,0,.763-.173.763-.578,0-.274-.174-.516-.6-.516a1.256,1.256,0,0,0-.683.226l-.121-.336a1.623,1.623,0,0,1,.894-.263c.673,0,.978.4.978.815a.85.85,0,0,1-.631.805v.01a.891.891,0,0,1,.763.878c0,.547-.426,1.026-1.247,1.026a1.742,1.742,0,0,1-.889-.231Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1878",
    "data-name": "\\uADF8\\uB8F9 1878"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11591",
    "data-name": "\\uD328\\uC2A4 11591",
    d: "M757.834,4113.158v-.284l.363-.352c.873-.831,1.267-1.273,1.273-1.788a.61.61,0,0,0-.679-.668,1.159,1.159,0,0,0-.725.289l-.148-.326a1.5,1.5,0,0,1,.968-.347.961.961,0,0,1,1.046.994c0,.631-.457,1.141-1.178,1.835l-.273.253v.01h1.536v.384Z",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11592",
    "data-name": "\\uD328\\uC2A4 11592",
    d: "M729.6,4105.721h0l.553-3.626,37.592-.018v-.619H729.6Z",
    fill: "#eef0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1891",
    "data-name": "\\uADF8\\uB8F9 1891"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_899",
    "data-name": "\\uC0AC\\uAC01\\uD615 899",
    width: 7.933,
    height: 28.463,
    transform: "translate(727.471 4140)",
    fill: "#e4e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_900",
    "data-name": "\\uC0AC\\uAC01\\uD615 900",
    width: 7.595,
    height: 19.13,
    transform: "translate(727.639 4144.667)",
    fill: "#f9fafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_901",
    "data-name": "\\uC0AC\\uAC01\\uD615 901",
    width: 6.92,
    height: 1.724,
    transform: "translate(727.977 4145.089)",
    fill: "#fbd008"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_902",
    "data-name": "\\uC0AC\\uAC01\\uD615 902",
    width: 6.245,
    height: 9.242,
    transform: "translate(728.315 4147.621)",
    fill: "#e4e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1883",
    "data-name": "\\uADF8\\uB8F9 1883"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11593",
    "data-name": "\\uD328\\uC2A4 11593",
    d: "M733.083,4156.258h-3.292v-7.613h3.292Zm-2.977-.314h2.662v-6.984h-2.662Z",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_903",
    "data-name": "\\uC0AC\\uAC01\\uD615 903",
    width: 6.92,
    height: 1.519,
    transform: "translate(734.897 4156.819) rotate(180)",
    fill: "#302f27"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_904",
    "data-name": "\\uC0AC\\uAC01\\uD615 904",
    width: 6.195,
    height: 1.519,
    transform: "translate(734.534 4155.638) rotate(180)",
    fill: "#302f27"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1886",
    "data-name": "\\uADF8\\uB8F9 1886"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_72",
    "data-name": "\\uD0C0\\uC6D0 72",
    cx: 1.266,
    cy: 1.266,
    r: 1.266,
    transform: "translate(730.169 4141.099)",
    fill: "#575755"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1884",
    "data-name": "\\uADF8\\uB8F9 1884"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_905",
    "data-name": "\\uC0AC\\uAC01\\uD615 905",
    width: 0.315,
    height: 1.753,
    transform: "matrix(0.585, -0.811, 0.811, 0.585, 730.632, 4141.979)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1885",
    "data-name": "\\uADF8\\uB8F9 1885"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_906",
    "data-name": "\\uC0AC\\uAC01\\uD615 906",
    width: 1.753,
    height: 0.315,
    transform: "matrix(0.586, -0.811, 0.811, 0.586, 730.794, 4142.983)",
    fill: "#adadaa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1889",
    "data-name": "\\uADF8\\uB8F9 1889"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11594",
    "data-name": "\\uD328\\uC2A4 11594",
    d: "M731.374,4165.1a1.266,1.266,0,1,1-1.2,1.325A1.265,1.265,0,0,1,731.374,4165.1Z",
    fill: "#575755"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1887",
    "data-name": "\\uADF8\\uB8F9 1887"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_907",
    "data-name": "\\uC0AC\\uAC01\\uD615 907",
    width: 1.753,
    height: 0.315,
    transform: "translate(730.604 4166.686) rotate(-31.175)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1888",
    "data-name": "\\uADF8\\uB8F9 1888"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_908",
    "data-name": "\\uC0AC\\uAC01\\uD615 908",
    width: 0.315,
    height: 1.753,
    transform: "translate(730.846 4165.698) rotate(-31.18)",
    fill: "#adadaa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1890",
    "data-name": "\\uADF8\\uB8F9 1890"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_909",
    "data-name": "\\uC0AC\\uAC01\\uD615 909",
    width: 5.257,
    height: 0.315,
    transform: "translate(728.758 4161.722)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11595",
    "data-name": "\\uD328\\uC2A4 11595",
    d: "M727.469,4144.264h0l.553-3.626,7.38-.018V4140h-7.933Z",
    fill: "#eef0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1900",
    "data-name": "\\uADF8\\uB8F9 1900"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_910",
    "data-name": "\\uC0AC\\uAC01\\uD615 910",
    width: 7.933,
    height: 28.463,
    transform: "translate(735.403 4140)",
    fill: "#e4e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_911",
    "data-name": "\\uC0AC\\uAC01\\uD615 911",
    width: 7.595,
    height: 19.13,
    transform: "translate(735.572 4144.667)",
    fill: "#f9fafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_912",
    "data-name": "\\uC0AC\\uAC01\\uD615 912",
    width: 6.92,
    height: 1.724,
    transform: "translate(735.91 4145.089)",
    fill: "#fbd008"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_913",
    "data-name": "\\uC0AC\\uAC01\\uD615 913",
    width: 6.245,
    height: 9.242,
    transform: "translate(736.247 4147.621)",
    fill: "#e4e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1892",
    "data-name": "\\uADF8\\uB8F9 1892"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11596",
    "data-name": "\\uD328\\uC2A4 11596",
    d: "M741.016,4156.258h-3.292v-7.613h3.292Zm-2.977-.314H740.7v-6.984h-2.662Z",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_914",
    "data-name": "\\uC0AC\\uAC01\\uD615 914",
    width: 6.92,
    height: 1.519,
    transform: "translate(735.91 4147.621)",
    fill: "#302f27"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_915",
    "data-name": "\\uC0AC\\uAC01\\uD615 915",
    width: 6.195,
    height: 1.519,
    transform: "translate(736.272 4148.802)",
    fill: "#302f27"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1895",
    "data-name": "\\uADF8\\uB8F9 1895"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_73",
    "data-name": "\\uD0C0\\uC6D0 73",
    cx: 1.266,
    cy: 1.266,
    r: 1.266,
    transform: "translate(738.102 4141.099)",
    fill: "#575755"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1893",
    "data-name": "\\uADF8\\uB8F9 1893"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_916",
    "data-name": "\\uC0AC\\uAC01\\uD615 916",
    width: 0.315,
    height: 1.753,
    transform: "translate(738.628 4141.87) rotate(-46.027)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1894",
    "data-name": "\\uADF8\\uB8F9 1894"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_917",
    "data-name": "\\uC0AC\\uAC01\\uD615 917",
    width: 1.753,
    height: 0.315,
    transform: "translate(738.646 4142.886) rotate(-46.03)",
    fill: "#adadaa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1898",
    "data-name": "\\uADF8\\uB8F9 1898"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_74",
    "data-name": "\\uD0C0\\uC6D0 74",
    cx: 1.266,
    cy: 1.266,
    r: 1.266,
    transform: "translate(738.102 4165.101)",
    fill: "#575755"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1896",
    "data-name": "\\uADF8\\uB8F9 1896"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_918",
    "data-name": "\\uC0AC\\uAC01\\uD615 918",
    width: 0.315,
    height: 1.753,
    transform: "translate(738.483 4166.268) rotate(-73.458)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1897",
    "data-name": "\\uADF8\\uB8F9 1897"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_919",
    "data-name": "\\uC0AC\\uAC01\\uD615 919",
    width: 1.753,
    height: 0.315,
    transform: "translate(738.967 4167.162) rotate(-73.459)",
    fill: "#adadaa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1899",
    "data-name": "\\uADF8\\uB8F9 1899"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_920",
    "data-name": "\\uC0AC\\uAC01\\uD615 920",
    width: 5.257,
    height: 0.315,
    transform: "translate(736.691 4161.722)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11597",
    "data-name": "\\uD328\\uC2A4 11597",
    d: "M735.4,4144.264h0l.553-3.626,7.38-.018V4140H735.4Z",
    fill: "#eef0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1918",
    "data-name": "\\uADF8\\uB8F9 1918"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_921",
    "data-name": "\\uC0AC\\uAC01\\uD615 921",
    width: 19.133,
    height: 28.463,
    transform: "translate(748.541 4140)",
    fill: "#e4e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_922",
    "data-name": "\\uC0AC\\uAC01\\uD615 922",
    width: 19.133,
    height: 19.802,
    transform: "translate(748.541 4144.331)",
    fill: "#f9fafa"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_75",
    "data-name": "\\uD0C0\\uC6D0 75",
    cx: 6.895,
    cy: 6.895,
    r: 6.895,
    transform: "translate(751.213 4147.307)",
    fill: "#e4e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1903",
    "data-name": "\\uADF8\\uB8F9 1903"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11598",
    "data-name": "\\uD328\\uC2A4 11598",
    d: "M751.67,4141.131a1.266,1.266,0,1,1-1.521.945A1.266,1.266,0,0,1,751.67,4141.131Z",
    fill: "#575755"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1901",
    "data-name": "\\uADF8\\uB8F9 1901"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_923",
    "data-name": "\\uC0AC\\uAC01\\uD615 923",
    width: 1.753,
    height: 0.315,
    transform: "translate(750.495 4142.443) rotate(-15.259)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1902",
    "data-name": "\\uADF8\\uB8F9 1902"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_924",
    "data-name": "\\uC0AC\\uAC01\\uD615 924",
    width: 0.315,
    height: 1.753,
    transform: "translate(750.999 4141.56) rotate(-15.264)",
    fill: "#adadaa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1906",
    "data-name": "\\uADF8\\uB8F9 1906"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_76",
    "data-name": "\\uD0C0\\uC6D0 76",
    cx: 0.845,
    cy: 0.845,
    r: 0.845,
    transform: "translate(757.263 4153.387)",
    fill: "#575755"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1904",
    "data-name": "\\uADF8\\uB8F9 1904"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_925",
    "data-name": "\\uC0AC\\uAC01\\uD615 925",
    width: 1.17,
    height: 0.21,
    transform: "translate(757.516 4154.285) rotate(-15.265)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1905",
    "data-name": "\\uADF8\\uB8F9 1905"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_926",
    "data-name": "\\uC0AC\\uAC01\\uD615 926",
    width: 0.21,
    height: 1.171,
    transform: "translate(757.853 4153.695) rotate(-15.263)",
    fill: "#adadaa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1907",
    "data-name": "\\uADF8\\uB8F9 1907"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11599",
    "data-name": "\\uD328\\uC2A4 11599",
    d: "M755,4153.287a.93.93,0,1,1-1.117.694A.929.929,0,0,1,755,4153.287Z",
    fill: "#575755"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1908",
    "data-name": "\\uADF8\\uB8F9 1908"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11600",
    "data-name": "\\uD328\\uC2A4 11600",
    d: "M761.643,4153.327a.929.929,0,1,1-1.117.694A.929.929,0,0,1,761.643,4153.327Z",
    fill: "#575755"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1911",
    "data-name": "\\uADF8\\uB8F9 1911"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11601",
    "data-name": "\\uD328\\uC2A4 11601",
    d: "M765.608,4141.466a1.266,1.266,0,1,1-1.79.006A1.265,1.265,0,0,1,765.608,4141.466Z",
    fill: "#575755"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1909",
    "data-name": "\\uADF8\\uB8F9 1909"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_927",
    "data-name": "\\uC0AC\\uAC01\\uD615 927",
    width: 0.315,
    height: 1.753,
    transform: "translate(763.83 4142.268) rotate(-73.611)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1910",
    "data-name": "\\uADF8\\uB8F9 1910"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_928",
    "data-name": "\\uC0AC\\uAC01\\uD615 928",
    width: 1.753,
    height: 0.315,
    transform: "translate(764.317 4143.16) rotate(-73.607)",
    fill: "#adadaa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1914",
    "data-name": "\\uADF8\\uB8F9 1914"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_77",
    "data-name": "\\uD0C0\\uC6D0 77",
    cx: 1.266,
    cy: 1.266,
    r: 1.266,
    transform: "translate(750.116 4165.149)",
    fill: "#575755"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1912",
    "data-name": "\\uADF8\\uB8F9 1912"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_929",
    "data-name": "\\uC0AC\\uAC01\\uD615 929",
    width: 1.753,
    height: 0.315,
    transform: "translate(750.661 4166.938) rotate(-46.167)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1913",
    "data-name": "\\uADF8\\uB8F9 1913"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_930",
    "data-name": "\\uC0AC\\uAC01\\uD615 930",
    width: 0.315,
    height: 1.753,
    transform: "matrix(0.693, -0.721, 0.721, 0.693, 750.641, 4165.922)",
    fill: "#adadaa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1917",
    "data-name": "\\uADF8\\uB8F9 1917"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11602",
    "data-name": "\\uD328\\uC2A4 11602",
    d: "M765.2,4165.247a1.266,1.266,0,1,1-1.656.681A1.266,1.266,0,0,1,765.2,4165.247Z",
    fill: "#575755"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1915",
    "data-name": "\\uADF8\\uB8F9 1915"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_931",
    "data-name": "\\uC0AC\\uAC01\\uD615 931",
    width: 1.753,
    height: 0.315,
    transform: "translate(763.828 4166.347) rotate(-5.771)",
    fill: "#adadaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1916",
    "data-name": "\\uADF8\\uB8F9 1916"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_932",
    "data-name": "\\uC0AC\\uAC01\\uD615 932",
    width: 0.315,
    height: 1.753,
    transform: "translate(764.471 4165.559) rotate(-5.766)",
    fill: "#adadaa"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11603",
    "data-name": "\\uD328\\uC2A4 11603",
    d: "M748.541,4144.265h0l.553-3.626,18.6-.018V4140H748.541Z",
    fill: "#eef0f0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1949",
    "data-name": "\\uADF8\\uB8F9 1949",
    transform: "translate(0 -3478)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11604",
    "data-name": "\\uD328\\uC2A4 11604",
    d: "M788.629,4413.673h-86.3v-5.782h54.9v-10.237h18.228l1.2,1.464.478.583,1.567,1.905.481.583,1.564,1.9.481.583,1.567,1.908.481.583,1.567,1.905.481.583,1.564,1.9.479.584Z",
    fill: "#075687"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_933",
    "data-name": "\\uC0AC\\uAC01\\uD615 933",
    width: 81.227,
    height: 33.126,
    transform: "translate(702.293 4413.672)",
    fill: "#3bb5e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11605",
    "data-name": "\\uD328\\uC2A4 11605",
    d: "M757.224,4379.095l-46.211-24.95-27.19,14.93v38.817h73.4Z",
    fill: "#3bb5e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11606",
    "data-name": "\\uD328\\uC2A4 11606",
    d: "M702.948,4378.159v70.652l-76.767-.33v-40.591l22.71.064.052-30.415,26.984-13.42Z",
    fill: "#61ccf7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11607",
    "data-name": "\\uD328\\uC2A4 11607",
    d: "M626.182,4448v-40.11l22.709.063V4448Z",
    fill: "#3bb5e6"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1921",
    "data-name": "\\uADF8\\uB8F9 1921"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11608",
    "data-name": "\\uD328\\uC2A4 11608",
    d: "M777.137,4399.7H757.225v-.583h19.433Z",
    fill: "#053554"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1922",
    "data-name": "\\uADF8\\uB8F9 1922"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11609",
    "data-name": "\\uD328\\uC2A4 11609",
    d: "M779.185,4402.19h-21.96v-.583H778.7Z",
    fill: "#053554"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1923",
    "data-name": "\\uADF8\\uB8F9 1923"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11610",
    "data-name": "\\uD328\\uC2A4 11610",
    d: "M781.23,4404.676h-24v-.583h23.523Z",
    fill: "#053554"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_934",
    "data-name": "\\uC0AC\\uAC01\\uD615 934",
    width: 80.569,
    height: 1.247,
    transform: "translate(702.948 4413.672)",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_935",
    "data-name": "\\uC0AC\\uAC01\\uD615 935",
    width: 22.697,
    height: 1.247,
    transform: "translate(626.183 4413.735)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_936",
    "data-name": "\\uC0AC\\uAC01\\uD615 936",
    width: 44.529,
    height: 1.247,
    transform: "translate(648.902 4413.735)",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11611",
    "data-name": "\\uD328\\uC2A4 11611",
    d: "M783.278,4407.167H757.225v-.583H782.8Z",
    fill: "#053554"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1924",
    "data-name": "\\uADF8\\uB8F9 1924"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11612",
    "data-name": "\\uD328\\uC2A4 11612",
    d: "M785.326,4409.656H702.948v-.583h81.9Z",
    fill: "#053554"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1925",
    "data-name": "\\uADF8\\uB8F9 1925"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11613",
    "data-name": "\\uD328\\uC2A4 11613",
    d: "M787.368,4412.142h-84.42v-.584H786.89Z",
    fill: "#053554"
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_937",
    "data-name": "\\uC0AC\\uAC01\\uD615 937",
    width: 12.262,
    height: 23.88,
    transform: "translate(632.125 4420.656)",
    fill: "#5e3d21"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_938",
    "data-name": "\\uC0AC\\uAC01\\uD615 938",
    width: 22.13,
    height: 10.512,
    transform: "translate(643.512 4421.531) rotate(90)",
    fill: "#855a39"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1926",
    "data-name": "\\uADF8\\uB8F9 1926"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_939",
    "data-name": "\\uC0AC\\uAC01\\uD615 939",
    width: 0.988,
    height: 3.848,
    transform: "translate(641.107 4431.75)",
    fill: "#4d311b"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_940",
    "data-name": "\\uC0AC\\uAC01\\uD615 940",
    width: 51.053,
    height: 27.776,
    transform: "translate(717.971 4419.021)",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_941",
    "data-name": "\\uC0AC\\uAC01\\uD615 941",
    width: 51.053,
    height: 27.776,
    transform: "translate(716.804 4419.021)",
    fill: "#fff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_942",
    "data-name": "\\uC0AC\\uAC01\\uD615 942",
    width: 46.662,
    height: 25.58,
    transform: "translate(719 4421.217)",
    fill: "#afe2f7"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1927",
    "data-name": "\\uADF8\\uB8F9 1927"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_943",
    "data-name": "\\uC0AC\\uAC01\\uD615 943",
    width: 46.662,
    height: 0.584,
    transform: "translate(719 4423.613)",
    fill: "#fff"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1928",
    "data-name": "\\uADF8\\uB8F9 1928"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_944",
    "data-name": "\\uC0AC\\uAC01\\uD615 944",
    width: 46.662,
    height: 0.583,
    transform: "translate(719 4428.591)",
    fill: "#fff"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1929",
    "data-name": "\\uADF8\\uB8F9 1929"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_945",
    "data-name": "\\uC0AC\\uAC01\\uD615 945",
    width: 46.662,
    height: 0.583,
    transform: "translate(719 4433.57)",
    fill: "#fff"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1930",
    "data-name": "\\uADF8\\uB8F9 1930"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_946",
    "data-name": "\\uC0AC\\uAC01\\uD615 946",
    width: 46.662,
    height: 0.584,
    transform: "translate(719 4438.546)",
    fill: "#fff"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1931",
    "data-name": "\\uADF8\\uB8F9 1931"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_947",
    "data-name": "\\uC0AC\\uAC01\\uD615 947",
    width: 46.662,
    height: 0.583,
    transform: "translate(719 4443.524)",
    fill: "#fff"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11614",
    "data-name": "\\uD328\\uC2A4 11614",
    d: "M713.554,4362.415a2.367,2.367,0,1,1-2.367-2.365A2.367,2.367,0,0,1,713.554,4362.415Z",
    fill: "#8ad2f0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11615",
    "data-name": "\\uD328\\uC2A4 11615",
    d: "M711.187,4365.658a3.242,3.242,0,1,1,3.243-3.243A3.246,3.246,0,0,1,711.187,4365.658Zm0-4.732a1.491,1.491,0,1,0,1.492,1.489A1.493,1.493,0,0,0,711.187,4360.926Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11616",
    "data-name": "\\uD328\\uC2A4 11616",
    d: "M678.844,4364.468,651.689,4378.3h-5.465l30.147-15.491Z",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11617",
    "data-name": "\\uD328\\uC2A4 11617",
    d: "M708.547,4378.3h-5.465l-27.155-13.834L648.771,4378.3h-5.465l32.62-16.761Z",
    fill: "#053554"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11618",
    "data-name": "\\uD328\\uC2A4 11618",
    d: "M711.627,4352.715l-26.467,14.535,2.795,1.318,26.267-14.423Z",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11619",
    "data-name": "\\uD328\\uC2A4 11619",
    d: "M757.224,4379.095l5.325.342-51.536-28.147-29.062,15.96,2.795,1.318,26.267-14.423Z",
    fill: "#053554"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_948",
    "data-name": "\\uC0AC\\uAC01\\uD615 948",
    width: 2.475,
    height: 30.74,
    transform: "translate(693.431 4413.735)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_949",
    "data-name": "\\uC0AC\\uAC01\\uD615 949",
    width: 1.016,
    height: 30.74,
    transform: "translate(694.89 4413.735)",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_950",
    "data-name": "\\uC0AC\\uAC01\\uD615 950",
    width: 2.475,
    height: 37.052,
    transform: "translate(693.431 4439.298) rotate(90)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_951",
    "data-name": "\\uC0AC\\uAC01\\uD615 951",
    width: 1.016,
    height: 37.052,
    transform: "translate(693.431 4440.757) rotate(90)",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_952",
    "data-name": "\\uC0AC\\uAC01\\uD615 952",
    width: 2.475,
    height: 30.749,
    transform: "translate(653.905 4413.733)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_953",
    "data-name": "\\uC0AC\\uAC01\\uD615 953",
    width: 0.949,
    height: 30.749,
    transform: "translate(655.431 4413.733)",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_954",
    "data-name": "\\uC0AC\\uAC01\\uD615 954",
    width: 2.475,
    height: 30.749,
    transform: "translate(620.746 4413.733)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_955",
    "data-name": "\\uC0AC\\uAC01\\uD615 955",
    width: 1.067,
    height: 30.749,
    transform: "translate(622.153 4413.733)",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1932",
    "data-name": "\\uADF8\\uB8F9 1932"
  }, _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_956",
    "data-name": "\\uC0AC\\uAC01\\uD615 956",
    width: 27.29,
    height: 17.301,
    transform: "translate(662.282 4382.754)",
    fill: "#8ad2f0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11620",
    "data-name": "\\uD328\\uC2A4 11620",
    d: "M686.8,4382.754l-7.454,17.3h-3.265l7.454-17.3Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11621",
    "data-name": "\\uD328\\uC2A4 11621",
    d: "M672.58,4382.754l-7.454,17.3h-2.845v-.98l7.034-16.32Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11622",
    "data-name": "\\uD328\\uC2A4 11622",
    d: "M688.271,4382.754l-7.454,17.3h-.986l7.454-17.3Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11623",
    "data-name": "\\uD328\\uC2A4 11623",
    d: "M689.572,4382.754v1.9l-6.634,15.4h-.986l7.454-17.3Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11624",
    "data-name": "\\uD328\\uC2A4 11624",
    d: "M677.423,4382.754l-7.454,17.3h-.989l7.454-17.3Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11625",
    "data-name": "\\uD328\\uC2A4 11625",
    d: "M667.985,4382.754l-5.7,13.236v-2.3l4.715-10.94Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11626",
    "data-name": "\\uD328\\uC2A4 11626",
    d: "M682.182,4382.754l-7.457,17.3h-1.8l7.454-17.3Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11627",
    "data-name": "\\uD328\\uC2A4 11627",
    d: "M689.572,4390.687v4.184l-2.235,5.184h-1.8Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11628",
    "data-name": "\\uD328\\uC2A4 11628",
    d: "M661.405,4381.879v19.05h29.042v-19.05Zm27.292,8.65h-5.589v-6.9H688.7Zm-18.2,0v-6.9h10.863v6.9Zm10.863,1.75v6.9H670.495v-6.9Zm-12.614-8.649v6.9h-5.588v-6.9Zm-5.588,8.649h5.588v6.9h-5.588Zm19.952,6.9v-6.9H688.7v6.9Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1935",
    "data-name": "\\uADF8\\uB8F9 1935"
  }, _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_957",
    "data-name": "\\uC0AC\\uAC01\\uD615 957",
    width: 27.29,
    height: 17.301,
    transform: "translate(725.427 4382.754)",
    fill: "#8ad2f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1933",
    "data-name": "\\uADF8\\uB8F9 1933",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11629",
    "data-name": "\\uD328\\uC2A4 11629",
    d: "M749.648,4382.754l-7.437,17.263-2.754-1.187,6.926-16.075Z",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11630",
    "data-name": "\\uD328\\uC2A4 11630",
    d: "M752.718,4387.328v3.653l-3.909,9.073h-1.572Z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11631",
    "data-name": "\\uD328\\uC2A4 11631",
    d: "M752.718,4393.423v2.3l-1.87,4.335h-.989Z",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11632",
    "data-name": "\\uD328\\uC2A4 11632",
    d: "M751.994,4382.754l-7.454,17.3h-1.8l7.457-17.3Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1934",
    "data-name": "\\uADF8\\uB8F9 1934",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11633",
    "data-name": "\\uD328\\uC2A4 11633",
    d: "M731.823,4382.754l-6.4,14.844v-7.574l3.133-7.27Z",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11634",
    "data-name": "\\uD328\\uC2A4 11634",
    d: "M738.439,4382.754l-7.454,17.3H729.41l7.454-17.3Z",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11635",
    "data-name": "\\uD328\\uC2A4 11635",
    d: "M740.479,4382.754l-7.457,17.3h-.989l7.457-17.3Z",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11636",
    "data-name": "\\uD328\\uC2A4 11636",
    d: "M726.714,4400.054l7.454-17.3h-1.8l-6.941,16.1Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11637",
    "data-name": "\\uD328\\uC2A4 11637",
    d: "M745.24,4382.754l-7.457,17.3H736.21l7.454-17.3Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11638",
    "data-name": "\\uD328\\uC2A4 11638",
    d: "M724.552,4381.879v19.05h29.041v-19.05Zm27.291,8.65h-5.589v-6.9h5.589Zm-18.2,0v-6.9H744.5v6.9Zm10.863,1.75v6.9H733.641v-6.9Zm-12.613-8.649v6.9H726.3v-6.9Zm-5.589,8.649h5.589v6.9H726.3Zm19.952,6.9v-6.9h5.589v6.9Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1936",
    "data-name": "\\uADF8\\uB8F9 1936"
  }, _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_958",
    "data-name": "\\uC0AC\\uAC01\\uD615 958",
    width: 12.869,
    height: 17.301,
    transform: "translate(707.123 4382.754)",
    fill: "#8ad2f0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11639",
    "data-name": "\\uD328\\uC2A4 11639",
    d: "M714.592,4382.8l-7.454,17.3h-.015v-7.547l4.2-9.753Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11640",
    "data-name": "\\uD328\\uC2A4 11640",
    d: "M719.992,4382.754v2.815l-6.24,14.485h-1.575l7.454-17.3Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11641",
    "data-name": "\\uD328\\uC2A4 11641",
    d: "M719.992,4388.011v2.293l-4.2,9.75H714.8Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11642",
    "data-name": "\\uD328\\uC2A4 11642",
    d: "M716.938,4382.754l-7.457,17.3h-1.8l7.454-17.3Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11643",
    "data-name": "\\uD328\\uC2A4 11643",
    d: "M706.247,4381.928v19.049h14.619v-19.049Zm12.869,8.649h-4.684v-6.9h4.684Zm-6.435-6.9v6.9H708v-6.9Zm-4.684,8.65h4.684v6.9H708Zm6.435,6.9v-6.9h4.684v6.9Z",
    fill: "#fff"
  }))), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_959",
    "data-name": "\\uC0AC\\uAC01\\uD615 959",
    width: 78.547,
    height: 2.314,
    transform: "translate(618.824 4444.482)",
    fill: "#c4c6c9"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_960",
    "data-name": "\\uC0AC\\uAC01\\uD615 960",
    width: 78.547,
    height: 1.269,
    transform: "translate(618.824 4445.527)",
    fill: "#7c7e80"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1938",
    "data-name": "\\uADF8\\uB8F9 1938"
  }, _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_961",
    "data-name": "\\uC0AC\\uAC01\\uD615 961",
    width: 27.29,
    height: 17.301,
    transform: "translate(662.282 4419.348)",
    fill: "#8ad2f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1937",
    "data-name": "\\uADF8\\uB8F9 1937"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11644",
    "data-name": "\\uD328\\uC2A4 11644",
    d: "M677.184,4419.348l-7.454,17.3h-3.265l7.454-17.3Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11645",
    "data-name": "\\uD328\\uC2A4 11645",
    d: "M687.025,4419.348l-7.454,17.3h-3.265l7.454-17.3Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11646",
    "data-name": "\\uD328\\uC2A4 11646",
    d: "M673.178,4419.348l-7.454,17.3h-1.573l7.454-17.3Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11647",
    "data-name": "\\uD328\\uC2A4 11647",
    d: "M668.052,4419.348l-5.771,13.388v-2.29l4.782-11.1Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11648",
    "data-name": "\\uD328\\uC2A4 11648",
    d: "M670.591,4419.348l-7.454,17.3h-.855v-.306l7.323-16.994Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11649",
    "data-name": "\\uD328\\uC2A4 11649",
    d: "M689.572,4419.348v2.223l-6.5,15.077h-1.8l7.451-17.3Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11650",
    "data-name": "\\uD328\\uC2A4 11650",
    d: "M680.641,4419.348l-7.454,17.3h-1.573l7.454-17.3Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11651",
    "data-name": "\\uD328\\uC2A4 11651",
    d: "M661.405,4418.473v19.05h29.042v-19.05Zm27.292,8.65h-5.589v-6.9H688.7Zm-18.2,0v-6.9h10.863v6.9Zm10.863,1.75v6.9H670.495v-6.9Zm-12.614-8.649v6.9h-5.588v-6.9Zm-5.588,8.649h5.588v6.9h-5.588Zm19.952,6.9v-6.9H688.7v6.9Z",
    fill: "#fff"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11652",
    "data-name": "\\uD328\\uC2A4 11652",
    d: "M697.37,4413.734H618.823l.616-1.444.248-.583.811-1.9.248-.583.808-1.905.251-.583.808-1.905.248-.583.811-1.9.248-.583.811-1.905.248-.583.811-1.905.248-.583.811-1.9.248-.583.811-1.905.248-.583.718-1.687.248-.583.373-.878h19.448v.878l0,.583,0,1.687v.583l0,1.905v.583l0,1.9,0,.583v1.905l0,.583,0,1.905v.583l0,1.9v.583l0,1.905,0,.583v.642h46.992l.321,1.264.146.583.484,1.9.149.583Z",
    fill: "#075687"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1939",
    "data-name": "\\uADF8\\uB8F9 1939"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11653",
    "data-name": "\\uD328\\uC2A4 11653",
    d: "M648.923,4401.752v.583H623.672l.248-.583Z",
    fill: "#053554"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1940",
    "data-name": "\\uADF8\\uB8F9 1940"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11654",
    "data-name": "\\uD328\\uC2A4 11654",
    d: "M648.92,4404.241v.583H622.613l.248-.583Z",
    fill: "#053554"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1941",
    "data-name": "\\uADF8\\uB8F9 1941"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11655",
    "data-name": "\\uD328\\uC2A4 11655",
    d: "M648.917,4406.729l0,.583h-27.36l.251-.583Z",
    fill: "#053554"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1942",
    "data-name": "\\uADF8\\uB8F9 1942"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11656",
    "data-name": "\\uD328\\uC2A4 11656",
    d: "M696.372,4409.8H620.5l.248-.583h75.481Z",
    fill: "#053554"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1943",
    "data-name": "\\uADF8\\uB8F9 1943"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11657",
    "data-name": "\\uD328\\uC2A4 11657",
    d: "M697.005,4412.29H619.439l.248-.583h77.17Z",
    fill: "#053554"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1944",
    "data-name": "\\uADF8\\uB8F9 1944"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11658",
    "data-name": "\\uD328\\uC2A4 11658",
    d: "M648.943,4389.528l0,.583H628.874l.248-.583Z",
    fill: "#053554"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1945",
    "data-name": "\\uADF8\\uB8F9 1945"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11659",
    "data-name": "\\uD328\\uC2A4 11659",
    d: "M648.937,4391.8v.583H627.908l.248-.583Z",
    fill: "#053554"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1946",
    "data-name": "\\uADF8\\uB8F9 1946"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11660",
    "data-name": "\\uD328\\uC2A4 11660",
    d: "M648.934,4394.287v.583H626.849l.248-.583Z",
    fill: "#053554"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1947",
    "data-name": "\\uADF8\\uB8F9 1947"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11661",
    "data-name": "\\uD328\\uC2A4 11661",
    d: "M648.931,4396.775l0,.583H625.79l.248-.583Z",
    fill: "#053554"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1948",
    "data-name": "\\uADF8\\uB8F9 1948"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11662",
    "data-name": "\\uD328\\uC2A4 11662",
    d: "M648.928,4399.264l0,.583H624.731l.248-.583Z",
    fill: "#053554"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11663",
    "data-name": "\\uD328\\uC2A4 11663",
    d: "M719,4421.217V4446.8h9.465Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11664",
    "data-name": "\\uD328\\uC2A4 11664",
    d: "M702.948,4378.3v29.589h10.978Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_962",
    "data-name": "\\uC0AC\\uAC01\\uD615 962",
    width: 34,
    height: 29,
    transform: "translate(369.134 638.29)",
    fill: "#e6e6e6"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_963",
    "data-name": "\\uC0AC\\uAC01\\uD615 963",
    width: 34,
    height: 39.821,
    transform: "translate(541.344 632.29)",
    fill: "#e6e6e6"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    id: "\\uBC30\\uC804\\uBC18",
    transform: "translate(722.193 732.286)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uBC30\uC804\uBC18"))), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_964",
    "data-name": "\\uC0AC\\uAC01\\uD615 964",
    width: 26,
    height: 10,
    rx: 2.529,
    transform: "translate(373.134 641.29)",
    fill: "#fff"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_965",
    "data-name": "\\uC0AC\\uAC01\\uD615 965",
    width: 26,
    height: 10,
    rx: 2.529,
    transform: "translate(545.344 635.29)",
    fill: "#fff"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_966",
    "data-name": "\\uC0AC\\uAC01\\uD615 966",
    width: 26,
    height: 10,
    rx: 2.529,
    transform: "translate(545.344 647.111)",
    fill: "#fff"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_967",
    "data-name": "\\uC0AC\\uAC01\\uD615 967",
    width: 26,
    height: 10,
    rx: 2.529,
    transform: "translate(545.344 659.111)",
    fill: "#fff"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_968",
    "data-name": "\\uC0AC\\uAC01\\uD615 968",
    width: 26,
    height: 10,
    rx: 2.529,
    transform: "translate(373.134 654.29)",
    fill: "#fff"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1950",
    "data-name": "\\uADF8\\uB8F9 1950",
    transform: "translate(0 -3478)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "V1",
    transform: "translate(381.187 4127.988)",
    fontSize: 9,
    fontFamily: "NanumGothicBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "V1")), /*#__PURE__*/React.createElement("text", {
    id: "I1",
    transform: "translate(382.481 4140.691)",
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "NanumGothicBold, NanumGothic"
  }, "1")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    id: "V2",
    transform: "translate(552.62 643.988)",
    fontSize: 9,
    fontFamily: "NanumGothicBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "V2"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    id: "I2",
    transform: "translate(553.785 655.691)",
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "NanumGothicBold, NanumGothic"
  }, "2"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    id: "P",
    transform: "translate(555.747 666.691)",
    fontSize: 9,
    fontFamily: "NanumGothicBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "P"))), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_969",
    "data-name": "\\uC0AC\\uAC01\\uD615 969",
    width: 112,
    height: 124,
    rx: 8.907,
    transform: "translate(994.465 840.111)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2387",
    "data-name": "\\uADF8\\uB8F9 2387",
    transform: "translate(0 -3478)"
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11665",
    "data-name": "\\uD328\\uC2A4 11665",
    d: "M1024.769,4407.614a.662.662,0,0,0,.334-.09l4.089-2.361a6.6,6.6,0,0,1,2.723-.768.669.669,0,1,0-.1-1.334,7.829,7.829,0,0,0-3.289.943l-4.089,2.361a.669.669,0,0,0,.335,1.249Z",
    fill: "#35353f"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11666",
    "data-name": "\\uD328\\uC2A4 11666",
    d: "M1036.272,4383.1a3.748,3.748,0,0,0-1.711-1.969c-.09-.038-.033-.159.044-.165.8-.065,1.646,1.09,1.94,1.72.015.031.028.062.041.094-.1.112-.2.22-.307.341Z",
    fill: "#35353f"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11667",
    "data-name": "\\uD328\\uC2A4 11667",
    d: "M1035.577,4383.3c.042-.1,0-.222-.18-.351-.249-.176-.554-.257-.8-.443a.042.042,0,0,1,.021-.078c.489-.052,1.5.282,1.386.927a.782.782,0,0,1-.03.112A.871.871,0,0,1,1035.577,4383.3Z",
    fill: "#35353f"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11668",
    "data-name": "\\uD328\\uC2A4 11668",
    d: "M1035.6,4382.231c-.094-.273-1.294-.064-1.538-.1a2.22,2.22,0,0,1,.456-.676c.383-.027,1.376.253,1.567.75a1.276,1.276,0,0,1-.477.168A.23.23,0,0,0,1035.6,4382.231Z",
    fill: "#35353f"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11669",
    "data-name": "\\uD328\\uC2A4 11669",
    d: "M1036.847,4381.7c-.442-.972-1.472-1.287-2.2-1.964a.032.032,0,0,1,.022-.054,3.479,3.479,0,0,1,2.46,1.695,2.334,2.334,0,0,1,.269.829c-.132.07-.262.143-.384.222A1.917,1.917,0,0,0,1036.847,4381.7Z",
    fill: "#35353f"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "man"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11670",
    "data-name": "\\uD328\\uC2A4 11670",
    d: "M1025.316,4404.685c.069-.177.194-.119.338-.151a1.305,1.305,0,0,0,.492-.262c.184-.141.345-.309.517-.465a4.94,4.94,0,0,1,1.524-.941,1.589,1.589,0,0,1,1.124-.116,1.169,1.169,0,0,1,.536.4.928.928,0,0,1,.129.6,1.409,1.409,0,0,1-.062.429,1.76,1.76,0,0,1-.517.7,2.973,2.973,0,0,1-.821.583,7.517,7.517,0,0,0-.768.3,1.662,1.662,0,0,0-.418.359,1.317,1.317,0,0,1-.3.327,1.9,1.9,0,0,1-.9.27.994.994,0,0,1-1.074-1.03,3.22,3.22,0,0,1,.115-.667A3.029,3.029,0,0,1,1025.316,4404.685Z",
    fill: "#261d22"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11671",
    "data-name": "\\uD328\\uC2A4 11671",
    d: "M1036.356,4397.553a.67.67,0,0,0,.494-1.122,4.545,4.545,0,0,0-1.081-.848,8.509,8.509,0,0,0-4.79-.943.669.669,0,1,0,.1,1.334,7.251,7.251,0,0,1,4.017.768,3.175,3.175,0,0,1,.763.593A.67.67,0,0,0,1036.356,4397.553Z",
    fill: "#35353f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1955",
    "data-name": "\\uADF8\\uB8F9 1955"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1954",
    "data-name": "\\uADF8\\uB8F9 1954",
    style: {
      isolation: "isolate"
    }
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1951",
    "data-name": "\\uADF8\\uB8F9 1951"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11672",
    "data-name": "\\uD328\\uC2A4 11672",
    d: "M1053.929,4361.734l-39.309-22.844.006,2.172,39.309,22.844Z",
    fill: "#cacaca"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1952",
    "data-name": "\\uADF8\\uB8F9 1952"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11673",
    "data-name": "\\uD328\\uC2A4 11673",
    d: "M1055.82,4360.643,1016.51,4337.8l-1.89,1.091,39.309,22.844Z",
    fill: "#d9d9d9"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1953",
    "data-name": "\\uADF8\\uB8F9 1953"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11674",
    "data-name": "\\uD328\\uC2A4 11674",
    d: "M1053.929,4361.734l.006,2.172,1.89-1.091-.006-2.172Z",
    fill: "#a6a6a6"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1960",
    "data-name": "\\uADF8\\uB8F9 1960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1959",
    "data-name": "\\uADF8\\uB8F9 1959",
    style: {
      isolation: "isolate"
    }
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1956",
    "data-name": "\\uADF8\\uB8F9 1956"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11675",
    "data-name": "\\uD328\\uC2A4 11675",
    d: "M1028.017,4343.2l.258,90.93,4.605,2.676-.258-90.93Z",
    fill: "#bcbdbf"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1957",
    "data-name": "\\uADF8\\uB8F9 1957"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11676",
    "data-name": "\\uD328\\uC2A4 11676",
    d: "M1032.623,4345.881l.258,90.93,2.835-1.636-.258-90.93Z",
    fill: "#a6a6a6"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1958",
    "data-name": "\\uADF8\\uB8F9 1958"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11677",
    "data-name": "\\uD328\\uC2A4 11677",
    d: "M1028.017,4343.2l4.605,2.676,2.835-1.636-4.606-2.676Z",
    fill: "#d9d9d9"
  }))))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11678",
    "data-name": "\\uD328\\uC2A4 11678",
    d: "M1025.053,4383.751a18.9,18.9,0,0,1,3.115.341,16.149,16.149,0,0,0,3.611-.012,27.347,27.347,0,0,0,2.975-.342c.257-.052.733-.211.823-.438a.871.871,0,0,0,.4.167c-.255.768-1.641.823-2.262.918a30.026,30.026,0,0,1-4.54.362,15.787,15.787,0,0,1-2.173-.155,6.288,6.288,0,0,1-2.1-.266A.311.311,0,0,1,1025.053,4383.751Z",
    fill: "#35353f"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11679",
    "data-name": "\\uD328\\uC2A4 11679",
    d: "M1026.761,4382.112a24.313,24.313,0,0,0,2.469.622,12.408,12.408,0,0,0,2.833.364,11.47,11.47,0,0,0,2.63-.3c.217-.051.846-.151.919-.43a1.276,1.276,0,0,0,.477-.168.472.472,0,0,1,0,.334c-.1.3-.51.442-.775.542a8.217,8.217,0,0,1-1.649.364,13.311,13.311,0,0,1-3.646.048c-.586-.073-1.156-.2-1.733-.325a8.073,8.073,0,0,1-1.8-.422C1026.143,4382.58,1026.393,4381.981,1026.761,4382.112Z",
    fill: "#35353f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1967",
    "data-name": "\\uADF8\\uB8F9 1967"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1966",
    "data-name": "\\uADF8\\uB8F9 1966",
    style: {
      isolation: "isolate"
    }
  }, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1961",
    "data-name": "\\uADF8\\uB8F9 1961"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11680",
    "data-name": "\\uD328\\uC2A4 11680",
    d: "M1025.986,4410.116l.031,10.912,6.3,3.659-.031-10.912Z",
    fill: "#f44522"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1962",
    "data-name": "\\uADF8\\uB8F9 1962"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11681",
    "data-name": "\\uD328\\uC2A4 11681",
    d: "M1032.283,4413.775l.031,10.912,2.767-1.6-.031-10.912Z",
    fill: "#f73e19"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1963",
    "data-name": "\\uADF8\\uB8F9 1963"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11682",
    "data-name": "\\uD328\\uC2A4 11682",
    d: "M1032.742,4413.51l.23-.133v10.93l-.23.133Z",
    fill: "#35353f"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1964",
    "data-name": "\\uADF8\\uB8F9 1964"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11683",
    "data-name": "\\uD328\\uC2A4 11683",
    d: "M1025.986,4410.116l6.3,3.659,2.767-1.6-6.3-3.659Z",
    fill: "#ff4c22"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1965",
    "data-name": "\\uADF8\\uB8F9 1965"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11684",
    "data-name": "\\uD328\\uC2A4 11684",
    d: "M1026.445,4409.851l6.3,3.659.23-.133-6.3-3.659Z",
    fill: "#434851"
  })))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11685",
    "data-name": "\\uD328\\uC2A4 11685",
    d: "M1026.477,4416.872h0c.114.066.207.012.207-.12v-.281a.46.46,0,0,0-.207-.359h0c-.114-.066-.207-.012-.207.12v.281A.459.459,0,0,0,1026.477,4416.872Z",
    fill: "#261d22"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11686",
    "data-name": "\\uD328\\uC2A4 11686",
    d: "M1028.609,4414.239l.164,2.553-.8-.5,1.043,3.979.161-1.782,1.028.407Z",
    fill: "#ffd438"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1972",
    "data-name": "\\uADF8\\uB8F9 1972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1971",
    "data-name": "\\uADF8\\uB8F9 1971",
    style: {
      isolation: "isolate"
    }
  }, _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1968",
    "data-name": "\\uADF8\\uB8F9 1968"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11687",
    "data-name": "\\uD328\\uC2A4 11687",
    d: "M1047.748,4365.3l-39.309-22.844.006,2.172,39.309,22.844Z",
    fill: "#cacaca"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1969",
    "data-name": "\\uADF8\\uB8F9 1969"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11688",
    "data-name": "\\uD328\\uC2A4 11688",
    d: "M1049.638,4364.211l-39.309-22.844-1.89,1.091,39.309,22.844Z",
    fill: "#d9d9d9"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1970",
    "data-name": "\\uADF8\\uB8F9 1970"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11689",
    "data-name": "\\uD328\\uC2A4 11689",
    d: "M1047.748,4365.3l.006,2.173,1.89-1.091-.006-2.173Z",
    fill: "#a6a6a6"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2179",
    "data-name": "\\uADF8\\uB8F9 2179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2075",
    "data-name": "\\uADF8\\uB8F9 2075"
  }, _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_970",
    "data-name": "\\uC0AC\\uAC01\\uD615 970",
    width: 8.038,
    height: 0.335,
    transform: "translate(1048.223 4349.954) rotate(-30)",
    fill: "#35353f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2023",
    "data-name": "\\uADF8\\uB8F9 2023"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1978",
    "data-name": "\\uADF8\\uB8F9 1978"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1977",
    "data-name": "\\uADF8\\uB8F9 1977",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1975",
    "data-name": "\\uADF8\\uB8F9 1975"
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11690",
    "data-name": "\\uD328\\uC2A4 11690",
    d: "M1048.045,4354.476l0,2.982a.333.333,0,0,0,.194.271,1.039,1.039,0,0,0,.94,0,.333.333,0,0,0,.2-.275l0-2.982a.335.335,0,0,1-.2.274,1.035,1.035,0,0,1-.941,0A.331.331,0,0,1,1048.045,4354.476Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1974",
    "data-name": "\\uADF8\\uB8F9 1974",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1973",
    "data-name": "\\uADF8\\uB8F9 1973",
    style: {
      isolation: "isolate"
    }
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11691",
    "data-name": "\\uD328\\uC2A4 11691",
    d: "M1048.045,4354.476l0,2.982a.333.333,0,0,0,.194.271,1.039,1.039,0,0,0,.94,0,.333.333,0,0,0,.2-.275l0-2.982a.335.335,0,0,1-.2.274,1.035,1.035,0,0,1-.941,0,.331.331,0,0,1-.193-.27Z",
    fill: "#2e2e37"
  }))))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1976",
    "data-name": "\\uADF8\\uB8F9 1976"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11693",
    "data-name": "\\uD328\\uC2A4 11693",
    d: "M1048.242,4354.2a.288.288,0,0,0,0,.545,1.035,1.035,0,0,0,.941,0,.288.288,0,0,0,0-.545A1.036,1.036,0,0,0,1048.242,4354.2Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2022",
    "data-name": "\\uADF8\\uB8F9 2022"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2009",
    "data-name": "\\uADF8\\uB8F9 2009"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1984",
    "data-name": "\\uADF8\\uB8F9 1984"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1983",
    "data-name": "\\uADF8\\uB8F9 1983",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1981",
    "data-name": "\\uADF8\\uB8F9 1981",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1980",
    "data-name": "\\uADF8\\uB8F9 1980",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1979",
    "data-name": "\\uADF8\\uB8F9 1979",
    style: {
      isolation: "isolate"
    }
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11694",
    "data-name": "\\uD328\\uC2A4 11694",
    d: "M1046.788,4354.359l0,.5a.954.954,0,0,0,.559.781,2.7,2.7,0,0,0,1.255.325v-.5a2.72,2.72,0,0,1-1.256-.325.956.956,0,0,1-.559-.782Z",
    fill: "#2e2e37"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11695",
    "data-name": "\\uD328\\uC2A4 11695",
    d: "M1048.6,4355.466v.5a2.825,2.825,0,0,0,1.463-.324,1.341,1.341,0,0,0,.407-.345v-.5a1.343,1.343,0,0,1-.408.344,2.819,2.819,0,0,1-1.462.325Z",
    fill: "#3b3b45"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11696",
    "data-name": "\\uD328\\uC2A4 11696",
    d: "M1050.473,4354.8v.5a.734.734,0,0,0,.16-.448v-.5a.746.746,0,0,1-.16.449Z",
    fill: "#2e2e37"
  }))))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1982",
    "data-name": "\\uADF8\\uB8F9 1982"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11698",
    "data-name": "\\uD328\\uC2A4 11698",
    d: "M1047.356,4353.567a.832.832,0,0,0-.009,1.574,2.993,2.993,0,0,0,2.718,0,.832.832,0,0,0,.009-1.575A2.993,2.993,0,0,0,1047.356,4353.567Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1990",
    "data-name": "\\uADF8\\uB8F9 1990"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1989",
    "data-name": "\\uADF8\\uB8F9 1989",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1987",
    "data-name": "\\uADF8\\uB8F9 1987",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1986",
    "data-name": "\\uADF8\\uB8F9 1986",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1985",
    "data-name": "\\uADF8\\uB8F9 1985",
    style: {
      isolation: "isolate"
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11699",
    "data-name": "\\uD328\\uC2A4 11699",
    d: "M1047.119,4353.732v.412a.792.792,0,0,0,.463.647,2.249,2.249,0,0,0,1.04.269v-.412a2.24,2.24,0,0,1-1.04-.269.791.791,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11700",
    "data-name": "\\uD328\\uC2A4 11700",
    d: "M1048.622,4354.648v.412a2.339,2.339,0,0,0,1.211-.268,1.108,1.108,0,0,0,.337-.286v-.412a1.1,1.1,0,0,1-.337.285,2.341,2.341,0,0,1-1.211.269Z",
    fill: "#3b3b45"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11701",
    "data-name": "\\uD328\\uC2A4 11701",
    d: "M1050.17,4354.094v.412a.612.612,0,0,0,.133-.371v-.412a.615.615,0,0,1-.133.371Z",
    fill: "#2e2e37"
  }))))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1988",
    "data-name": "\\uADF8\\uB8F9 1988"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11703",
    "data-name": "\\uD328\\uC2A4 11703",
    d: "M1047.589,4353.076a.688.688,0,0,0-.007,1.3,2.477,2.477,0,0,0,2.251,0,.689.689,0,0,0,.007-1.3A2.476,2.476,0,0,0,1047.589,4353.076Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1996",
    "data-name": "\\uADF8\\uB8F9 1996"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1995",
    "data-name": "\\uADF8\\uB8F9 1995",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1993",
    "data-name": "\\uADF8\\uB8F9 1993",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1992",
    "data-name": "\\uADF8\\uB8F9 1992",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1991",
    "data-name": "\\uADF8\\uB8F9 1991",
    style: {
      isolation: "isolate"
    }
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11704",
    "data-name": "\\uD328\\uC2A4 11704",
    d: "M1046.8,4353.1v.5a.951.951,0,0,0,.557.778,2.7,2.7,0,0,0,1.252.324l0-.5a2.7,2.7,0,0,1-1.251-.324.948.948,0,0,1-.557-.778Z",
    fill: "#2e2e37"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11705",
    "data-name": "\\uD328\\uC2A4 11705",
    d: "M1048.6,4354.206l0,.5a2.8,2.8,0,0,0,1.457-.323,1.333,1.333,0,0,0,.406-.344v-.5a1.357,1.357,0,0,1-.406.343,2.8,2.8,0,0,1-1.458.323Z",
    fill: "#3b3b45"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11706",
    "data-name": "\\uD328\\uC2A4 11706",
    d: "M1050.467,4353.54v.5a.738.738,0,0,0,.16-.446v-.5a.743.743,0,0,1-.16.447Z",
    fill: "#2e2e37"
  }))))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1994",
    "data-name": "\\uADF8\\uB8F9 1994"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11708",
    "data-name": "\\uD328\\uC2A4 11708",
    d: "M1047.361,4352.314a.828.828,0,0,0-.009,1.568,2.98,2.98,0,0,0,2.709,0,.829.829,0,0,0,.009-1.57A2.983,2.983,0,0,0,1047.361,4352.314Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2002",
    "data-name": "\\uADF8\\uB8F9 2002"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2001",
    "data-name": "\\uADF8\\uB8F9 2001",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1999",
    "data-name": "\\uADF8\\uB8F9 1999",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1998",
    "data-name": "\\uADF8\\uB8F9 1998",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1997",
    "data-name": "\\uADF8\\uB8F9 1997",
    style: {
      isolation: "isolate"
    }
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11709",
    "data-name": "\\uD328\\uC2A4 11709",
    d: "M1047.119,4352.58v.412a.792.792,0,0,0,.463.647,2.237,2.237,0,0,0,1.04.269v-.412a2.234,2.234,0,0,1-1.04-.269.792.792,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11710",
    "data-name": "\\uD328\\uC2A4 11710",
    d: "M1048.622,4353.5v.412a2.344,2.344,0,0,0,1.211-.268,1.108,1.108,0,0,0,.337-.286v-.412a1.119,1.119,0,0,1-.337.286,2.346,2.346,0,0,1-1.211.268Z",
    fill: "#3b3b45"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11711",
    "data-name": "\\uD328\\uC2A4 11711",
    d: "M1050.17,4352.942v.412a.612.612,0,0,0,.133-.371v-.412a.61.61,0,0,1-.133.371Z",
    fill: "#2e2e37"
  }))))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2000",
    "data-name": "\\uADF8\\uB8F9 2000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11713",
    "data-name": "\\uD328\\uC2A4 11713",
    d: "M1047.589,4351.924a.688.688,0,0,0-.007,1.3,2.482,2.482,0,0,0,2.251,0,.69.69,0,0,0,.007-1.305A2.482,2.482,0,0,0,1047.589,4351.924Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2008",
    "data-name": "\\uADF8\\uB8F9 2008"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2007",
    "data-name": "\\uADF8\\uB8F9 2007",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2005",
    "data-name": "\\uADF8\\uB8F9 2005",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2004",
    "data-name": "\\uADF8\\uB8F9 2004",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2003",
    "data-name": "\\uADF8\\uB8F9 2003",
    style: {
      isolation: "isolate"
    }
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11714",
    "data-name": "\\uD328\\uC2A4 11714",
    d: "M1046.815,4351.955l0,.49a.939.939,0,0,0,.551.771,2.679,2.679,0,0,0,1.238.32l0-.49a2.674,2.674,0,0,1-1.238-.321.944.944,0,0,1-.551-.77Z",
    fill: "#2e2e37"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11715",
    "data-name": "\\uD328\\uC2A4 11715",
    d: "M1048.6,4353.046l0,.49a2.783,2.783,0,0,0,1.442-.32,1.306,1.306,0,0,0,.4-.34v-.49a1.34,1.34,0,0,1-.4.34,2.786,2.786,0,0,1-1.442.32Z",
    fill: "#3b3b45"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11716",
    "data-name": "\\uD328\\uC2A4 11716",
    d: "M1050.448,4352.386v.49a.729.729,0,0,0,.159-.442l0-.49a.726.726,0,0,1-.158.442Z",
    fill: "#2e2e37"
  }))))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2006",
    "data-name": "\\uADF8\\uB8F9 2006"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11718",
    "data-name": "\\uD328\\uC2A4 11718",
    d: "M1047.375,4351.173a.82.82,0,0,0-.009,1.552,2.953,2.953,0,0,0,2.68,0,.821.821,0,0,0,.009-1.553A2.953,2.953,0,0,0,1047.375,4351.173Z",
    fill: "#434851"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2021",
    "data-name": "\\uADF8\\uB8F9 2021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2015",
    "data-name": "\\uADF8\\uB8F9 2015"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2014",
    "data-name": "\\uADF8\\uB8F9 2014",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2012",
    "data-name": "\\uADF8\\uB8F9 2012"
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11719",
    "data-name": "\\uD328\\uC2A4 11719",
    d: "M1048.088,4350.251l-.92,1.513a.767.767,0,0,0,.448.627,2.4,2.4,0,0,0,2.182,0,.772.772,0,0,0,.456-.636l-.931-1.507a.31.31,0,0,1-.182.254.959.959,0,0,1-.873,0A.307.307,0,0,1,1048.088,4350.251Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2011",
    "data-name": "\\uADF8\\uB8F9 2011",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2010",
    "data-name": "\\uADF8\\uB8F9 2010",
    style: {
      isolation: "isolate"
    }
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11720",
    "data-name": "\\uD328\\uC2A4 11720",
    d: "M1048.088,4350.251l-.92,1.513a.767.767,0,0,0,.448.627,2.4,2.4,0,0,0,2.182,0,.772.772,0,0,0,.456-.636l-.931-1.507a.31.31,0,0,1-.182.254.959.959,0,0,1-.873,0,.307.307,0,0,1-.18-.251Z",
    fill: "#3b3b45"
  }))))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2013",
    "data-name": "\\uADF8\\uB8F9 2013"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11722",
    "data-name": "\\uD328\\uC2A4 11722",
    d: "M1048.271,4350a.267.267,0,0,0,0,.5.959.959,0,0,0,.873,0,.267.267,0,0,0,0-.5A.957.957,0,0,0,1048.271,4350Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2020",
    "data-name": "\\uADF8\\uB8F9 2020"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2019",
    "data-name": "\\uADF8\\uB8F9 2019",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2018",
    "data-name": "\\uADF8\\uB8F9 2018"
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11723",
    "data-name": "\\uD328\\uC2A4 11723",
    d: "M1048.093,4349.6l0,.651a.308.308,0,0,0,.179.252.963.963,0,0,0,.875,0,.312.312,0,0,0,.183-.255l0-.606a.309.309,0,0,1-.183.255.963.963,0,0,1-.875,0A.367.367,0,0,1,1048.093,4349.6Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2017",
    "data-name": "\\uADF8\\uB8F9 2017",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2016",
    "data-name": "\\uADF8\\uB8F9 2016",
    style: {
      isolation: "isolate"
    }
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11724",
    "data-name": "\\uD328\\uC2A4 11724",
    d: "M1048.088,4349.641l0,.6a.308.308,0,0,0,.179.252.963.963,0,0,0,.875,0,.312.312,0,0,0,.183-.255l0-.606a.309.309,0,0,1-.183.255.963.963,0,0,1-.875,0,.309.309,0,0,1-.18-.251Z",
    fill: "#e4e6f0"
  }))))))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11726",
    "data-name": "\\uD328\\uC2A4 11726",
    d: "M1048.711,4350.257a.62.62,0,1,1,.62-.62.62.62,0,0,1-.62.62Z",
    fill: "#e4e6f0"
  }))))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11727",
    "data-name": "\\uD328\\uC2A4 11727",
    d: "M1042.18,4353.8a.157.157,0,0,0,.083-.023l6.127-3.537a.167.167,0,1,0-.167-.29l-6.127,3.538a.167.167,0,0,0,.084.312Z",
    fill: "#35353f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2074",
    "data-name": "\\uADF8\\uB8F9 2074"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2029",
    "data-name": "\\uADF8\\uB8F9 2029"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2028",
    "data-name": "\\uADF8\\uB8F9 2028",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2026",
    "data-name": "\\uADF8\\uB8F9 2026"
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11728",
    "data-name": "\\uD328\\uC2A4 11728",
    d: "M1041.869,4358.368l0,2.983a.331.331,0,0,0,.194.27,1.033,1.033,0,0,0,.94,0,.332.332,0,0,0,.2-.274l0-2.983a.335.335,0,0,1-.2.275,1.041,1.041,0,0,1-.941,0A.332.332,0,0,1,1041.869,4358.368Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2025",
    "data-name": "\\uADF8\\uB8F9 2025",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2024",
    "data-name": "\\uADF8\\uB8F9 2024",
    style: {
      isolation: "isolate"
    }
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11729",
    "data-name": "\\uD328\\uC2A4 11729",
    d: "M1041.869,4358.368l0,2.983a.331.331,0,0,0,.194.27,1.033,1.033,0,0,0,.94,0,.332.332,0,0,0,.2-.274l0-2.983a.335.335,0,0,1-.2.275,1.041,1.041,0,0,1-.941,0,.332.332,0,0,1-.193-.271Z",
    fill: "#2e2e37"
  }))))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2027",
    "data-name": "\\uADF8\\uB8F9 2027"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11731",
    "data-name": "\\uD328\\uC2A4 11731",
    d: "M1042.065,4358.094a.288.288,0,0,0,0,.545,1.041,1.041,0,0,0,.941,0,.288.288,0,0,0,0-.545A1.032,1.032,0,0,0,1042.065,4358.094Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2073",
    "data-name": "\\uADF8\\uB8F9 2073"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2060",
    "data-name": "\\uADF8\\uB8F9 2060"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2035",
    "data-name": "\\uADF8\\uB8F9 2035"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2034",
    "data-name": "\\uADF8\\uB8F9 2034",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2032",
    "data-name": "\\uADF8\\uB8F9 2032",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2031",
    "data-name": "\\uADF8\\uB8F9 2031",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2030",
    "data-name": "\\uADF8\\uB8F9 2030",
    style: {
      isolation: "isolate"
    }
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11732",
    "data-name": "\\uD328\\uC2A4 11732",
    d: "M1040.612,4358.252l0,.5a.954.954,0,0,0,.559.781,2.7,2.7,0,0,0,1.255.325v-.5a2.708,2.708,0,0,1-1.256-.325.954.954,0,0,1-.559-.781Z",
    fill: "#2e2e37"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11733",
    "data-name": "\\uD328\\uC2A4 11733",
    d: "M1042.427,4359.358v.5a2.834,2.834,0,0,0,1.463-.324,1.354,1.354,0,0,0,.407-.345v-.5a1.346,1.346,0,0,1-.408.345,2.809,2.809,0,0,1-1.462.324Z",
    fill: "#3b3b45"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11734",
    "data-name": "\\uD328\\uC2A4 11734",
    d: "M1044.3,4358.689v.5a.738.738,0,0,0,.16-.448v-.5a.734.734,0,0,1-.16.448Z",
    fill: "#2e2e37"
  }))))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2033",
    "data-name": "\\uADF8\\uB8F9 2033"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11736",
    "data-name": "\\uD328\\uC2A4 11736",
    d: "M1041.18,4357.46a.831.831,0,0,0-.009,1.573,3,3,0,0,0,2.718,0,.832.832,0,0,0,.009-1.575A2.993,2.993,0,0,0,1041.18,4357.46Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2041",
    "data-name": "\\uADF8\\uB8F9 2041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2040",
    "data-name": "\\uADF8\\uB8F9 2040",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2038",
    "data-name": "\\uADF8\\uB8F9 2038",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2037",
    "data-name": "\\uADF8\\uB8F9 2037",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2036",
    "data-name": "\\uADF8\\uB8F9 2036",
    style: {
      isolation: "isolate"
    }
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11737",
    "data-name": "\\uD328\\uC2A4 11737",
    d: "M1040.943,4357.624v.413a.792.792,0,0,0,.463.647,2.261,2.261,0,0,0,1.04.269v-.412a2.246,2.246,0,0,1-1.04-.27.789.789,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11738",
    "data-name": "\\uD328\\uC2A4 11738",
    d: "M1042.446,4358.541v.412a2.346,2.346,0,0,0,1.211-.269,1.118,1.118,0,0,0,.337-.285v-.412a1.131,1.131,0,0,1-.337.285,2.341,2.341,0,0,1-1.211.269Z",
    fill: "#3b3b45"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11739",
    "data-name": "\\uD328\\uC2A4 11739",
    d: "M1043.994,4357.987v.412a.617.617,0,0,0,.133-.372v-.412a.615.615,0,0,1-.133.372Z",
    fill: "#2e2e37"
  }))))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2039",
    "data-name": "\\uADF8\\uB8F9 2039"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11741",
    "data-name": "\\uD328\\uC2A4 11741",
    d: "M1041.413,4356.968a.688.688,0,0,0-.007,1.3,2.479,2.479,0,0,0,2.251,0,.689.689,0,0,0,.007-1.3A2.479,2.479,0,0,0,1041.413,4356.968Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2047",
    "data-name": "\\uADF8\\uB8F9 2047"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2046",
    "data-name": "\\uADF8\\uB8F9 2046",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2044",
    "data-name": "\\uADF8\\uB8F9 2044",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2043",
    "data-name": "\\uADF8\\uB8F9 2043",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2042",
    "data-name": "\\uADF8\\uB8F9 2042",
    style: {
      isolation: "isolate"
    }
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11742",
    "data-name": "\\uD328\\uC2A4 11742",
    d: "M1040.619,4357v.5a.951.951,0,0,0,.557.779,2.7,2.7,0,0,0,1.252.324l0-.5a2.7,2.7,0,0,1-1.251-.324.951.951,0,0,1-.557-.779Z",
    fill: "#2e2e37"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11743",
    "data-name": "\\uD328\\uC2A4 11743",
    d: "M1042.427,4358.1l0,.5a2.817,2.817,0,0,0,1.457-.323,1.333,1.333,0,0,0,.406-.344v-.5a1.333,1.333,0,0,1-.406.344,2.815,2.815,0,0,1-1.458.323Z",
    fill: "#3b3b45"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11744",
    "data-name": "\\uD328\\uC2A4 11744",
    d: "M1044.291,4357.432v.5a.733.733,0,0,0,.16-.447v-.5a.739.739,0,0,1-.16.447Z",
    fill: "#2e2e37"
  }))))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2045",
    "data-name": "\\uADF8\\uB8F9 2045"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11746",
    "data-name": "\\uD328\\uC2A4 11746",
    d: "M1041.185,4356.207a.828.828,0,0,0-.009,1.568,2.983,2.983,0,0,0,2.709,0,.829.829,0,0,0,.009-1.57A2.98,2.98,0,0,0,1041.185,4356.207Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2053",
    "data-name": "\\uADF8\\uB8F9 2053"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2052",
    "data-name": "\\uADF8\\uB8F9 2052",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2050",
    "data-name": "\\uADF8\\uB8F9 2050",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2049",
    "data-name": "\\uADF8\\uB8F9 2049",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2048",
    "data-name": "\\uADF8\\uB8F9 2048",
    style: {
      isolation: "isolate"
    }
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11747",
    "data-name": "\\uD328\\uC2A4 11747",
    d: "M1040.943,4356.473v.412a.792.792,0,0,0,.463.647,2.243,2.243,0,0,0,1.04.269v-.412a2.246,2.246,0,0,1-1.04-.269.792.792,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11748",
    "data-name": "\\uD328\\uC2A4 11748",
    d: "M1042.446,4357.389v.412a2.341,2.341,0,0,0,1.211-.269,1.091,1.091,0,0,0,.337-.285v-.412a1.1,1.1,0,0,1-.337.285,2.346,2.346,0,0,1-1.211.269Z",
    fill: "#3b3b45"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11749",
    "data-name": "\\uD328\\uC2A4 11749",
    d: "M1043.994,4356.835v.412a.615.615,0,0,0,.133-.371v-.412a.615.615,0,0,1-.133.371Z",
    fill: "#2e2e37"
  }))))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2051",
    "data-name": "\\uADF8\\uB8F9 2051"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11751",
    "data-name": "\\uD328\\uC2A4 11751",
    d: "M1041.413,4355.817a.688.688,0,0,0-.007,1.3,2.479,2.479,0,0,0,2.251,0,.689.689,0,0,0,.007-1.3A2.479,2.479,0,0,0,1041.413,4355.817Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2059",
    "data-name": "\\uADF8\\uB8F9 2059"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2058",
    "data-name": "\\uADF8\\uB8F9 2058",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2056",
    "data-name": "\\uADF8\\uB8F9 2056",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2055",
    "data-name": "\\uADF8\\uB8F9 2055",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2054",
    "data-name": "\\uADF8\\uB8F9 2054",
    style: {
      isolation: "isolate"
    }
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11752",
    "data-name": "\\uD328\\uC2A4 11752",
    d: "M1040.639,4355.847l0,.491a.937.937,0,0,0,.551.77,2.668,2.668,0,0,0,1.238.321v-.491a2.693,2.693,0,0,1-1.239-.32.944.944,0,0,1-.551-.771Z",
    fill: "#2e2e37"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11753",
    "data-name": "\\uD328\\uC2A4 11753",
    d: "M1042.429,4356.938v.491a2.793,2.793,0,0,0,1.442-.32,1.3,1.3,0,0,0,.4-.34v-.491a1.319,1.319,0,0,1-.4.34,2.775,2.775,0,0,1-1.441.32Z",
    fill: "#3b3b45"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11754",
    "data-name": "\\uD328\\uC2A4 11754",
    d: "M1044.272,4356.278v.491a.731.731,0,0,0,.159-.442l0-.491a.721.721,0,0,1-.158.442Z",
    fill: "#2e2e37"
  }))))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2057",
    "data-name": "\\uADF8\\uB8F9 2057"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11756",
    "data-name": "\\uD328\\uC2A4 11756",
    d: "M1041.2,4355.066a.82.82,0,0,0-.009,1.552,2.953,2.953,0,0,0,2.68,0,.821.821,0,0,0,.009-1.553A2.953,2.953,0,0,0,1041.2,4355.066Z",
    fill: "#434851"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2072",
    "data-name": "\\uADF8\\uB8F9 2072"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2066",
    "data-name": "\\uADF8\\uB8F9 2066"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2065",
    "data-name": "\\uADF8\\uB8F9 2065",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2063",
    "data-name": "\\uADF8\\uB8F9 2063"
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11757",
    "data-name": "\\uD328\\uC2A4 11757",
    d: "M1041.913,4354.144l-.921,1.512a.769.769,0,0,0,.448.628,2.407,2.407,0,0,0,2.182,0,.775.775,0,0,0,.456-.636l-.931-1.507a.309.309,0,0,1-.182.254.959.959,0,0,1-.873,0A.3.3,0,0,1,1041.913,4354.144Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2062",
    "data-name": "\\uADF8\\uB8F9 2062",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2061",
    "data-name": "\\uADF8\\uB8F9 2061",
    style: {
      isolation: "isolate"
    }
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11758",
    "data-name": "\\uD328\\uC2A4 11758",
    d: "M1041.913,4354.144l-.921,1.512a.769.769,0,0,0,.448.628,2.407,2.407,0,0,0,2.182,0,.775.775,0,0,0,.456-.636l-.931-1.507a.309.309,0,0,1-.182.254.959.959,0,0,1-.873,0,.3.3,0,0,1-.179-.251Z",
    fill: "#3b3b45"
  }))))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2064",
    "data-name": "\\uADF8\\uB8F9 2064"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11760",
    "data-name": "\\uD328\\uC2A4 11760",
    d: "M1042.095,4353.889a.267.267,0,0,0,0,.506.959.959,0,0,0,.873,0,.267.267,0,0,0,0-.506A.963.963,0,0,0,1042.095,4353.889Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2071",
    "data-name": "\\uADF8\\uB8F9 2071"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2070",
    "data-name": "\\uADF8\\uB8F9 2070",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2069",
    "data-name": "\\uADF8\\uB8F9 2069"
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11761",
    "data-name": "\\uD328\\uC2A4 11761",
    d: "M1041.917,4353.488l0,.651a.306.306,0,0,0,.179.251.966.966,0,0,0,.875,0,.311.311,0,0,0,.183-.255l0-.6a.311.311,0,0,1-.183.255.966.966,0,0,1-.875,0A.369.369,0,0,1,1041.917,4353.488Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2068",
    "data-name": "\\uADF8\\uB8F9 2068",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2067",
    "data-name": "\\uADF8\\uB8F9 2067",
    style: {
      isolation: "isolate"
    }
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11762",
    "data-name": "\\uD328\\uC2A4 11762",
    d: "M1041.913,4353.533l0,.606a.306.306,0,0,0,.179.251.966.966,0,0,0,.875,0,.311.311,0,0,0,.183-.255l0-.6a.311.311,0,0,1-.183.255.966.966,0,0,1-.875,0,.308.308,0,0,1-.179-.252Z",
    fill: "#e4e6f0"
  }))))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_78",
    "data-name": "\\uD0C0\\uC6D0 78",
    cx: 0.62,
    cy: 0.62,
    r: 0.62,
    transform: "translate(1041.916 4352.91)",
    fill: "#e4e6f0"
  }))))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11764",
    "data-name": "\\uD328\\uC2A4 11764",
    d: "M1032.565,4359.355a.165.165,0,0,0,.083-.022l9.615-5.552a.167.167,0,1,0-.167-.289l-9.615,5.551a.167.167,0,0,0,.084.312Z",
    fill: "#35353f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2178",
    "data-name": "\\uADF8\\uB8F9 2178"
  }, _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_971",
    "data-name": "\\uC0AC\\uAC01\\uD615 971",
    width: 8.038,
    height: 0.335,
    transform: "translate(1052.061 4352.012) rotate(-30)",
    fill: "#35353f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2126",
    "data-name": "\\uADF8\\uB8F9 2126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2081",
    "data-name": "\\uADF8\\uB8F9 2081"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2080",
    "data-name": "\\uADF8\\uB8F9 2080",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2078",
    "data-name": "\\uADF8\\uB8F9 2078"
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11765",
    "data-name": "\\uD328\\uC2A4 11765",
    d: "M1051.883,4356.534l0,2.982a.332.332,0,0,0,.193.271,1.041,1.041,0,0,0,.941,0,.335.335,0,0,0,.2-.275l0-2.982a.332.332,0,0,1-.2.274,1.041,1.041,0,0,1-.941,0A.332.332,0,0,1,1051.883,4356.534Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2077",
    "data-name": "\\uADF8\\uB8F9 2077",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2076",
    "data-name": "\\uADF8\\uB8F9 2076",
    style: {
      isolation: "isolate"
    }
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11766",
    "data-name": "\\uD328\\uC2A4 11766",
    d: "M1051.883,4356.534l0,2.982a.332.332,0,0,0,.193.271,1.041,1.041,0,0,0,.941,0,.335.335,0,0,0,.2-.275l0-2.982a.332.332,0,0,1-.2.274,1.041,1.041,0,0,1-.941,0,.332.332,0,0,1-.193-.27Z",
    fill: "#2e2e37"
  }))))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2079",
    "data-name": "\\uADF8\\uB8F9 2079"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11768",
    "data-name": "\\uD328\\uC2A4 11768",
    d: "M1052.079,4356.259a.288.288,0,0,0,0,.545,1.041,1.041,0,0,0,.941,0,.288.288,0,0,0,0-.545A1.041,1.041,0,0,0,1052.079,4356.259Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2125",
    "data-name": "\\uADF8\\uB8F9 2125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2112",
    "data-name": "\\uADF8\\uB8F9 2112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2087",
    "data-name": "\\uADF8\\uB8F9 2087"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2086",
    "data-name": "\\uADF8\\uB8F9 2086",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2084",
    "data-name": "\\uADF8\\uB8F9 2084",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2083",
    "data-name": "\\uADF8\\uB8F9 2083",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2082",
    "data-name": "\\uADF8\\uB8F9 2082",
    style: {
      isolation: "isolate"
    }
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11769",
    "data-name": "\\uD328\\uC2A4 11769",
    d: "M1050.626,4356.417l0,.5a.951.951,0,0,0,.559.781,2.7,2.7,0,0,0,1.255.325v-.5a2.726,2.726,0,0,1-1.256-.325.957.957,0,0,1-.559-.782Z",
    fill: "#2e2e37"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11770",
    "data-name": "\\uD328\\uC2A4 11770",
    d: "M1052.441,4357.524v.5a2.82,2.82,0,0,0,1.463-.324,1.333,1.333,0,0,0,.407-.345v-.5a1.346,1.346,0,0,1-.408.345,2.819,2.819,0,0,1-1.462.325Z",
    fill: "#3b3b45"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11771",
    "data-name": "\\uD328\\uC2A4 11771",
    d: "M1054.311,4356.854v.5a.735.735,0,0,0,.16-.448v-.5a.741.741,0,0,1-.16.448Z",
    fill: "#2e2e37"
  }))))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2085",
    "data-name": "\\uADF8\\uB8F9 2085"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11773",
    "data-name": "\\uD328\\uC2A4 11773",
    d: "M1051.194,4355.625a.832.832,0,0,0-.009,1.574,3,3,0,0,0,2.718,0,.832.832,0,0,0,.009-1.575A2.993,2.993,0,0,0,1051.194,4355.625Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2093",
    "data-name": "\\uADF8\\uB8F9 2093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2092",
    "data-name": "\\uADF8\\uB8F9 2092",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2090",
    "data-name": "\\uADF8\\uB8F9 2090",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2089",
    "data-name": "\\uADF8\\uB8F9 2089",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2088",
    "data-name": "\\uADF8\\uB8F9 2088",
    style: {
      isolation: "isolate"
    }
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11774",
    "data-name": "\\uD328\\uC2A4 11774",
    d: "M1050.957,4355.79v.412a.792.792,0,0,0,.463.647,2.249,2.249,0,0,0,1.04.269v-.412a2.258,2.258,0,0,1-1.04-.269.79.79,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11775",
    "data-name": "\\uD328\\uC2A4 11775",
    d: "M1052.46,4356.706v.412a2.346,2.346,0,0,0,1.211-.269,1.1,1.1,0,0,0,.337-.285v-.412a1.1,1.1,0,0,1-.338.285,2.336,2.336,0,0,1-1.21.269Z",
    fill: "#3b3b45"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11776",
    "data-name": "\\uD328\\uC2A4 11776",
    d: "M1054.008,4356.152v.412a.615.615,0,0,0,.133-.371v-.412a.612.612,0,0,1-.133.371Z",
    fill: "#2e2e37"
  }))))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2091",
    "data-name": "\\uADF8\\uB8F9 2091"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11778",
    "data-name": "\\uD328\\uC2A4 11778",
    d: "M1051.427,4355.134a.688.688,0,0,0-.007,1.3,2.477,2.477,0,0,0,2.25,0,.689.689,0,0,0,.008-1.3A2.479,2.479,0,0,0,1051.427,4355.134Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2099",
    "data-name": "\\uADF8\\uB8F9 2099"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2098",
    "data-name": "\\uADF8\\uB8F9 2098",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2096",
    "data-name": "\\uADF8\\uB8F9 2096",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2095",
    "data-name": "\\uADF8\\uB8F9 2095",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2094",
    "data-name": "\\uADF8\\uB8F9 2094",
    style: {
      isolation: "isolate"
    }
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11779",
    "data-name": "\\uD328\\uC2A4 11779",
    d: "M1050.633,4355.162v.5a.95.95,0,0,0,.557.778,2.694,2.694,0,0,0,1.252.324l0-.5a2.7,2.7,0,0,1-1.251-.324.947.947,0,0,1-.557-.778Z",
    fill: "#2e2e37"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11780",
    "data-name": "\\uD328\\uC2A4 11780",
    d: "M1052.441,4356.264l0,.5a2.812,2.812,0,0,0,1.457-.323,1.334,1.334,0,0,0,.406-.344v-.5a1.346,1.346,0,0,1-.406.344,2.813,2.813,0,0,1-1.458.323Z",
    fill: "#3b3b45"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11781",
    "data-name": "\\uD328\\uC2A4 11781",
    d: "M1054.305,4355.6v.5a.736.736,0,0,0,.16-.446v-.5a.738.738,0,0,1-.16.446Z",
    fill: "#2e2e37"
  }))))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2097",
    "data-name": "\\uADF8\\uB8F9 2097"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11783",
    "data-name": "\\uD328\\uC2A4 11783",
    d: "M1051.2,4354.372a.828.828,0,0,0-.009,1.568,2.981,2.981,0,0,0,2.709,0,.829.829,0,0,0,.009-1.57A2.983,2.983,0,0,0,1051.2,4354.372Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2105",
    "data-name": "\\uADF8\\uB8F9 2105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2104",
    "data-name": "\\uADF8\\uB8F9 2104",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2102",
    "data-name": "\\uADF8\\uB8F9 2102",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2101",
    "data-name": "\\uADF8\\uB8F9 2101",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2100",
    "data-name": "\\uADF8\\uB8F9 2100",
    style: {
      isolation: "isolate"
    }
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11784",
    "data-name": "\\uD328\\uC2A4 11784",
    d: "M1050.957,4354.638v.412a.791.791,0,0,0,.463.647,2.226,2.226,0,0,0,1.04.269v-.412a2.234,2.234,0,0,1-1.04-.269.79.79,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11785",
    "data-name": "\\uD328\\uC2A4 11785",
    d: "M1052.46,4355.554v.412a2.341,2.341,0,0,0,1.211-.268,1.126,1.126,0,0,0,.337-.286V4355a1.112,1.112,0,0,1-.338.286,2.34,2.34,0,0,1-1.21.268Z",
    fill: "#3b3b45"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11786",
    "data-name": "\\uD328\\uC2A4 11786",
    d: "M1054.008,4355v.412a.612.612,0,0,0,.133-.371v-.412a.615.615,0,0,1-.133.371Z",
    fill: "#2e2e37"
  }))))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2103",
    "data-name": "\\uADF8\\uB8F9 2103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11788",
    "data-name": "\\uD328\\uC2A4 11788",
    d: "M1051.427,4353.982a.688.688,0,0,0-.007,1.3,2.48,2.48,0,0,0,2.25,0,.69.69,0,0,0,.008-1.305A2.482,2.482,0,0,0,1051.427,4353.982Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2111",
    "data-name": "\\uADF8\\uB8F9 2111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2110",
    "data-name": "\\uADF8\\uB8F9 2110",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2108",
    "data-name": "\\uADF8\\uB8F9 2108",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2107",
    "data-name": "\\uADF8\\uB8F9 2107",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2106",
    "data-name": "\\uADF8\\uB8F9 2106",
    style: {
      isolation: "isolate"
    }
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11789",
    "data-name": "\\uD328\\uC2A4 11789",
    d: "M1050.653,4354.013v.49a.942.942,0,0,0,.552.771,2.679,2.679,0,0,0,1.238.32l0-.491a2.664,2.664,0,0,1-1.238-.32.942.942,0,0,1-.551-.77Z",
    fill: "#2e2e37"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11790",
    "data-name": "\\uD328\\uC2A4 11790",
    d: "M1052.442,4355.1l0,.491a2.783,2.783,0,0,0,1.442-.32,1.313,1.313,0,0,0,.4-.34v-.49a1.334,1.334,0,0,1-.4.34,2.786,2.786,0,0,1-1.442.319Z",
    fill: "#3b3b45"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11791",
    "data-name": "\\uD328\\uC2A4 11791",
    d: "M1054.286,4354.444v.49a.73.73,0,0,0,.159-.442l0-.49a.725.725,0,0,1-.158.442Z",
    fill: "#2e2e37"
  }))))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2109",
    "data-name": "\\uADF8\\uB8F9 2109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11793",
    "data-name": "\\uD328\\uC2A4 11793",
    d: "M1051.213,4353.231a.82.82,0,0,0-.009,1.552,2.953,2.953,0,0,0,2.68,0,.821.821,0,0,0,.009-1.553A2.95,2.95,0,0,0,1051.213,4353.231Z",
    fill: "#434851"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2124",
    "data-name": "\\uADF8\\uB8F9 2124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2118",
    "data-name": "\\uADF8\\uB8F9 2118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2117",
    "data-name": "\\uADF8\\uB8F9 2117",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2115",
    "data-name": "\\uADF8\\uB8F9 2115"
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11794",
    "data-name": "\\uD328\\uC2A4 11794",
    d: "M1051.926,4352.309l-.92,1.513a.765.765,0,0,0,.448.627,2.407,2.407,0,0,0,2.182,0,.776.776,0,0,0,.456-.636l-.931-1.507a.31.31,0,0,1-.182.254.959.959,0,0,1-.873,0A.307.307,0,0,1,1051.926,4352.309Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2114",
    "data-name": "\\uADF8\\uB8F9 2114",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2113",
    "data-name": "\\uADF8\\uB8F9 2113",
    style: {
      isolation: "isolate"
    }
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11795",
    "data-name": "\\uD328\\uC2A4 11795",
    d: "M1051.926,4352.309l-.92,1.513a.765.765,0,0,0,.448.627,2.407,2.407,0,0,0,2.182,0,.776.776,0,0,0,.456-.636l-.931-1.507a.31.31,0,0,1-.182.254.959.959,0,0,1-.873,0,.307.307,0,0,1-.18-.251Z",
    fill: "#3b3b45"
  }))))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2116",
    "data-name": "\\uADF8\\uB8F9 2116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11797",
    "data-name": "\\uD328\\uC2A4 11797",
    d: "M1052.109,4352.055a.266.266,0,0,0,0,.5.959.959,0,0,0,.873,0,.267.267,0,0,0,0-.5A.957.957,0,0,0,1052.109,4352.055Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2123",
    "data-name": "\\uADF8\\uB8F9 2123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2122",
    "data-name": "\\uADF8\\uB8F9 2122",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2121",
    "data-name": "\\uADF8\\uB8F9 2121"
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11798",
    "data-name": "\\uD328\\uC2A4 11798",
    d: "M1051.931,4351.653l0,.651a.312.312,0,0,0,.18.252.966.966,0,0,0,.875,0,.312.312,0,0,0,.183-.256l0-.6a.311.311,0,0,1-.183.255.966.966,0,0,1-.875,0A.368.368,0,0,1,1051.931,4351.653Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2120",
    "data-name": "\\uADF8\\uB8F9 2120",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2119",
    "data-name": "\\uADF8\\uB8F9 2119",
    style: {
      isolation: "isolate"
    }
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11799",
    "data-name": "\\uD328\\uC2A4 11799",
    d: "M1051.926,4351.7l0,.6a.312.312,0,0,0,.18.252.966.966,0,0,0,.875,0,.312.312,0,0,0,.183-.256l0-.6a.311.311,0,0,1-.183.255.966.966,0,0,1-.875,0,.31.31,0,0,1-.18-.251Z",
    fill: "#e4e6f0"
  }))))))), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11801",
    "data-name": "\\uD328\\uC2A4 11801",
    d: "M1052.549,4352.315a.62.62,0,1,1,.62-.62.62.62,0,0,1-.62.62Z",
    fill: "#e4e6f0"
  }))))), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11802",
    "data-name": "\\uD328\\uC2A4 11802",
    d: "M1046.018,4355.862a.157.157,0,0,0,.083-.023l6.127-3.537a.167.167,0,0,0-.167-.29l-6.127,3.538a.167.167,0,0,0,.084.312Z",
    fill: "#35353f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2177",
    "data-name": "\\uADF8\\uB8F9 2177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2132",
    "data-name": "\\uADF8\\uB8F9 2132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2131",
    "data-name": "\\uADF8\\uB8F9 2131",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2129",
    "data-name": "\\uADF8\\uB8F9 2129"
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11803",
    "data-name": "\\uD328\\uC2A4 11803",
    d: "M1045.707,4360.426l0,2.983a.332.332,0,0,0,.193.27,1.035,1.035,0,0,0,.941,0,.334.334,0,0,0,.2-.274l0-2.983a.331.331,0,0,1-.2.275,1.038,1.038,0,0,1-.941,0A.331.331,0,0,1,1045.707,4360.426Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2128",
    "data-name": "\\uADF8\\uB8F9 2128",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2127",
    "data-name": "\\uADF8\\uB8F9 2127",
    style: {
      isolation: "isolate"
    }
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11804",
    "data-name": "\\uD328\\uC2A4 11804",
    d: "M1045.707,4360.426l0,2.983a.332.332,0,0,0,.193.27,1.035,1.035,0,0,0,.941,0,.334.334,0,0,0,.2-.274l0-2.983a.331.331,0,0,1-.2.275,1.038,1.038,0,0,1-.941,0,.331.331,0,0,1-.193-.271Z",
    fill: "#2e2e37"
  }))))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2130",
    "data-name": "\\uADF8\\uB8F9 2130"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11806",
    "data-name": "\\uD328\\uC2A4 11806",
    d: "M1045.9,4360.152a.288.288,0,0,0,0,.545,1.038,1.038,0,0,0,.941,0,.288.288,0,0,0,0-.545A1.035,1.035,0,0,0,1045.9,4360.152Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2176",
    "data-name": "\\uADF8\\uB8F9 2176"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2163",
    "data-name": "\\uADF8\\uB8F9 2163"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2138",
    "data-name": "\\uADF8\\uB8F9 2138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2137",
    "data-name": "\\uADF8\\uB8F9 2137",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2135",
    "data-name": "\\uADF8\\uB8F9 2135",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2134",
    "data-name": "\\uADF8\\uB8F9 2134",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2133",
    "data-name": "\\uADF8\\uB8F9 2133",
    style: {
      isolation: "isolate"
    }
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11807",
    "data-name": "\\uD328\\uC2A4 11807",
    d: "M1044.45,4360.31l0,.5a.955.955,0,0,0,.559.781,2.713,2.713,0,0,0,1.255.325v-.5a2.708,2.708,0,0,1-1.256-.325.954.954,0,0,1-.559-.781Z",
    fill: "#2e2e37"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11808",
    "data-name": "\\uD328\\uC2A4 11808",
    d: "M1046.265,4361.416v.5a2.834,2.834,0,0,0,1.463-.324,1.354,1.354,0,0,0,.407-.345v-.5a1.338,1.338,0,0,1-.408.345,2.824,2.824,0,0,1-1.462.324Z",
    fill: "#3b3b45"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11809",
    "data-name": "\\uD328\\uC2A4 11809",
    d: "M1048.135,4360.747v.5a.738.738,0,0,0,.16-.448v-.5a.741.741,0,0,1-.16.448Z",
    fill: "#2e2e37"
  }))))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2136",
    "data-name": "\\uADF8\\uB8F9 2136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11811",
    "data-name": "\\uD328\\uC2A4 11811",
    d: "M1045.018,4359.518a.831.831,0,0,0-.009,1.573,2.993,2.993,0,0,0,2.718,0,.832.832,0,0,0,.009-1.575A2.993,2.993,0,0,0,1045.018,4359.518Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2144",
    "data-name": "\\uADF8\\uB8F9 2144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2143",
    "data-name": "\\uADF8\\uB8F9 2143",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2141",
    "data-name": "\\uADF8\\uB8F9 2141",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2140",
    "data-name": "\\uADF8\\uB8F9 2140",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2139",
    "data-name": "\\uADF8\\uB8F9 2139",
    style: {
      isolation: "isolate"
    }
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11812",
    "data-name": "\\uD328\\uC2A4 11812",
    d: "M1044.781,4359.682v.412a.789.789,0,0,0,.463.647,2.246,2.246,0,0,0,1.04.27v-.412a2.246,2.246,0,0,1-1.04-.27.791.791,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11813",
    "data-name": "\\uD328\\uC2A4 11813",
    d: "M1046.284,4360.6v.412a2.346,2.346,0,0,0,1.211-.269,1.131,1.131,0,0,0,.337-.285v-.413a1.112,1.112,0,0,1-.338.286,2.34,2.34,0,0,1-1.21.269Z",
    fill: "#3b3b45"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11814",
    "data-name": "\\uD328\\uC2A4 11814",
    d: "M1047.832,4360.044v.413a.617.617,0,0,0,.133-.372v-.412a.612.612,0,0,1-.133.371Z",
    fill: "#2e2e37"
  }))))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2142",
    "data-name": "\\uADF8\\uB8F9 2142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11816",
    "data-name": "\\uD328\\uC2A4 11816",
    d: "M1045.251,4359.026a.688.688,0,0,0-.007,1.3,2.477,2.477,0,0,0,2.25,0,.689.689,0,0,0,.008-1.3A2.479,2.479,0,0,0,1045.251,4359.026Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2150",
    "data-name": "\\uADF8\\uB8F9 2150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2149",
    "data-name": "\\uADF8\\uB8F9 2149",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2147",
    "data-name": "\\uADF8\\uB8F9 2147",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2146",
    "data-name": "\\uADF8\\uB8F9 2146",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2145",
    "data-name": "\\uADF8\\uB8F9 2145",
    style: {
      isolation: "isolate"
    }
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11817",
    "data-name": "\\uD328\\uC2A4 11817",
    d: "M1044.457,4359.054v.5a.951.951,0,0,0,.557.779,2.7,2.7,0,0,0,1.252.324l0-.5a2.7,2.7,0,0,1-1.251-.324.95.95,0,0,1-.557-.779Z",
    fill: "#2e2e37"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11818",
    "data-name": "\\uD328\\uC2A4 11818",
    d: "M1046.265,4360.157l0,.5a2.821,2.821,0,0,0,1.457-.323,1.334,1.334,0,0,0,.406-.344v-.5a1.345,1.345,0,0,1-.406.344,2.823,2.823,0,0,1-1.458.323Z",
    fill: "#3b3b45"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11819",
    "data-name": "\\uD328\\uC2A4 11819",
    d: "M1048.129,4359.49v.5a.736.736,0,0,0,.16-.447v-.5a.739.739,0,0,1-.16.447Z",
    fill: "#2e2e37"
  }))))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2148",
    "data-name": "\\uADF8\\uB8F9 2148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11821",
    "data-name": "\\uD328\\uC2A4 11821",
    d: "M1045.023,4358.265a.828.828,0,0,0-.009,1.568,2.983,2.983,0,0,0,2.709,0,.829.829,0,0,0,.009-1.57A2.981,2.981,0,0,0,1045.023,4358.265Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2156",
    "data-name": "\\uADF8\\uB8F9 2156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2155",
    "data-name": "\\uADF8\\uB8F9 2155",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2153",
    "data-name": "\\uADF8\\uB8F9 2153",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2152",
    "data-name": "\\uADF8\\uB8F9 2152",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2151",
    "data-name": "\\uADF8\\uB8F9 2151",
    style: {
      isolation: "isolate"
    }
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11822",
    "data-name": "\\uD328\\uC2A4 11822",
    d: "M1044.781,4358.531v.412a.791.791,0,0,0,.463.647,2.24,2.24,0,0,0,1.04.269v-.412a2.252,2.252,0,0,1-1.04-.269.792.792,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11823",
    "data-name": "\\uD328\\uC2A4 11823",
    d: "M1046.284,4359.447v.412a2.337,2.337,0,0,0,1.211-.269,1.1,1.1,0,0,0,.337-.285v-.412a1.11,1.11,0,0,1-.338.285,2.335,2.335,0,0,1-1.21.269Z",
    fill: "#3b3b45"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11824",
    "data-name": "\\uD328\\uC2A4 11824",
    d: "M1047.832,4358.893v.412a.615.615,0,0,0,.133-.371v-.412a.615.615,0,0,1-.133.371Z",
    fill: "#2e2e37"
  }))))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2154",
    "data-name": "\\uADF8\\uB8F9 2154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11826",
    "data-name": "\\uD328\\uC2A4 11826",
    d: "M1045.251,4357.875a.688.688,0,0,0-.007,1.3,2.477,2.477,0,0,0,2.25,0,.689.689,0,0,0,.008-1.3A2.479,2.479,0,0,0,1045.251,4357.875Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2162",
    "data-name": "\\uADF8\\uB8F9 2162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2161",
    "data-name": "\\uADF8\\uB8F9 2161",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2159",
    "data-name": "\\uADF8\\uB8F9 2159",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2158",
    "data-name": "\\uADF8\\uB8F9 2158",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2157",
    "data-name": "\\uADF8\\uB8F9 2157",
    style: {
      isolation: "isolate"
    }
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11827",
    "data-name": "\\uD328\\uC2A4 11827",
    d: "M1044.477,4357.9l0,.491a.938.938,0,0,0,.551.77,2.661,2.661,0,0,0,1.238.321l0-.491a2.682,2.682,0,0,1-1.238-.32.942.942,0,0,1-.551-.771Z",
    fill: "#2e2e37"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11828",
    "data-name": "\\uD328\\uC2A4 11828",
    d: "M1046.266,4359l0,.491a2.788,2.788,0,0,0,1.442-.32,1.326,1.326,0,0,0,.4-.34v-.491a1.311,1.311,0,0,1-.4.34,2.776,2.776,0,0,1-1.442.32Z",
    fill: "#3b3b45"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11829",
    "data-name": "\\uD328\\uC2A4 11829",
    d: "M1048.11,4358.336v.491a.724.724,0,0,0,.158-.442v-.491a.721.721,0,0,1-.158.442Z",
    fill: "#2e2e37"
  }))))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2160",
    "data-name": "\\uADF8\\uB8F9 2160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11831",
    "data-name": "\\uD328\\uC2A4 11831",
    d: "M1045.037,4357.124a.82.82,0,0,0-.009,1.552,2.95,2.95,0,0,0,2.68,0,.82.82,0,0,0,.009-1.553A2.95,2.95,0,0,0,1045.037,4357.124Z",
    fill: "#434851"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2175",
    "data-name": "\\uADF8\\uB8F9 2175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2169",
    "data-name": "\\uADF8\\uB8F9 2169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2168",
    "data-name": "\\uADF8\\uB8F9 2168",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2166",
    "data-name": "\\uADF8\\uB8F9 2166"
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11832",
    "data-name": "\\uD328\\uC2A4 11832",
    d: "M1045.75,4356.2l-.92,1.512a.767.767,0,0,0,.448.628,2.4,2.4,0,0,0,2.182,0,.774.774,0,0,0,.456-.637l-.931-1.507a.31.31,0,0,1-.182.255.962.962,0,0,1-.873,0A.308.308,0,0,1,1045.75,4356.2Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2165",
    "data-name": "\\uADF8\\uB8F9 2165",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2164",
    "data-name": "\\uADF8\\uB8F9 2164",
    style: {
      isolation: "isolate"
    }
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11833",
    "data-name": "\\uD328\\uC2A4 11833",
    d: "M1045.75,4356.2l-.92,1.512a.767.767,0,0,0,.448.628,2.4,2.4,0,0,0,2.182,0,.774.774,0,0,0,.456-.637l-.931-1.507a.31.31,0,0,1-.182.255.962.962,0,0,1-.873,0,.308.308,0,0,1-.18-.251Z",
    fill: "#3b3b45"
  }))))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2167",
    "data-name": "\\uADF8\\uB8F9 2167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11835",
    "data-name": "\\uD328\\uC2A4 11835",
    d: "M1045.933,4355.947a.268.268,0,0,0,0,.506.962.962,0,0,0,.873,0,.268.268,0,0,0,0-.506A.966.966,0,0,0,1045.933,4355.947Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2174",
    "data-name": "\\uADF8\\uB8F9 2174"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2173",
    "data-name": "\\uADF8\\uB8F9 2173",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2172",
    "data-name": "\\uADF8\\uB8F9 2172"
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11836",
    "data-name": "\\uD328\\uC2A4 11836",
    d: "M1045.755,4355.546l0,.651a.31.31,0,0,0,.18.251.966.966,0,0,0,.875,0,.311.311,0,0,0,.183-.255l0-.6a.311.311,0,0,1-.183.255.963.963,0,0,1-.875,0A.368.368,0,0,1,1045.755,4355.546Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2171",
    "data-name": "\\uADF8\\uB8F9 2171",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2170",
    "data-name": "\\uADF8\\uB8F9 2170",
    style: {
      isolation: "isolate"
    }
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11837",
    "data-name": "\\uD328\\uC2A4 11837",
    d: "M1045.75,4355.591l0,.606a.31.31,0,0,0,.18.251.966.966,0,0,0,.875,0,.311.311,0,0,0,.183-.255l0-.6a.311.311,0,0,1-.183.255.963.963,0,0,1-.875,0,.311.311,0,0,1-.18-.252Z",
    fill: "#e4e6f0"
  }))))))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_79",
    "data-name": "\\uD0C0\\uC6D0 79",
    cx: 0.62,
    cy: 0.62,
    r: 0.62,
    transform: "translate(1045.753 4354.968)",
    fill: "#e4e6f0"
  }))))), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11839",
    "data-name": "\\uD328\\uC2A4 11839",
    d: "M1036.549,4380.425a.167.167,0,0,0,.167-.166c.007-.75-.029-1.844-.07-3.111-.1-3.063-.237-7.257.192-9.208.724-3.29,2.861-8.017,8.935-11.86.406-.257.458-.29.416-.429a.175.175,0,0,0-.171-.124h0a.168.168,0,0,0-.148.094c-.056.039-.162.106-.272.176-6.172,3.9-8.346,8.719-9.084,12.071-.438,1.992-.306,6.039-.2,9.291.041,1.263.076,2.354.069,3.1a.168.168,0,0,0,.166.169Z",
    fill: "#35353f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2386",
    "data-name": "\\uADF8\\uB8F9 2386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2282",
    "data-name": "\\uADF8\\uB8F9 2282"
  }, _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_972",
    "data-name": "\\uC0AC\\uAC01\\uD615 972",
    width: 8.038,
    height: 0.335,
    transform: "translate(1016.097 4331.13) rotate(-30)",
    fill: "#35353f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2230",
    "data-name": "\\uADF8\\uB8F9 2230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2185",
    "data-name": "\\uADF8\\uB8F9 2185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2184",
    "data-name": "\\uADF8\\uB8F9 2184",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2182",
    "data-name": "\\uADF8\\uB8F9 2182"
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11840",
    "data-name": "\\uD328\\uC2A4 11840",
    d: "M1015.919,4335.652l0,2.982a.332.332,0,0,0,.194.271,1.038,1.038,0,0,0,.941,0,.333.333,0,0,0,.2-.275l0-2.982a.332.332,0,0,1-.2.274,1.032,1.032,0,0,1-.941,0A.332.332,0,0,1,1015.919,4335.652Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2181",
    "data-name": "\\uADF8\\uB8F9 2181",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2180",
    "data-name": "\\uADF8\\uB8F9 2180",
    style: {
      isolation: "isolate"
    }
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11841",
    "data-name": "\\uD328\\uC2A4 11841",
    d: "M1015.919,4335.652l0,2.982a.332.332,0,0,0,.194.271,1.038,1.038,0,0,0,.941,0,.333.333,0,0,0,.2-.275l0-2.982a.332.332,0,0,1-.2.274,1.032,1.032,0,0,1-.941,0,.332.332,0,0,1-.193-.27Z",
    fill: "#2e2e37"
  }))))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2183",
    "data-name": "\\uADF8\\uB8F9 2183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11843",
    "data-name": "\\uD328\\uC2A4 11843",
    d: "M1016.116,4335.377a.288.288,0,0,0,0,.545,1.032,1.032,0,0,0,.941,0,.288.288,0,0,0,0-.545A1.039,1.039,0,0,0,1016.116,4335.377Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2229",
    "data-name": "\\uADF8\\uB8F9 2229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2216",
    "data-name": "\\uADF8\\uB8F9 2216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2191",
    "data-name": "\\uADF8\\uB8F9 2191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2190",
    "data-name": "\\uADF8\\uB8F9 2190",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2188",
    "data-name": "\\uADF8\\uB8F9 2188",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2187",
    "data-name": "\\uADF8\\uB8F9 2187",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2186",
    "data-name": "\\uADF8\\uB8F9 2186",
    style: {
      isolation: "isolate"
    }
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11844",
    "data-name": "\\uD328\\uC2A4 11844",
    d: "M1014.663,4335.535v.5a.954.954,0,0,0,.559.781,2.7,2.7,0,0,0,1.256.325l0-.5a2.72,2.72,0,0,1-1.256-.325.954.954,0,0,1-.558-.782Z",
    fill: "#2e2e37"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11845",
    "data-name": "\\uD328\\uC2A4 11845",
    d: "M1016.477,4336.642l0,.5a2.818,2.818,0,0,0,1.462-.324,1.34,1.34,0,0,0,.407-.345v-.5a1.331,1.331,0,0,1-.408.344,2.819,2.819,0,0,1-1.462.325Z",
    fill: "#3b3b45"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11846",
    "data-name": "\\uD328\\uC2A4 11846",
    d: "M1018.347,4335.973v.5a.737.737,0,0,0,.161-.448l0-.5a.74.74,0,0,1-.16.449Z",
    fill: "#2e2e37"
  }))))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2189",
    "data-name": "\\uADF8\\uB8F9 2189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11848",
    "data-name": "\\uD328\\uC2A4 11848",
    d: "M1015.23,4334.743a.831.831,0,0,0-.009,1.574,2.99,2.99,0,0,0,2.718,0,.832.832,0,0,0,.009-1.575A2.993,2.993,0,0,0,1015.23,4334.743Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2197",
    "data-name": "\\uADF8\\uB8F9 2197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2196",
    "data-name": "\\uADF8\\uB8F9 2196",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2194",
    "data-name": "\\uADF8\\uB8F9 2194",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2193",
    "data-name": "\\uADF8\\uB8F9 2193",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2192",
    "data-name": "\\uADF8\\uB8F9 2192",
    style: {
      isolation: "isolate"
    }
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11849",
    "data-name": "\\uD328\\uC2A4 11849",
    d: "M1014.993,4334.908v.412a.791.791,0,0,0,.463.647,2.243,2.243,0,0,0,1.04.269v-.412a2.249,2.249,0,0,1-1.04-.269.792.792,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11850",
    "data-name": "\\uD328\\uC2A4 11850",
    d: "M1016.5,4335.824v.412a2.334,2.334,0,0,0,1.211-.268,1.106,1.106,0,0,0,.337-.286v-.412a1.107,1.107,0,0,1-.337.286,2.346,2.346,0,0,1-1.211.268Z",
    fill: "#3b3b45"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11851",
    "data-name": "\\uD328\\uC2A4 11851",
    d: "M1018.044,4335.27v.412a.615.615,0,0,0,.133-.371v-.412a.615.615,0,0,1-.133.371Z",
    fill: "#2e2e37"
  }))))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2195",
    "data-name": "\\uADF8\\uB8F9 2195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11853",
    "data-name": "\\uD328\\uC2A4 11853",
    d: "M1015.463,4334.252a.688.688,0,0,0-.007,1.3,2.482,2.482,0,0,0,2.251,0,.69.69,0,0,0,.007-1.305A2.482,2.482,0,0,0,1015.463,4334.252Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2203",
    "data-name": "\\uADF8\\uB8F9 2203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2202",
    "data-name": "\\uADF8\\uB8F9 2202",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2200",
    "data-name": "\\uADF8\\uB8F9 2200",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2199",
    "data-name": "\\uADF8\\uB8F9 2199",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2198",
    "data-name": "\\uADF8\\uB8F9 2198",
    style: {
      isolation: "isolate"
    }
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11854",
    "data-name": "\\uD328\\uC2A4 11854",
    d: "M1014.669,4334.28v.5a.952.952,0,0,0,.557.778,2.709,2.709,0,0,0,1.252.324v-.5a2.711,2.711,0,0,1-1.252-.323.952.952,0,0,1-.557-.779Z",
    fill: "#2e2e37"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11855",
    "data-name": "\\uD328\\uC2A4 11855",
    d: "M1016.478,4335.382v.5a2.8,2.8,0,0,0,1.457-.323,1.346,1.346,0,0,0,.406-.343v-.5a1.346,1.346,0,0,1-.406.343,2.8,2.8,0,0,1-1.457.323Z",
    fill: "#3b3b45"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11856",
    "data-name": "\\uD328\\uC2A4 11856",
    d: "M1018.341,4334.716v.5a.736.736,0,0,0,.16-.447v-.5a.741.741,0,0,1-.16.447Z",
    fill: "#2e2e37"
  }))))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2201",
    "data-name": "\\uADF8\\uB8F9 2201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11858",
    "data-name": "\\uD328\\uC2A4 11858",
    d: "M1015.235,4333.49a.829.829,0,0,0-.009,1.569,2.983,2.983,0,0,0,2.709,0,.83.83,0,0,0,.009-1.57A2.985,2.985,0,0,0,1015.235,4333.49Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2209",
    "data-name": "\\uADF8\\uB8F9 2209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2208",
    "data-name": "\\uADF8\\uB8F9 2208",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2206",
    "data-name": "\\uADF8\\uB8F9 2206",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2205",
    "data-name": "\\uADF8\\uB8F9 2205",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2204",
    "data-name": "\\uADF8\\uB8F9 2204",
    style: {
      isolation: "isolate"
    }
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11859",
    "data-name": "\\uD328\\uC2A4 11859",
    d: "M1014.993,4333.756v.412a.791.791,0,0,0,.463.647,2.232,2.232,0,0,0,1.04.269v-.412a2.232,2.232,0,0,1-1.04-.269.791.791,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11860",
    "data-name": "\\uD328\\uC2A4 11860",
    d: "M1016.5,4334.672v.412a2.339,2.339,0,0,0,1.211-.268,1.107,1.107,0,0,0,.337-.286v-.412a1.106,1.106,0,0,1-.337.286,2.336,2.336,0,0,1-1.211.268Z",
    fill: "#3b3b45"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11861",
    "data-name": "\\uD328\\uC2A4 11861",
    d: "M1018.044,4334.118v.412a.61.61,0,0,0,.133-.371v-.412a.612.612,0,0,1-.133.371Z",
    fill: "#2e2e37"
  }))))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2207",
    "data-name": "\\uADF8\\uB8F9 2207"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11863",
    "data-name": "\\uD328\\uC2A4 11863",
    d: "M1015.463,4333.1a.688.688,0,0,0-.007,1.3,2.479,2.479,0,0,0,2.251,0,.689.689,0,0,0,.007-1.3A2.48,2.48,0,0,0,1015.463,4333.1Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2215",
    "data-name": "\\uADF8\\uB8F9 2215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2214",
    "data-name": "\\uADF8\\uB8F9 2214",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2212",
    "data-name": "\\uADF8\\uB8F9 2212",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2211",
    "data-name": "\\uADF8\\uB8F9 2211",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2210",
    "data-name": "\\uADF8\\uB8F9 2210",
    style: {
      isolation: "isolate"
    }
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11864",
    "data-name": "\\uD328\\uC2A4 11864",
    d: "M1014.689,4333.131l0,.49a.942.942,0,0,0,.551.771,2.682,2.682,0,0,0,1.238.32v-.49a2.675,2.675,0,0,1-1.239-.321.943.943,0,0,1-.551-.77Z",
    fill: "#2e2e37"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11865",
    "data-name": "\\uD328\\uC2A4 11865",
    d: "M1016.479,4334.222v.49a2.776,2.776,0,0,0,1.442-.32,1.305,1.305,0,0,0,.4-.34l0-.49a1.34,1.34,0,0,1-.4.34,2.793,2.793,0,0,1-1.442.32Z",
    fill: "#3b3b45"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11866",
    "data-name": "\\uD328\\uC2A4 11866",
    d: "M1018.322,4333.562l0,.49a.725.725,0,0,0,.158-.441l0-.491a.726.726,0,0,1-.158.442Z",
    fill: "#2e2e37"
  }))))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2213",
    "data-name": "\\uADF8\\uB8F9 2213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11868",
    "data-name": "\\uD328\\uC2A4 11868",
    d: "M1015.249,4332.349a.82.82,0,0,0-.009,1.552,2.952,2.952,0,0,0,2.681,0,.82.82,0,0,0,.008-1.553A2.95,2.95,0,0,0,1015.249,4332.349Z",
    fill: "#434851"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2228",
    "data-name": "\\uADF8\\uB8F9 2228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2222",
    "data-name": "\\uADF8\\uB8F9 2222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2221",
    "data-name": "\\uADF8\\uB8F9 2221",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2219",
    "data-name": "\\uADF8\\uB8F9 2219"
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11869",
    "data-name": "\\uD328\\uC2A4 11869",
    d: "M1015.963,4331.427l-.921,1.513a.766.766,0,0,0,.448.627,2.406,2.406,0,0,0,2.183,0,.77.77,0,0,0,.455-.636l-.931-1.507a.31.31,0,0,1-.182.254.962.962,0,0,1-.873,0A.306.306,0,0,1,1015.963,4331.427Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2218",
    "data-name": "\\uADF8\\uB8F9 2218",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2217",
    "data-name": "\\uADF8\\uB8F9 2217",
    style: {
      isolation: "isolate"
    }
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11870",
    "data-name": "\\uD328\\uC2A4 11870",
    d: "M1015.963,4331.427l-.921,1.513a.766.766,0,0,0,.448.627,2.406,2.406,0,0,0,2.183,0,.77.77,0,0,0,.455-.636l-.931-1.507a.31.31,0,0,1-.182.254.962.962,0,0,1-.873,0,.306.306,0,0,1-.179-.251Z",
    fill: "#3b3b45"
  }))))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2220",
    "data-name": "\\uADF8\\uB8F9 2220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11872",
    "data-name": "\\uD328\\uC2A4 11872",
    d: "M1016.145,4331.173a.267.267,0,0,0,0,.505.962.962,0,0,0,.873,0,.267.267,0,0,0,0-.505A.962.962,0,0,0,1016.145,4331.173Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2227",
    "data-name": "\\uADF8\\uB8F9 2227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2226",
    "data-name": "\\uADF8\\uB8F9 2226",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2225",
    "data-name": "\\uADF8\\uB8F9 2225"
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11873",
    "data-name": "\\uD328\\uC2A4 11873",
    d: "M1015.967,4330.771l0,.651a.308.308,0,0,0,.179.252.965.965,0,0,0,.876,0,.311.311,0,0,0,.182-.255l0-.606a.31.31,0,0,1-.183.255.963.963,0,0,1-.875,0A.367.367,0,0,1,1015.967,4330.771Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2224",
    "data-name": "\\uADF8\\uB8F9 2224",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2223",
    "data-name": "\\uADF8\\uB8F9 2223",
    style: {
      isolation: "isolate"
    }
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11874",
    "data-name": "\\uD328\\uC2A4 11874",
    d: "M1015.963,4330.817l0,.6a.308.308,0,0,0,.179.252.965.965,0,0,0,.876,0,.311.311,0,0,0,.182-.255l0-.606a.31.31,0,0,1-.183.255.963.963,0,0,1-.875,0,.3.3,0,0,1-.179-.251Z",
    fill: "#e4e6f0"
  }))))))), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11876",
    "data-name": "\\uD328\\uC2A4 11876",
    d: "M1016.585,4331.433a.62.62,0,1,1,.62-.62.62.62,0,0,1-.62.62Z",
    fill: "#e4e6f0"
  }))))), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11877",
    "data-name": "\\uD328\\uC2A4 11877",
    d: "M1010.054,4334.98a.157.157,0,0,0,.083-.023l6.128-3.537a.168.168,0,0,0-.168-.29l-6.127,3.538a.167.167,0,0,0,.084.312Z",
    fill: "#35353f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2281",
    "data-name": "\\uADF8\\uB8F9 2281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2236",
    "data-name": "\\uADF8\\uB8F9 2236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2235",
    "data-name": "\\uADF8\\uB8F9 2235",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2233",
    "data-name": "\\uADF8\\uB8F9 2233"
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11878",
    "data-name": "\\uD328\\uC2A4 11878",
    d: "M1009.743,4339.544l0,2.983a.326.326,0,0,0,.193.27,1.032,1.032,0,0,0,.941,0,.332.332,0,0,0,.2-.274l0-2.983a.335.335,0,0,1-.2.275,1.039,1.039,0,0,1-.94,0A.33.33,0,0,1,1009.743,4339.544Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2232",
    "data-name": "\\uADF8\\uB8F9 2232",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2231",
    "data-name": "\\uADF8\\uB8F9 2231",
    style: {
      isolation: "isolate"
    }
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11879",
    "data-name": "\\uD328\\uC2A4 11879",
    d: "M1009.743,4339.544l0,2.983a.326.326,0,0,0,.193.27,1.032,1.032,0,0,0,.941,0,.332.332,0,0,0,.2-.274l0-2.983a.335.335,0,0,1-.2.275,1.039,1.039,0,0,1-.94,0,.33.33,0,0,1-.194-.271Z",
    fill: "#2e2e37"
  }))))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2234",
    "data-name": "\\uADF8\\uB8F9 2234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11881",
    "data-name": "\\uD328\\uC2A4 11881",
    d: "M1009.94,4339.27a.288.288,0,0,0,0,.545,1.039,1.039,0,0,0,.94,0,.288.288,0,0,0,0-.545A1.033,1.033,0,0,0,1009.94,4339.27Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2280",
    "data-name": "\\uADF8\\uB8F9 2280"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2267",
    "data-name": "\\uADF8\\uB8F9 2267"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2242",
    "data-name": "\\uADF8\\uB8F9 2242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2241",
    "data-name": "\\uADF8\\uB8F9 2241",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2239",
    "data-name": "\\uADF8\\uB8F9 2239",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2238",
    "data-name": "\\uADF8\\uB8F9 2238",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2237",
    "data-name": "\\uADF8\\uB8F9 2237",
    style: {
      isolation: "isolate"
    }
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11882",
    "data-name": "\\uD328\\uC2A4 11882",
    d: "M1008.487,4339.428v.5a.955.955,0,0,0,.559.781,2.714,2.714,0,0,0,1.256.325l0-.5a2.708,2.708,0,0,1-1.256-.325.95.95,0,0,1-.558-.781Z",
    fill: "#2e2e37"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11883",
    "data-name": "\\uD328\\uC2A4 11883",
    d: "M1010.3,4340.534l0,.5a2.836,2.836,0,0,0,1.462-.324,1.354,1.354,0,0,0,.407-.345v-.5a1.333,1.333,0,0,1-.408.345,2.814,2.814,0,0,1-1.462.324Z",
    fill: "#3b3b45"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11884",
    "data-name": "\\uD328\\uC2A4 11884",
    d: "M1012.171,4339.865v.5a.738.738,0,0,0,.161-.448l0-.5a.736.736,0,0,1-.16.448Z",
    fill: "#2e2e37"
  }))))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2240",
    "data-name": "\\uADF8\\uB8F9 2240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11886",
    "data-name": "\\uD328\\uC2A4 11886",
    d: "M1009.054,4338.636a.831.831,0,0,0-.009,1.573,2.993,2.993,0,0,0,2.718,0,.832.832,0,0,0,.009-1.575A3,3,0,0,0,1009.054,4338.636Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2248",
    "data-name": "\\uADF8\\uB8F9 2248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2247",
    "data-name": "\\uADF8\\uB8F9 2247",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2245",
    "data-name": "\\uADF8\\uB8F9 2245",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2244",
    "data-name": "\\uADF8\\uB8F9 2244",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2243",
    "data-name": "\\uADF8\\uB8F9 2243",
    style: {
      isolation: "isolate"
    }
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11887",
    "data-name": "\\uD328\\uC2A4 11887",
    d: "M1008.817,4338.8v.413a.791.791,0,0,0,.463.647,2.255,2.255,0,0,0,1.04.269v-.412a2.255,2.255,0,0,1-1.04-.269.792.792,0,0,1-.463-.648Z",
    fill: "#2e2e37"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11888",
    "data-name": "\\uD328\\uC2A4 11888",
    d: "M1010.32,4339.717v.412a2.334,2.334,0,0,0,1.211-.269,1.118,1.118,0,0,0,.337-.285v-.412a1.126,1.126,0,0,1-.337.285,2.341,2.341,0,0,1-1.211.269Z",
    fill: "#3b3b45"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11889",
    "data-name": "\\uD328\\uC2A4 11889",
    d: "M1011.868,4339.163v.412a.615.615,0,0,0,.133-.372v-.412a.617.617,0,0,1-.133.372Z",
    fill: "#2e2e37"
  }))))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2246",
    "data-name": "\\uADF8\\uB8F9 2246"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11891",
    "data-name": "\\uD328\\uC2A4 11891",
    d: "M1009.287,4338.144a.689.689,0,0,0-.007,1.3,2.482,2.482,0,0,0,2.251,0,.689.689,0,0,0,.007-1.3A2.482,2.482,0,0,0,1009.287,4338.144Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2254",
    "data-name": "\\uADF8\\uB8F9 2254"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2253",
    "data-name": "\\uADF8\\uB8F9 2253",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2251",
    "data-name": "\\uADF8\\uB8F9 2251",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2250",
    "data-name": "\\uADF8\\uB8F9 2250",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2249",
    "data-name": "\\uADF8\\uB8F9 2249",
    style: {
      isolation: "isolate"
    }
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11892",
    "data-name": "\\uD328\\uC2A4 11892",
    d: "M1008.493,4338.172v.5a.952.952,0,0,0,.557.779,2.7,2.7,0,0,0,1.252.324l0-.5a2.7,2.7,0,0,1-1.251-.324.951.951,0,0,1-.557-.779Z",
    fill: "#2e2e37"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11893",
    "data-name": "\\uD328\\uC2A4 11893",
    d: "M1010.3,4339.275l0,.5a2.812,2.812,0,0,0,1.457-.323,1.334,1.334,0,0,0,.406-.344v-.5a1.334,1.334,0,0,1-.406.344,2.813,2.813,0,0,1-1.458.323Z",
    fill: "#3b3b45"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11894",
    "data-name": "\\uD328\\uC2A4 11894",
    d: "M1012.165,4338.608v.5a.731.731,0,0,0,.16-.447v-.5a.738.738,0,0,1-.16.447Z",
    fill: "#2e2e37"
  }))))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2252",
    "data-name": "\\uADF8\\uB8F9 2252"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11896",
    "data-name": "\\uD328\\uC2A4 11896",
    d: "M1009.059,4337.383a.828.828,0,0,0-.009,1.568,2.986,2.986,0,0,0,2.709,0,.83.83,0,0,0,.009-1.57A2.983,2.983,0,0,0,1009.059,4337.383Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2260",
    "data-name": "\\uADF8\\uB8F9 2260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2259",
    "data-name": "\\uADF8\\uB8F9 2259",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2257",
    "data-name": "\\uADF8\\uB8F9 2257",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2256",
    "data-name": "\\uADF8\\uB8F9 2256",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2255",
    "data-name": "\\uADF8\\uB8F9 2255",
    style: {
      isolation: "isolate"
    }
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11897",
    "data-name": "\\uD328\\uC2A4 11897",
    d: "M1008.817,4337.649v.412a.792.792,0,0,0,.463.647,2.249,2.249,0,0,0,1.04.269v-.412a2.255,2.255,0,0,1-1.04-.269.791.791,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11898",
    "data-name": "\\uD328\\uC2A4 11898",
    d: "M1010.32,4338.565v.412a2.339,2.339,0,0,0,1.211-.269,1.092,1.092,0,0,0,.337-.285v-.412a1.091,1.091,0,0,1-.337.285,2.341,2.341,0,0,1-1.211.269Z",
    fill: "#3b3b45"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11899",
    "data-name": "\\uD328\\uC2A4 11899",
    d: "M1011.868,4338.011v.412a.612.612,0,0,0,.133-.371v-.412a.615.615,0,0,1-.133.371Z",
    fill: "#2e2e37"
  }))))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2258",
    "data-name": "\\uADF8\\uB8F9 2258"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11901",
    "data-name": "\\uD328\\uC2A4 11901",
    d: "M1009.287,4336.993a.688.688,0,0,0-.007,1.3,2.477,2.477,0,0,0,2.251,0,.689.689,0,0,0,.007-1.3A2.476,2.476,0,0,0,1009.287,4336.993Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2266",
    "data-name": "\\uADF8\\uB8F9 2266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2265",
    "data-name": "\\uADF8\\uB8F9 2265",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2263",
    "data-name": "\\uADF8\\uB8F9 2263",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2262",
    "data-name": "\\uADF8\\uB8F9 2262",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2261",
    "data-name": "\\uADF8\\uB8F9 2261",
    style: {
      isolation: "isolate"
    }
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11902",
    "data-name": "\\uD328\\uC2A4 11902",
    d: "M1008.513,4337.023l0,.491a.941.941,0,0,0,.551.77,2.677,2.677,0,0,0,1.238.321v-.491a2.68,2.68,0,0,1-1.239-.32.943.943,0,0,1-.551-.771Z",
    fill: "#2e2e37"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11903",
    "data-name": "\\uD328\\uC2A4 11903",
    d: "M1010.3,4338.114v.491a2.786,2.786,0,0,0,1.442-.32,1.332,1.332,0,0,0,.4-.34l0-.491a1.312,1.312,0,0,1-.4.34,2.781,2.781,0,0,1-1.442.32Z",
    fill: "#3b3b45"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11904",
    "data-name": "\\uD328\\uC2A4 11904",
    d: "M1012.146,4337.454l0,.491a.736.736,0,0,0,.158-.442l0-.491a.722.722,0,0,1-.158.442Z",
    fill: "#2e2e37"
  }))))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2264",
    "data-name": "\\uADF8\\uB8F9 2264"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11906",
    "data-name": "\\uD328\\uC2A4 11906",
    d: "M1009.073,4336.242a.82.82,0,0,0-.009,1.552,2.952,2.952,0,0,0,2.681,0,.82.82,0,0,0,.008-1.553A2.95,2.95,0,0,0,1009.073,4336.242Z",
    fill: "#434851"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2279",
    "data-name": "\\uADF8\\uB8F9 2279"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2273",
    "data-name": "\\uADF8\\uB8F9 2273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2272",
    "data-name": "\\uADF8\\uB8F9 2272",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2270",
    "data-name": "\\uADF8\\uB8F9 2270"
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11907",
    "data-name": "\\uD328\\uC2A4 11907",
    d: "M1009.787,4335.32l-.921,1.512a.767.767,0,0,0,.448.628,2.406,2.406,0,0,0,2.183,0,.771.771,0,0,0,.455-.636l-.931-1.507a.309.309,0,0,1-.182.254.959.959,0,0,1-.873,0A.3.3,0,0,1,1009.787,4335.32Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2269",
    "data-name": "\\uADF8\\uB8F9 2269",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2268",
    "data-name": "\\uADF8\\uB8F9 2268",
    style: {
      isolation: "isolate"
    }
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11908",
    "data-name": "\\uD328\\uC2A4 11908",
    d: "M1009.787,4335.32l-.921,1.512a.767.767,0,0,0,.448.628,2.406,2.406,0,0,0,2.183,0,.771.771,0,0,0,.455-.636l-.931-1.507a.309.309,0,0,1-.182.254.959.959,0,0,1-.873,0,.3.3,0,0,1-.179-.251Z",
    fill: "#3b3b45"
  }))))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2271",
    "data-name": "\\uADF8\\uB8F9 2271"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11910",
    "data-name": "\\uD328\\uC2A4 11910",
    d: "M1009.969,4335.066a.267.267,0,0,0,0,.5.959.959,0,0,0,.873,0,.267.267,0,0,0,0-.5A.959.959,0,0,0,1009.969,4335.066Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2278",
    "data-name": "\\uADF8\\uB8F9 2278"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2277",
    "data-name": "\\uADF8\\uB8F9 2277",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2276",
    "data-name": "\\uADF8\\uB8F9 2276"
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11911",
    "data-name": "\\uD328\\uC2A4 11911",
    d: "M1009.791,4334.664l0,.651a.3.3,0,0,0,.18.251.963.963,0,0,0,.875,0,.308.308,0,0,0,.182-.255l0-.6a.31.31,0,0,1-.183.255.963.963,0,0,1-.875,0A.367.367,0,0,1,1009.791,4334.664Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2275",
    "data-name": "\\uADF8\\uB8F9 2275",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2274",
    "data-name": "\\uADF8\\uB8F9 2274",
    style: {
      isolation: "isolate"
    }
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11912",
    "data-name": "\\uD328\\uC2A4 11912",
    d: "M1009.787,4334.709l0,.606a.3.3,0,0,0,.18.251.963.963,0,0,0,.875,0,.308.308,0,0,0,.182-.255l0-.6a.31.31,0,0,1-.183.255.963.963,0,0,1-.875,0,.307.307,0,0,1-.179-.252Z",
    fill: "#e4e6f0"
  }))))))), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11914",
    "data-name": "\\uD328\\uC2A4 11914",
    d: "M1009.79,4334.706a.62.62,0,1,1,.619.62A.62.62,0,0,1,1009.79,4334.706Z",
    fill: "#e4e6f0"
  }))))), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11915",
    "data-name": "\\uD328\\uC2A4 11915",
    d: "M1000.439,4340.531a.165.165,0,0,0,.083-.022l9.615-5.552a.167.167,0,1,0-.167-.289l-9.615,5.551a.167.167,0,0,0,.084.312Z",
    fill: "#35353f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2385",
    "data-name": "\\uADF8\\uB8F9 2385"
  }, _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_973",
    "data-name": "\\uC0AC\\uAC01\\uD615 973",
    width: 8.038,
    height: 0.335,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 1019.935, 4333.188)",
    fill: "#35353f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2333",
    "data-name": "\\uADF8\\uB8F9 2333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2288",
    "data-name": "\\uADF8\\uB8F9 2288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2287",
    "data-name": "\\uADF8\\uB8F9 2287",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2285",
    "data-name": "\\uADF8\\uB8F9 2285"
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11916",
    "data-name": "\\uD328\\uC2A4 11916",
    d: "M1019.757,4337.709l0,2.983a.332.332,0,0,0,.194.271,1.039,1.039,0,0,0,.94,0,.332.332,0,0,0,.2-.275l0-2.982a.335.335,0,0,1-.2.274,1.035,1.035,0,0,1-.941,0A.332.332,0,0,1,1019.757,4337.709Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2284",
    "data-name": "\\uADF8\\uB8F9 2284",
    clipPath: "url(#clip-path-50)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2283",
    "data-name": "\\uADF8\\uB8F9 2283",
    style: {
      isolation: "isolate"
    }
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11917",
    "data-name": "\\uD328\\uC2A4 11917",
    d: "M1019.757,4337.709l0,2.983a.332.332,0,0,0,.194.271,1.039,1.039,0,0,0,.94,0,.332.332,0,0,0,.2-.275l0-2.982a.335.335,0,0,1-.2.274,1.035,1.035,0,0,1-.941,0,.332.332,0,0,1-.193-.271Z",
    fill: "#2e2e37"
  }))))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2286",
    "data-name": "\\uADF8\\uB8F9 2286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11919",
    "data-name": "\\uD328\\uC2A4 11919",
    d: "M1019.954,4337.435a.288.288,0,0,0,0,.545,1.035,1.035,0,0,0,.941,0,.288.288,0,0,0,0-.545A1.039,1.039,0,0,0,1019.954,4337.435Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2332",
    "data-name": "\\uADF8\\uB8F9 2332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2319",
    "data-name": "\\uADF8\\uB8F9 2319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2294",
    "data-name": "\\uADF8\\uB8F9 2294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2293",
    "data-name": "\\uADF8\\uB8F9 2293",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2291",
    "data-name": "\\uADF8\\uB8F9 2291",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2290",
    "data-name": "\\uADF8\\uB8F9 2290",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2289",
    "data-name": "\\uADF8\\uB8F9 2289",
    style: {
      isolation: "isolate"
    }
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11920",
    "data-name": "\\uD328\\uC2A4 11920",
    d: "M1018.5,4337.593l0,.5a.954.954,0,0,0,.559.781,2.7,2.7,0,0,0,1.256.325l0-.5a2.72,2.72,0,0,1-1.256-.325.955.955,0,0,1-.559-.782Z",
    fill: "#2e2e37"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11921",
    "data-name": "\\uD328\\uC2A4 11921",
    d: "M1020.315,4338.7l0,.5a2.823,2.823,0,0,0,1.462-.324,1.341,1.341,0,0,0,.407-.345v-.5a1.331,1.331,0,0,1-.408.344,2.824,2.824,0,0,1-1.462.325Z",
    fill: "#3b3b45"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11922",
    "data-name": "\\uD328\\uC2A4 11922",
    d: "M1022.185,4338.031v.5a.734.734,0,0,0,.161-.448l0-.5a.738.738,0,0,1-.16.449Z",
    fill: "#2e2e37"
  }))))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2292",
    "data-name": "\\uADF8\\uB8F9 2292"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11924",
    "data-name": "\\uD328\\uC2A4 11924",
    d: "M1019.068,4336.8a.832.832,0,0,0-.009,1.574,2.993,2.993,0,0,0,2.718,0,.832.832,0,0,0,.009-1.575A3,3,0,0,0,1019.068,4336.8Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2300",
    "data-name": "\\uADF8\\uB8F9 2300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2299",
    "data-name": "\\uADF8\\uB8F9 2299",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2297",
    "data-name": "\\uADF8\\uB8F9 2297",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2296",
    "data-name": "\\uADF8\\uB8F9 2296",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2295",
    "data-name": "\\uADF8\\uB8F9 2295",
    style: {
      isolation: "isolate"
    }
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11925",
    "data-name": "\\uD328\\uC2A4 11925",
    d: "M1018.831,4336.966v.412a.791.791,0,0,0,.463.647,2.243,2.243,0,0,0,1.04.269v-.412a2.24,2.24,0,0,1-1.04-.269.791.791,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11926",
    "data-name": "\\uD328\\uC2A4 11926",
    d: "M1020.334,4337.882v.412a2.339,2.339,0,0,0,1.211-.268,1.106,1.106,0,0,0,.337-.286v-.412a1.1,1.1,0,0,1-.337.285,2.337,2.337,0,0,1-1.211.269Z",
    fill: "#3b3b45"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11927",
    "data-name": "\\uD328\\uC2A4 11927",
    d: "M1021.882,4337.328v.412a.615.615,0,0,0,.133-.371v-.412a.615.615,0,0,1-.133.371Z",
    fill: "#2e2e37"
  }))))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2298",
    "data-name": "\\uADF8\\uB8F9 2298"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11929",
    "data-name": "\\uD328\\uC2A4 11929",
    d: "M1019.3,4336.31a.688.688,0,0,0-.007,1.3,2.476,2.476,0,0,0,2.251,0,.689.689,0,0,0,.007-1.3A2.479,2.479,0,0,0,1019.3,4336.31Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2306",
    "data-name": "\\uADF8\\uB8F9 2306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2305",
    "data-name": "\\uADF8\\uB8F9 2305",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2303",
    "data-name": "\\uADF8\\uB8F9 2303",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2302",
    "data-name": "\\uADF8\\uB8F9 2302",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2301",
    "data-name": "\\uADF8\\uB8F9 2301",
    style: {
      isolation: "isolate"
    }
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11930",
    "data-name": "\\uD328\\uC2A4 11930",
    d: "M1018.507,4336.338v.5a.951.951,0,0,0,.557.778,2.7,2.7,0,0,0,1.252.324l0-.5a2.7,2.7,0,0,1-1.251-.324.95.95,0,0,1-.557-.778Z",
    fill: "#2e2e37"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11931",
    "data-name": "\\uD328\\uC2A4 11931",
    d: "M1020.315,4337.44l0,.5a2.8,2.8,0,0,0,1.457-.323,1.326,1.326,0,0,0,.406-.344v-.5a1.334,1.334,0,0,1-.406.344,2.8,2.8,0,0,1-1.458.323Z",
    fill: "#3b3b45"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11932",
    "data-name": "\\uD328\\uC2A4 11932",
    d: "M1022.179,4336.773v.5a.731.731,0,0,0,.16-.446v-.5a.737.737,0,0,1-.16.446Z",
    fill: "#2e2e37"
  }))))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2304",
    "data-name": "\\uADF8\\uB8F9 2304"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11934",
    "data-name": "\\uD328\\uC2A4 11934",
    d: "M1019.073,4335.548a.828.828,0,0,0-.009,1.568,2.983,2.983,0,0,0,2.709,0,.83.83,0,0,0,.009-1.57A2.983,2.983,0,0,0,1019.073,4335.548Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2312",
    "data-name": "\\uADF8\\uB8F9 2312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2311",
    "data-name": "\\uADF8\\uB8F9 2311",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2309",
    "data-name": "\\uADF8\\uB8F9 2309",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2308",
    "data-name": "\\uADF8\\uB8F9 2308",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2307",
    "data-name": "\\uADF8\\uB8F9 2307",
    style: {
      isolation: "isolate"
    }
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11935",
    "data-name": "\\uD328\\uC2A4 11935",
    d: "M1018.831,4335.814v.412a.792.792,0,0,0,.463.647,2.237,2.237,0,0,0,1.04.269v-.412a2.228,2.228,0,0,1-1.04-.269.791.791,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11936",
    "data-name": "\\uD328\\uC2A4 11936",
    d: "M1020.334,4336.73v.412a2.344,2.344,0,0,0,1.211-.268,1.107,1.107,0,0,0,.337-.286v-.412a1.119,1.119,0,0,1-.337.286,2.341,2.341,0,0,1-1.211.268Z",
    fill: "#3b3b45"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11937",
    "data-name": "\\uD328\\uC2A4 11937",
    d: "M1021.882,4336.176v.412a.61.61,0,0,0,.133-.371v-.412a.612.612,0,0,1-.133.371Z",
    fill: "#2e2e37"
  }))))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2310",
    "data-name": "\\uADF8\\uB8F9 2310"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11939",
    "data-name": "\\uD328\\uC2A4 11939",
    d: "M1019.3,4335.158a.688.688,0,0,0-.007,1.3,2.482,2.482,0,0,0,2.251,0,.689.689,0,0,0,.007-1.3A2.479,2.479,0,0,0,1019.3,4335.158Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2318",
    "data-name": "\\uADF8\\uB8F9 2318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2317",
    "data-name": "\\uADF8\\uB8F9 2317",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2315",
    "data-name": "\\uADF8\\uB8F9 2315",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2314",
    "data-name": "\\uADF8\\uB8F9 2314",
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2313",
    "data-name": "\\uADF8\\uB8F9 2313",
    style: {
      isolation: "isolate"
    }
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11940",
    "data-name": "\\uD328\\uC2A4 11940",
    d: "M1018.527,4335.189l0,.49a.94.94,0,0,0,.551.771,2.685,2.685,0,0,0,1.238.32v-.49a2.669,2.669,0,0,1-1.239-.321.943.943,0,0,1-.551-.77Z",
    fill: "#2e2e37"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11941",
    "data-name": "\\uD328\\uC2A4 11941",
    d: "M1020.317,4336.28v.49a2.776,2.776,0,0,0,1.442-.32,1.319,1.319,0,0,0,.4-.34l0-.49a1.331,1.331,0,0,1-.4.34,2.794,2.794,0,0,1-1.441.32Z",
    fill: "#3b3b45"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11942",
    "data-name": "\\uD328\\uC2A4 11942",
    d: "M1022.16,4335.62l0,.49a.733.733,0,0,0,.158-.442l0-.49a.726.726,0,0,1-.158.442Z",
    fill: "#2e2e37"
  }))))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2316",
    "data-name": "\\uADF8\\uB8F9 2316"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11944",
    "data-name": "\\uD328\\uC2A4 11944",
    d: "M1019.087,4334.407a.82.82,0,0,0-.009,1.552,2.95,2.95,0,0,0,2.68,0,.82.82,0,0,0,.009-1.553A2.95,2.95,0,0,0,1019.087,4334.407Z",
    fill: "#434851"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2331",
    "data-name": "\\uADF8\\uB8F9 2331"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2325",
    "data-name": "\\uADF8\\uB8F9 2325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2324",
    "data-name": "\\uADF8\\uB8F9 2324",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2322",
    "data-name": "\\uADF8\\uB8F9 2322"
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11945",
    "data-name": "\\uD328\\uC2A4 11945",
    d: "M1019.8,4333.485l-.921,1.513a.766.766,0,0,0,.448.627,2.4,2.4,0,0,0,2.182,0,.769.769,0,0,0,.456-.636l-.931-1.507a.309.309,0,0,1-.182.254.959.959,0,0,1-.873,0A.3.3,0,0,1,1019.8,4333.485Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2321",
    "data-name": "\\uADF8\\uB8F9 2321",
    clipPath: "url(#clip-path-56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2320",
    "data-name": "\\uADF8\\uB8F9 2320",
    style: {
      isolation: "isolate"
    }
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11946",
    "data-name": "\\uD328\\uC2A4 11946",
    d: "M1019.8,4333.485l-.921,1.513a.766.766,0,0,0,.448.627,2.4,2.4,0,0,0,2.182,0,.769.769,0,0,0,.456-.636l-.931-1.507a.309.309,0,0,1-.182.254.959.959,0,0,1-.873,0,.3.3,0,0,1-.179-.251Z",
    fill: "#3b3b45"
  }))))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2323",
    "data-name": "\\uADF8\\uB8F9 2323"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11948",
    "data-name": "\\uD328\\uC2A4 11948",
    d: "M1019.983,4333.231a.267.267,0,0,0,0,.5.959.959,0,0,0,.873,0,.267.267,0,0,0,0-.5A.959.959,0,0,0,1019.983,4333.231Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2330",
    "data-name": "\\uADF8\\uB8F9 2330"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2329",
    "data-name": "\\uADF8\\uB8F9 2329",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2328",
    "data-name": "\\uADF8\\uB8F9 2328"
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11949",
    "data-name": "\\uD328\\uC2A4 11949",
    d: "M1019.8,4332.829l0,.651a.308.308,0,0,0,.179.252.963.963,0,0,0,.875,0,.311.311,0,0,0,.183-.255l0-.606a.31.31,0,0,1-.183.255.963.963,0,0,1-.875,0A.367.367,0,0,1,1019.8,4332.829Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2327",
    "data-name": "\\uADF8\\uB8F9 2327",
    clipPath: "url(#clip-path-57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2326",
    "data-name": "\\uADF8\\uB8F9 2326",
    style: {
      isolation: "isolate"
    }
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11950",
    "data-name": "\\uD328\\uC2A4 11950",
    d: "M1019.8,4332.875l0,.6a.308.308,0,0,0,.179.252.963.963,0,0,0,.875,0,.311.311,0,0,0,.183-.255l0-.606a.31.31,0,0,1-.183.255.963.963,0,0,1-.875,0,.306.306,0,0,1-.179-.251Z",
    fill: "#e4e6f0"
  }))))))), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11952",
    "data-name": "\\uD328\\uC2A4 11952",
    d: "M1020.423,4333.491a.62.62,0,1,1,.62-.62.62.62,0,0,1-.62.62Z",
    fill: "#e4e6f0"
  }))))), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11953",
    "data-name": "\\uD328\\uC2A4 11953",
    d: "M1013.892,4337.038a.161.161,0,0,0,.083-.023l6.127-3.537a.167.167,0,1,0-.167-.29l-6.127,3.538a.167.167,0,0,0,.084.312Z",
    fill: "#35353f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2384",
    "data-name": "\\uADF8\\uB8F9 2384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2339",
    "data-name": "\\uADF8\\uB8F9 2339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2338",
    "data-name": "\\uADF8\\uB8F9 2338",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2336",
    "data-name": "\\uADF8\\uB8F9 2336"
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11954",
    "data-name": "\\uD328\\uC2A4 11954",
    d: "M1013.581,4341.6l0,2.983a.33.33,0,0,0,.194.27,1.033,1.033,0,0,0,.94,0,.332.332,0,0,0,.2-.274l0-2.983a.335.335,0,0,1-.2.275,1.041,1.041,0,0,1-.941,0A.332.332,0,0,1,1013.581,4341.6Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2335",
    "data-name": "\\uADF8\\uB8F9 2335",
    clipPath: "url(#clip-path-58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2334",
    "data-name": "\\uADF8\\uB8F9 2334",
    style: {
      isolation: "isolate"
    }
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11955",
    "data-name": "\\uD328\\uC2A4 11955",
    d: "M1013.581,4341.6l0,2.983a.33.33,0,0,0,.194.27,1.033,1.033,0,0,0,.94,0,.332.332,0,0,0,.2-.274l0-2.983a.335.335,0,0,1-.2.275,1.041,1.041,0,0,1-.941,0,.332.332,0,0,1-.193-.271Z",
    fill: "#2e2e37"
  }))))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2337",
    "data-name": "\\uADF8\\uB8F9 2337"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11957",
    "data-name": "\\uD328\\uC2A4 11957",
    d: "M1013.778,4341.328a.288.288,0,0,0,0,.545,1.041,1.041,0,0,0,.941,0,.288.288,0,0,0,0-.545A1.03,1.03,0,0,0,1013.778,4341.328Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2383",
    "data-name": "\\uADF8\\uB8F9 2383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2370",
    "data-name": "\\uADF8\\uB8F9 2370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2345",
    "data-name": "\\uADF8\\uB8F9 2345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2344",
    "data-name": "\\uADF8\\uB8F9 2344",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2342",
    "data-name": "\\uADF8\\uB8F9 2342",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2341",
    "data-name": "\\uADF8\\uB8F9 2341",
    clipPath: "url(#clip-path-59)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2340",
    "data-name": "\\uADF8\\uB8F9 2340",
    style: {
      isolation: "isolate"
    }
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11958",
    "data-name": "\\uD328\\uC2A4 11958",
    d: "M1012.324,4341.486l0,.5a.956.956,0,0,0,.559.781,2.712,2.712,0,0,0,1.255.325v-.5a2.7,2.7,0,0,1-1.256-.325.955.955,0,0,1-.559-.781Z",
    fill: "#2e2e37"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11959",
    "data-name": "\\uD328\\uC2A4 11959",
    d: "M1014.139,4342.592v.5a2.834,2.834,0,0,0,1.463-.324,1.354,1.354,0,0,0,.407-.345v-.5a1.346,1.346,0,0,1-.408.345,2.819,2.819,0,0,1-1.462.324Z",
    fill: "#3b3b45"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11960",
    "data-name": "\\uD328\\uC2A4 11960",
    d: "M1016.009,4341.923v.5a.746.746,0,0,0,.161-.448l0-.5a.734.734,0,0,1-.16.448Z",
    fill: "#2e2e37"
  }))))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2343",
    "data-name": "\\uADF8\\uB8F9 2343"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11962",
    "data-name": "\\uD328\\uC2A4 11962",
    d: "M1012.892,4340.694a.831.831,0,0,0-.009,1.573,2.993,2.993,0,0,0,2.718,0,.832.832,0,0,0,.009-1.575A2.993,2.993,0,0,0,1012.892,4340.694Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2351",
    "data-name": "\\uADF8\\uB8F9 2351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2350",
    "data-name": "\\uADF8\\uB8F9 2350",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2348",
    "data-name": "\\uADF8\\uB8F9 2348",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2347",
    "data-name": "\\uADF8\\uB8F9 2347",
    clipPath: "url(#clip-path-60)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2346",
    "data-name": "\\uADF8\\uB8F9 2346",
    style: {
      isolation: "isolate"
    }
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11963",
    "data-name": "\\uD328\\uC2A4 11963",
    d: "M1012.655,4340.858v.412a.792.792,0,0,0,.463.648,2.261,2.261,0,0,0,1.04.269v-.412a2.241,2.241,0,0,1-1.04-.27.79.79,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11964",
    "data-name": "\\uD328\\uC2A4 11964",
    d: "M1014.158,4341.775v.412a2.339,2.339,0,0,0,1.211-.269,1.117,1.117,0,0,0,.337-.285v-.413a1.118,1.118,0,0,1-.337.286,2.337,2.337,0,0,1-1.211.269Z",
    fill: "#3b3b45"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11965",
    "data-name": "\\uD328\\uC2A4 11965",
    d: "M1015.706,4341.22v.413a.615.615,0,0,0,.133-.372v-.412a.612.612,0,0,1-.133.371Z",
    fill: "#2e2e37"
  }))))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2349",
    "data-name": "\\uADF8\\uB8F9 2349"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11967",
    "data-name": "\\uD328\\uC2A4 11967",
    d: "M1013.125,4340.2a.688.688,0,0,0-.007,1.3,2.476,2.476,0,0,0,2.251,0,.689.689,0,0,0,.007-1.3A2.476,2.476,0,0,0,1013.125,4340.2Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2357",
    "data-name": "\\uADF8\\uB8F9 2357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2356",
    "data-name": "\\uADF8\\uB8F9 2356",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2354",
    "data-name": "\\uADF8\\uB8F9 2354",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2353",
    "data-name": "\\uADF8\\uB8F9 2353",
    clipPath: "url(#clip-path-61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2352",
    "data-name": "\\uADF8\\uB8F9 2352",
    style: {
      isolation: "isolate"
    }
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11968",
    "data-name": "\\uD328\\uC2A4 11968",
    d: "M1012.331,4340.23v.5a.953.953,0,0,0,.557.779,2.7,2.7,0,0,0,1.252.324l0-.5a2.7,2.7,0,0,1-1.251-.324.95.95,0,0,1-.557-.779Z",
    fill: "#2e2e37"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11969",
    "data-name": "\\uD328\\uC2A4 11969",
    d: "M1014.139,4341.333l0,.5a2.822,2.822,0,0,0,1.457-.323,1.334,1.334,0,0,0,.406-.344v-.5a1.326,1.326,0,0,1-.406.344,2.818,2.818,0,0,1-1.458.323Z",
    fill: "#3b3b45"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11970",
    "data-name": "\\uD328\\uC2A4 11970",
    d: "M1016,4340.666v.5a.732.732,0,0,0,.16-.447v-.5a.738.738,0,0,1-.16.447Z",
    fill: "#2e2e37"
  }))))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2355",
    "data-name": "\\uADF8\\uB8F9 2355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11972",
    "data-name": "\\uD328\\uC2A4 11972",
    d: "M1012.9,4339.441a.828.828,0,0,0-.009,1.568,2.983,2.983,0,0,0,2.709,0,.829.829,0,0,0,.009-1.57A2.981,2.981,0,0,0,1012.9,4339.441Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2363",
    "data-name": "\\uADF8\\uB8F9 2363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2362",
    "data-name": "\\uADF8\\uB8F9 2362",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2360",
    "data-name": "\\uADF8\\uB8F9 2360",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2359",
    "data-name": "\\uADF8\\uB8F9 2359",
    clipPath: "url(#clip-path-62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2358",
    "data-name": "\\uADF8\\uB8F9 2358",
    style: {
      isolation: "isolate"
    }
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11973",
    "data-name": "\\uD328\\uC2A4 11973",
    d: "M1012.655,4339.707v.412a.792.792,0,0,0,.463.647,2.261,2.261,0,0,0,1.04.269v-.412a2.258,2.258,0,0,1-1.04-.269.792.792,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11974",
    "data-name": "\\uD328\\uC2A4 11974",
    d: "M1014.158,4340.623v.412a2.344,2.344,0,0,0,1.211-.269,1.091,1.091,0,0,0,.337-.285v-.412a1.117,1.117,0,0,1-.337.285,2.342,2.342,0,0,1-1.211.269Z",
    fill: "#3b3b45"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11975",
    "data-name": "\\uD328\\uC2A4 11975",
    d: "M1015.706,4340.069v.412a.614.614,0,0,0,.133-.371v-.412a.612.612,0,0,1-.133.371Z",
    fill: "#2e2e37"
  }))))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2361",
    "data-name": "\\uADF8\\uB8F9 2361"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11977",
    "data-name": "\\uD328\\uC2A4 11977",
    d: "M1013.125,4339.051a.688.688,0,0,0-.007,1.3,2.479,2.479,0,0,0,2.251,0,.689.689,0,0,0,.007-1.3A2.479,2.479,0,0,0,1013.125,4339.051Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2369",
    "data-name": "\\uADF8\\uB8F9 2369"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2368",
    "data-name": "\\uADF8\\uB8F9 2368",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2366",
    "data-name": "\\uADF8\\uB8F9 2366",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2365",
    "data-name": "\\uADF8\\uB8F9 2365",
    clipPath: "url(#clip-path-63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2364",
    "data-name": "\\uADF8\\uB8F9 2364",
    style: {
      isolation: "isolate"
    }
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11978",
    "data-name": "\\uD328\\uC2A4 11978",
    d: "M1012.351,4339.081l0,.491a.937.937,0,0,0,.551.77,2.668,2.668,0,0,0,1.238.321v-.491a2.686,2.686,0,0,1-1.239-.32.945.945,0,0,1-.551-.771Z",
    fill: "#2e2e37"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11979",
    "data-name": "\\uD328\\uC2A4 11979",
    d: "M1014.141,4340.172v.491a2.786,2.786,0,0,0,1.442-.32,1.325,1.325,0,0,0,.4-.34l0-.491a1.325,1.325,0,0,1-.4.34,2.781,2.781,0,0,1-1.442.32Z",
    fill: "#3b3b45"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11980",
    "data-name": "\\uD328\\uC2A4 11980",
    d: "M1015.984,4339.512l0,.491a.737.737,0,0,0,.158-.442l0-.491a.722.722,0,0,1-.158.442Z",
    fill: "#2e2e37"
  }))))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2367",
    "data-name": "\\uADF8\\uB8F9 2367"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11982",
    "data-name": "\\uD328\\uC2A4 11982",
    d: "M1012.911,4338.3a.82.82,0,0,0-.009,1.552,2.955,2.955,0,0,0,2.681,0,.821.821,0,0,0,.008-1.553A2.953,2.953,0,0,0,1012.911,4338.3Z",
    fill: "#434851"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2382",
    "data-name": "\\uADF8\\uB8F9 2382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2376",
    "data-name": "\\uADF8\\uB8F9 2376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2375",
    "data-name": "\\uADF8\\uB8F9 2375",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2373",
    "data-name": "\\uADF8\\uB8F9 2373"
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11983",
    "data-name": "\\uD328\\uC2A4 11983",
    d: "M1013.625,4337.378l-.921,1.512a.767.767,0,0,0,.448.628,2.4,2.4,0,0,0,2.182,0,.773.773,0,0,0,.456-.636l-.931-1.508a.31.31,0,0,1-.182.255.959.959,0,0,1-.873,0A.3.3,0,0,1,1013.625,4337.378Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2372",
    "data-name": "\\uADF8\\uB8F9 2372",
    clipPath: "url(#clip-path-64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2371",
    "data-name": "\\uADF8\\uB8F9 2371",
    style: {
      isolation: "isolate"
    }
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11984",
    "data-name": "\\uD328\\uC2A4 11984",
    d: "M1013.625,4337.378l-.921,1.512a.767.767,0,0,0,.448.628,2.4,2.4,0,0,0,2.182,0,.773.773,0,0,0,.456-.636l-.931-1.508a.31.31,0,0,1-.182.255.959.959,0,0,1-.873,0,.3.3,0,0,1-.179-.251Z",
    fill: "#3b3b45"
  }))))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2374",
    "data-name": "\\uADF8\\uB8F9 2374"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11986",
    "data-name": "\\uD328\\uC2A4 11986",
    d: "M1013.807,4337.123a.267.267,0,0,0,0,.506.959.959,0,0,0,.873,0,.267.267,0,0,0,0-.506A.963.963,0,0,0,1013.807,4337.123Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2381",
    "data-name": "\\uADF8\\uB8F9 2381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2380",
    "data-name": "\\uADF8\\uB8F9 2380",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2379",
    "data-name": "\\uADF8\\uB8F9 2379"
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11987",
    "data-name": "\\uD328\\uC2A4 11987",
    d: "M1013.629,4336.722l0,.651a.306.306,0,0,0,.179.251.963.963,0,0,0,.875,0,.31.31,0,0,0,.183-.255l0-.6a.31.31,0,0,1-.183.255.963.963,0,0,1-.875,0A.368.368,0,0,1,1013.629,4336.722Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2378",
    "data-name": "\\uADF8\\uB8F9 2378",
    clipPath: "url(#clip-path-65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2377",
    "data-name": "\\uADF8\\uB8F9 2377",
    style: {
      isolation: "isolate"
    }
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11988",
    "data-name": "\\uD328\\uC2A4 11988",
    d: "M1013.625,4336.767l0,.606a.306.306,0,0,0,.179.251.963.963,0,0,0,.875,0,.31.31,0,0,0,.183-.255l0-.6a.31.31,0,0,1-.183.255.963.963,0,0,1-.875,0,.308.308,0,0,1-.179-.252Z",
    fill: "#e4e6f0"
  }))))))), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11990",
    "data-name": "\\uD328\\uC2A4 11990",
    d: "M1013.628,4336.764a.62.62,0,1,1,.619.619A.62.62,0,0,1,1013.628,4336.764Z",
    fill: "#e4e6f0"
  }))))), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11991",
    "data-name": "\\uD328\\uC2A4 11991",
    d: "M1004.277,4342.589a.165.165,0,0,0,.083-.022l9.615-5.552a.167.167,0,1,0-.167-.289l-9.615,5.551a.167.167,0,0,0,.084.312Z",
    fill: "#35353f"
  })))), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11992",
    "data-name": "\\uD328\\uC2A4 11992",
    d: "M1031.346,4403.471a.669.669,0,0,0,.334-.09l4.089-2.361a3.428,3.428,0,0,0,1.834-2.345,2.7,2.7,0,0,0-.753-2.244.669.669,0,1,0-.987.9,1.4,1.4,0,0,1,.417,1.136,2.151,2.151,0,0,1-1.18,1.39l-4.09,2.361a.669.669,0,0,0,.336,1.249Z",
    fill: "#35353f"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11993",
    "data-name": "\\uD328\\uC2A4 11993",
    d: "M1030.225,4385.644a6.013,6.013,0,0,1,1.514-.534,8.245,8.245,0,0,1,1.535-.25,7.19,7.19,0,0,0,2.616-.523,2.1,2.1,0,0,0,1.124-1.908c.122-.079.252-.152.384-.222a2.7,2.7,0,0,1-.543,2,3.726,3.726,0,0,1-2.536,1.142,10.97,10.97,0,0,0-3.778.832A.314.314,0,0,1,1030.225,4385.644Z",
    fill: "#35353f"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11994",
    "data-name": "\\uD328\\uC2A4 11994",
    d: "M1029.659,4386.009a5.779,5.779,0,0,1,2.491-.182,5.728,5.728,0,0,0,3-.074,2,2,0,0,0,1.128-2.634c.1-.121.209-.229.307-.341a2.429,2.429,0,0,1-.274,2.664,3.47,3.47,0,0,1-3.016,1.019c-.647-.072-1.276-.158-1.929-.176a5.409,5.409,0,0,0-.92.023,2.14,2.14,0,0,1-.788.074C1029.453,4386.343,1029.5,4386.07,1029.659,4386.009Z",
    fill: "#35353f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2824",
    "data-name": "\\uADF8\\uB8F9 2824",
    transform: "translate(0 -3478)"
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11995",
    "data-name": "\\uD328\\uC2A4 11995",
    d: "M1065.769,4407.614a.662.662,0,0,0,.334-.09l4.089-2.361a6.6,6.6,0,0,1,2.723-.768.669.669,0,1,0-.1-1.334,7.829,7.829,0,0,0-3.289.943l-4.089,2.361a.669.669,0,0,0,.335,1.249Z",
    fill: "#35353f"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11996",
    "data-name": "\\uD328\\uC2A4 11996",
    d: "M1077.272,4383.1a3.748,3.748,0,0,0-1.711-1.969c-.09-.038-.033-.159.044-.165.8-.065,1.646,1.09,1.94,1.72.015.031.028.062.041.094-.1.112-.2.22-.307.341Z",
    fill: "#35353f"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11997",
    "data-name": "\\uD328\\uC2A4 11997",
    d: "M1076.577,4383.3c.042-.1,0-.222-.18-.351-.249-.176-.554-.257-.8-.443a.042.042,0,0,1,.021-.078c.489-.052,1.5.282,1.386.927a.782.782,0,0,1-.03.112A.871.871,0,0,1,1076.577,4383.3Z",
    fill: "#35353f"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11998",
    "data-name": "\\uD328\\uC2A4 11998",
    d: "M1076.6,4382.231c-.094-.273-1.294-.064-1.538-.1a2.22,2.22,0,0,1,.456-.676c.383-.027,1.376.253,1.567.75a1.276,1.276,0,0,1-.477.168A.23.23,0,0,0,1076.6,4382.231Z",
    fill: "#35353f"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11999",
    "data-name": "\\uD328\\uC2A4 11999",
    d: "M1077.847,4381.7c-.442-.972-1.472-1.287-2.2-1.964a.032.032,0,0,1,.022-.054,3.479,3.479,0,0,1,2.46,1.695,2.334,2.334,0,0,1,.269.829c-.132.07-.262.143-.384.222A1.917,1.917,0,0,0,1077.847,4381.7Z",
    fill: "#35353f"
  })), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    id: "man-2",
    "data-name": "man"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12000",
    "data-name": "\\uD328\\uC2A4 12000",
    d: "M1066.316,4404.685c.069-.177.194-.119.338-.151a1.305,1.305,0,0,0,.492-.262c.184-.141.345-.309.517-.465a4.94,4.94,0,0,1,1.524-.941,1.589,1.589,0,0,1,1.124-.116,1.169,1.169,0,0,1,.536.4.928.928,0,0,1,.129.6,1.409,1.409,0,0,1-.062.429,1.76,1.76,0,0,1-.517.7,2.973,2.973,0,0,1-.821.583,7.517,7.517,0,0,0-.768.3,1.662,1.662,0,0,0-.418.359,1.317,1.317,0,0,1-.3.327,1.9,1.9,0,0,1-.9.27.994.994,0,0,1-1.074-1.03,3.22,3.22,0,0,1,.115-.667A3.029,3.029,0,0,1,1066.316,4404.685Z",
    fill: "#261d22"
  }))), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12001",
    "data-name": "\\uD328\\uC2A4 12001",
    d: "M1077.356,4397.553a.67.67,0,0,0,.494-1.122,4.545,4.545,0,0,0-1.081-.848,8.509,8.509,0,0,0-4.79-.943.669.669,0,1,0,.1,1.334,7.251,7.251,0,0,1,4.017.768,3.175,3.175,0,0,1,.763.593A.67.67,0,0,0,1077.356,4397.553Z",
    fill: "#35353f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2392",
    "data-name": "\\uADF8\\uB8F9 2392"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2391",
    "data-name": "\\uADF8\\uB8F9 2391",
    style: {
      isolation: "isolate"
    }
  }, _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2388",
    "data-name": "\\uADF8\\uB8F9 2388"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12002",
    "data-name": "\\uD328\\uC2A4 12002",
    d: "M1094.929,4361.734l-39.309-22.844.006,2.172,39.309,22.844Z",
    fill: "#cacaca"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2389",
    "data-name": "\\uADF8\\uB8F9 2389"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12003",
    "data-name": "\\uD328\\uC2A4 12003",
    d: "M1096.82,4360.643,1057.51,4337.8l-1.89,1.091,39.309,22.844Z",
    fill: "#d9d9d9"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2390",
    "data-name": "\\uADF8\\uB8F9 2390"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12004",
    "data-name": "\\uD328\\uC2A4 12004",
    d: "M1094.929,4361.734l.006,2.172,1.89-1.091-.006-2.172Z",
    fill: "#a6a6a6"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2397",
    "data-name": "\\uADF8\\uB8F9 2397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2396",
    "data-name": "\\uADF8\\uB8F9 2396",
    style: {
      isolation: "isolate"
    }
  }, _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2393",
    "data-name": "\\uADF8\\uB8F9 2393"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12005",
    "data-name": "\\uD328\\uC2A4 12005",
    d: "M1069.017,4343.2l.258,90.93,4.605,2.676-.258-90.93Z",
    fill: "#bcbdbf"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2394",
    "data-name": "\\uADF8\\uB8F9 2394"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12006",
    "data-name": "\\uD328\\uC2A4 12006",
    d: "M1073.623,4345.881l.258,90.93,2.835-1.636-.258-90.93Z",
    fill: "#a6a6a6"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2395",
    "data-name": "\\uADF8\\uB8F9 2395"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12007",
    "data-name": "\\uD328\\uC2A4 12007",
    d: "M1069.017,4343.2l4.605,2.676,2.835-1.636-4.606-2.676Z",
    fill: "#d9d9d9"
  }))))), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12008",
    "data-name": "\\uD328\\uC2A4 12008",
    d: "M1066.053,4383.751a18.9,18.9,0,0,1,3.115.341,16.149,16.149,0,0,0,3.611-.012,27.347,27.347,0,0,0,2.975-.342c.257-.052.733-.211.823-.438a.871.871,0,0,0,.4.167c-.255.768-1.641.823-2.262.918a30.026,30.026,0,0,1-4.54.362,15.787,15.787,0,0,1-2.173-.155,6.288,6.288,0,0,1-2.1-.266A.311.311,0,0,1,1066.053,4383.751Z",
    fill: "#35353f"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12009",
    "data-name": "\\uD328\\uC2A4 12009",
    d: "M1067.761,4382.112a24.313,24.313,0,0,0,2.469.622,12.408,12.408,0,0,0,2.833.364,11.47,11.47,0,0,0,2.63-.3c.217-.051.846-.151.919-.43a1.276,1.276,0,0,0,.477-.168.472.472,0,0,1,0,.334c-.1.3-.51.442-.775.542a8.217,8.217,0,0,1-1.649.364,13.311,13.311,0,0,1-3.646.048c-.586-.073-1.156-.2-1.733-.325a8.073,8.073,0,0,1-1.8-.422C1067.143,4382.58,1067.393,4381.981,1067.761,4382.112Z",
    fill: "#35353f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2404",
    "data-name": "\\uADF8\\uB8F9 2404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2403",
    "data-name": "\\uADF8\\uB8F9 2403",
    style: {
      isolation: "isolate"
    }
  }, _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2398",
    "data-name": "\\uADF8\\uB8F9 2398"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12010",
    "data-name": "\\uD328\\uC2A4 12010",
    d: "M1066.986,4410.116l.031,10.912,6.3,3.659-.031-10.912Z",
    fill: "#f44522"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2399",
    "data-name": "\\uADF8\\uB8F9 2399"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12011",
    "data-name": "\\uD328\\uC2A4 12011",
    d: "M1073.283,4413.775l.031,10.912,2.767-1.6-.031-10.912Z",
    fill: "#f73e19"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2400",
    "data-name": "\\uADF8\\uB8F9 2400"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12012",
    "data-name": "\\uD328\\uC2A4 12012",
    d: "M1073.742,4413.51l.23-.133v10.93l-.23.133Z",
    fill: "#35353f"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2401",
    "data-name": "\\uADF8\\uB8F9 2401"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12013",
    "data-name": "\\uD328\\uC2A4 12013",
    d: "M1066.986,4410.116l6.3,3.659,2.767-1.6-6.3-3.659Z",
    fill: "#ff4c22"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2402",
    "data-name": "\\uADF8\\uB8F9 2402"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12014",
    "data-name": "\\uD328\\uC2A4 12014",
    d: "M1067.445,4409.851l6.3,3.659.23-.133-6.3-3.659Z",
    fill: "#434851"
  })))), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12015",
    "data-name": "\\uD328\\uC2A4 12015",
    d: "M1067.477,4416.872h0c.114.066.207.012.207-.12v-.281a.46.46,0,0,0-.207-.359h0c-.114-.066-.207-.012-.207.12v.281A.459.459,0,0,0,1067.477,4416.872Z",
    fill: "#261d22"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12016",
    "data-name": "\\uD328\\uC2A4 12016",
    d: "M1069.609,4414.239l.164,2.553-.8-.5,1.043,3.979.161-1.782,1.028.407Z",
    fill: "#ffd438"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2409",
    "data-name": "\\uADF8\\uB8F9 2409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2408",
    "data-name": "\\uADF8\\uB8F9 2408",
    style: {
      isolation: "isolate"
    }
  }, _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2405",
    "data-name": "\\uADF8\\uB8F9 2405"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12017",
    "data-name": "\\uD328\\uC2A4 12017",
    d: "M1088.748,4365.3l-39.309-22.844.006,2.172,39.309,22.844Z",
    fill: "#cacaca"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2406",
    "data-name": "\\uADF8\\uB8F9 2406"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12018",
    "data-name": "\\uD328\\uC2A4 12018",
    d: "M1090.638,4364.211l-39.309-22.844-1.89,1.091,39.309,22.844Z",
    fill: "#d9d9d9"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2407",
    "data-name": "\\uADF8\\uB8F9 2407"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12019",
    "data-name": "\\uD328\\uC2A4 12019",
    d: "M1088.748,4365.3l.006,2.173,1.89-1.091-.006-2.173Z",
    fill: "#a6a6a6"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2616",
    "data-name": "\\uADF8\\uB8F9 2616"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2512",
    "data-name": "\\uADF8\\uB8F9 2512"
  }, _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_974",
    "data-name": "\\uC0AC\\uAC01\\uD615 974",
    width: 8.038,
    height: 0.335,
    transform: "translate(1089.223 4349.954) rotate(-30)",
    fill: "#35353f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2460",
    "data-name": "\\uADF8\\uB8F9 2460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2415",
    "data-name": "\\uADF8\\uB8F9 2415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2414",
    "data-name": "\\uADF8\\uB8F9 2414",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2412",
    "data-name": "\\uADF8\\uB8F9 2412"
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12020",
    "data-name": "\\uD328\\uC2A4 12020",
    d: "M1089.045,4354.476l0,2.982a.333.333,0,0,0,.194.271,1.039,1.039,0,0,0,.94,0,.333.333,0,0,0,.2-.275l0-2.982a.335.335,0,0,1-.2.274,1.035,1.035,0,0,1-.941,0A.331.331,0,0,1,1089.045,4354.476Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2411",
    "data-name": "\\uADF8\\uB8F9 2411",
    clipPath: "url(#clip-path-66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2410",
    "data-name": "\\uADF8\\uB8F9 2410",
    style: {
      isolation: "isolate"
    }
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12021",
    "data-name": "\\uD328\\uC2A4 12021",
    d: "M1089.045,4354.476l0,2.982a.333.333,0,0,0,.194.271,1.039,1.039,0,0,0,.94,0,.333.333,0,0,0,.2-.275l0-2.982a.335.335,0,0,1-.2.274,1.035,1.035,0,0,1-.941,0,.331.331,0,0,1-.193-.27Z",
    fill: "#2e2e37"
  }))))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2413",
    "data-name": "\\uADF8\\uB8F9 2413"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12023",
    "data-name": "\\uD328\\uC2A4 12023",
    d: "M1089.242,4354.2a.288.288,0,0,0,0,.545,1.035,1.035,0,0,0,.941,0,.288.288,0,0,0,0-.545A1.036,1.036,0,0,0,1089.242,4354.2Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2459",
    "data-name": "\\uADF8\\uB8F9 2459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2446",
    "data-name": "\\uADF8\\uB8F9 2446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2421",
    "data-name": "\\uADF8\\uB8F9 2421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2420",
    "data-name": "\\uADF8\\uB8F9 2420",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2418",
    "data-name": "\\uADF8\\uB8F9 2418",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2417",
    "data-name": "\\uADF8\\uB8F9 2417",
    clipPath: "url(#clip-path-67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2416",
    "data-name": "\\uADF8\\uB8F9 2416",
    style: {
      isolation: "isolate"
    }
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12024",
    "data-name": "\\uD328\\uC2A4 12024",
    d: "M1087.788,4354.359l0,.5a.954.954,0,0,0,.559.781,2.7,2.7,0,0,0,1.255.325v-.5a2.72,2.72,0,0,1-1.256-.325.956.956,0,0,1-.559-.782Z",
    fill: "#2e2e37"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12025",
    "data-name": "\\uD328\\uC2A4 12025",
    d: "M1089.6,4355.466v.5a2.825,2.825,0,0,0,1.463-.324,1.341,1.341,0,0,0,.407-.345v-.5a1.343,1.343,0,0,1-.408.344,2.819,2.819,0,0,1-1.462.325Z",
    fill: "#3b3b45"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12026",
    "data-name": "\\uD328\\uC2A4 12026",
    d: "M1091.473,4354.8v.5a.734.734,0,0,0,.16-.448v-.5a.746.746,0,0,1-.16.449Z",
    fill: "#2e2e37"
  }))))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2419",
    "data-name": "\\uADF8\\uB8F9 2419"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12028",
    "data-name": "\\uD328\\uC2A4 12028",
    d: "M1088.356,4353.567a.832.832,0,0,0-.009,1.574,2.993,2.993,0,0,0,2.718,0,.832.832,0,0,0,.009-1.575A2.993,2.993,0,0,0,1088.356,4353.567Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2427",
    "data-name": "\\uADF8\\uB8F9 2427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2426",
    "data-name": "\\uADF8\\uB8F9 2426",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2424",
    "data-name": "\\uADF8\\uB8F9 2424",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2423",
    "data-name": "\\uADF8\\uB8F9 2423",
    clipPath: "url(#clip-path-68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2422",
    "data-name": "\\uADF8\\uB8F9 2422",
    style: {
      isolation: "isolate"
    }
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12029",
    "data-name": "\\uD328\\uC2A4 12029",
    d: "M1088.119,4353.732v.412a.792.792,0,0,0,.463.647,2.249,2.249,0,0,0,1.04.269v-.412a2.24,2.24,0,0,1-1.04-.269.791.791,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12030",
    "data-name": "\\uD328\\uC2A4 12030",
    d: "M1089.622,4354.648v.412a2.339,2.339,0,0,0,1.211-.268,1.108,1.108,0,0,0,.337-.286v-.412a1.1,1.1,0,0,1-.337.285,2.341,2.341,0,0,1-1.211.269Z",
    fill: "#3b3b45"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12031",
    "data-name": "\\uD328\\uC2A4 12031",
    d: "M1091.17,4354.094v.412a.612.612,0,0,0,.133-.371v-.412a.615.615,0,0,1-.133.371Z",
    fill: "#2e2e37"
  }))))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2425",
    "data-name": "\\uADF8\\uB8F9 2425"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12033",
    "data-name": "\\uD328\\uC2A4 12033",
    d: "M1088.589,4353.076a.688.688,0,0,0-.007,1.3,2.477,2.477,0,0,0,2.251,0,.689.689,0,0,0,.007-1.3A2.476,2.476,0,0,0,1088.589,4353.076Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2433",
    "data-name": "\\uADF8\\uB8F9 2433"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2432",
    "data-name": "\\uADF8\\uB8F9 2432",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2430",
    "data-name": "\\uADF8\\uB8F9 2430",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2429",
    "data-name": "\\uADF8\\uB8F9 2429",
    clipPath: "url(#clip-path-69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2428",
    "data-name": "\\uADF8\\uB8F9 2428",
    style: {
      isolation: "isolate"
    }
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12034",
    "data-name": "\\uD328\\uC2A4 12034",
    d: "M1087.8,4353.1v.5a.951.951,0,0,0,.557.778,2.7,2.7,0,0,0,1.252.324l0-.5a2.7,2.7,0,0,1-1.251-.324.948.948,0,0,1-.557-.778Z",
    fill: "#2e2e37"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12035",
    "data-name": "\\uD328\\uC2A4 12035",
    d: "M1089.6,4354.206l0,.5a2.8,2.8,0,0,0,1.457-.323,1.333,1.333,0,0,0,.406-.344v-.5a1.357,1.357,0,0,1-.406.343,2.8,2.8,0,0,1-1.458.323Z",
    fill: "#3b3b45"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12036",
    "data-name": "\\uD328\\uC2A4 12036",
    d: "M1091.467,4353.54v.5a.738.738,0,0,0,.16-.446v-.5a.743.743,0,0,1-.16.447Z",
    fill: "#2e2e37"
  }))))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2431",
    "data-name": "\\uADF8\\uB8F9 2431"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12038",
    "data-name": "\\uD328\\uC2A4 12038",
    d: "M1088.361,4352.314a.828.828,0,0,0-.009,1.568,2.98,2.98,0,0,0,2.709,0,.829.829,0,0,0,.009-1.57A2.983,2.983,0,0,0,1088.361,4352.314Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2439",
    "data-name": "\\uADF8\\uB8F9 2439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2438",
    "data-name": "\\uADF8\\uB8F9 2438",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2436",
    "data-name": "\\uADF8\\uB8F9 2436",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2435",
    "data-name": "\\uADF8\\uB8F9 2435",
    clipPath: "url(#clip-path-70)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2434",
    "data-name": "\\uADF8\\uB8F9 2434",
    style: {
      isolation: "isolate"
    }
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12039",
    "data-name": "\\uD328\\uC2A4 12039",
    d: "M1088.119,4352.58v.412a.792.792,0,0,0,.463.647,2.237,2.237,0,0,0,1.04.269v-.412a2.234,2.234,0,0,1-1.04-.269.792.792,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12040",
    "data-name": "\\uD328\\uC2A4 12040",
    d: "M1089.622,4353.5v.412a2.344,2.344,0,0,0,1.211-.268,1.108,1.108,0,0,0,.337-.286v-.412a1.119,1.119,0,0,1-.337.286,2.346,2.346,0,0,1-1.211.268Z",
    fill: "#3b3b45"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12041",
    "data-name": "\\uD328\\uC2A4 12041",
    d: "M1091.17,4352.942v.412a.612.612,0,0,0,.133-.371v-.412a.61.61,0,0,1-.133.371Z",
    fill: "#2e2e37"
  }))))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2437",
    "data-name": "\\uADF8\\uB8F9 2437"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12043",
    "data-name": "\\uD328\\uC2A4 12043",
    d: "M1088.589,4351.924a.688.688,0,0,0-.007,1.3,2.482,2.482,0,0,0,2.251,0,.69.69,0,0,0,.007-1.305A2.482,2.482,0,0,0,1088.589,4351.924Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2445",
    "data-name": "\\uADF8\\uB8F9 2445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2444",
    "data-name": "\\uADF8\\uB8F9 2444",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2442",
    "data-name": "\\uADF8\\uB8F9 2442",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2441",
    "data-name": "\\uADF8\\uB8F9 2441",
    clipPath: "url(#clip-path-71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2440",
    "data-name": "\\uADF8\\uB8F9 2440",
    style: {
      isolation: "isolate"
    }
  }, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12044",
    "data-name": "\\uD328\\uC2A4 12044",
    d: "M1087.815,4351.955l0,.49a.939.939,0,0,0,.551.771,2.679,2.679,0,0,0,1.238.32l0-.49a2.674,2.674,0,0,1-1.238-.321.944.944,0,0,1-.551-.77Z",
    fill: "#2e2e37"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12045",
    "data-name": "\\uD328\\uC2A4 12045",
    d: "M1089.6,4353.046l0,.49a2.783,2.783,0,0,0,1.442-.32,1.306,1.306,0,0,0,.4-.34v-.49a1.34,1.34,0,0,1-.4.34,2.786,2.786,0,0,1-1.442.32Z",
    fill: "#3b3b45"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12046",
    "data-name": "\\uD328\\uC2A4 12046",
    d: "M1091.448,4352.386v.49a.729.729,0,0,0,.159-.442l0-.49a.726.726,0,0,1-.158.442Z",
    fill: "#2e2e37"
  }))))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2443",
    "data-name": "\\uADF8\\uB8F9 2443"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12048",
    "data-name": "\\uD328\\uC2A4 12048",
    d: "M1088.375,4351.173a.82.82,0,0,0-.009,1.552,2.953,2.953,0,0,0,2.68,0,.821.821,0,0,0,.009-1.553A2.953,2.953,0,0,0,1088.375,4351.173Z",
    fill: "#434851"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2458",
    "data-name": "\\uADF8\\uB8F9 2458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2452",
    "data-name": "\\uADF8\\uB8F9 2452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2451",
    "data-name": "\\uADF8\\uB8F9 2451",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2449",
    "data-name": "\\uADF8\\uB8F9 2449"
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12049",
    "data-name": "\\uD328\\uC2A4 12049",
    d: "M1089.088,4350.251l-.92,1.513a.767.767,0,0,0,.448.627,2.4,2.4,0,0,0,2.182,0,.772.772,0,0,0,.456-.636l-.931-1.507a.31.31,0,0,1-.182.254.959.959,0,0,1-.873,0A.307.307,0,0,1,1089.088,4350.251Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2448",
    "data-name": "\\uADF8\\uB8F9 2448",
    clipPath: "url(#clip-path-72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2447",
    "data-name": "\\uADF8\\uB8F9 2447",
    style: {
      isolation: "isolate"
    }
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12050",
    "data-name": "\\uD328\\uC2A4 12050",
    d: "M1089.088,4350.251l-.92,1.513a.767.767,0,0,0,.448.627,2.4,2.4,0,0,0,2.182,0,.772.772,0,0,0,.456-.636l-.931-1.507a.31.31,0,0,1-.182.254.959.959,0,0,1-.873,0,.307.307,0,0,1-.18-.251Z",
    fill: "#3b3b45"
  }))))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2450",
    "data-name": "\\uADF8\\uB8F9 2450"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12052",
    "data-name": "\\uD328\\uC2A4 12052",
    d: "M1089.271,4350a.267.267,0,0,0,0,.5.959.959,0,0,0,.873,0,.267.267,0,0,0,0-.5A.957.957,0,0,0,1089.271,4350Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2457",
    "data-name": "\\uADF8\\uB8F9 2457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2456",
    "data-name": "\\uADF8\\uB8F9 2456",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2455",
    "data-name": "\\uADF8\\uB8F9 2455"
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12053",
    "data-name": "\\uD328\\uC2A4 12053",
    d: "M1089.093,4349.6l0,.651a.308.308,0,0,0,.179.252.963.963,0,0,0,.875,0,.312.312,0,0,0,.183-.255l0-.606a.309.309,0,0,1-.183.255.963.963,0,0,1-.875,0A.367.367,0,0,1,1089.093,4349.6Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2454",
    "data-name": "\\uADF8\\uB8F9 2454",
    clipPath: "url(#clip-path-73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2453",
    "data-name": "\\uADF8\\uB8F9 2453",
    style: {
      isolation: "isolate"
    }
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12054",
    "data-name": "\\uD328\\uC2A4 12054",
    d: "M1089.088,4349.641l0,.6a.308.308,0,0,0,.179.252.963.963,0,0,0,.875,0,.312.312,0,0,0,.183-.255l0-.606a.309.309,0,0,1-.183.255.963.963,0,0,1-.875,0,.309.309,0,0,1-.18-.251Z",
    fill: "#e4e6f0"
  }))))))), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12056",
    "data-name": "\\uD328\\uC2A4 12056",
    d: "M1089.711,4350.257a.62.62,0,1,1,.62-.62.62.62,0,0,1-.62.62Z",
    fill: "#e4e6f0"
  }))))), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12057",
    "data-name": "\\uD328\\uC2A4 12057",
    d: "M1083.18,4353.8a.157.157,0,0,0,.083-.023l6.127-3.537a.167.167,0,1,0-.167-.29l-6.127,3.538a.167.167,0,0,0,.084.312Z",
    fill: "#35353f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2511",
    "data-name": "\\uADF8\\uB8F9 2511"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2466",
    "data-name": "\\uADF8\\uB8F9 2466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2465",
    "data-name": "\\uADF8\\uB8F9 2465",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2463",
    "data-name": "\\uADF8\\uB8F9 2463"
  }, _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12058",
    "data-name": "\\uD328\\uC2A4 12058",
    d: "M1082.869,4358.368l0,2.983a.331.331,0,0,0,.194.27,1.033,1.033,0,0,0,.94,0,.332.332,0,0,0,.2-.274l0-2.983a.335.335,0,0,1-.2.275,1.041,1.041,0,0,1-.941,0A.332.332,0,0,1,1082.869,4358.368Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2462",
    "data-name": "\\uADF8\\uB8F9 2462",
    clipPath: "url(#clip-path-74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2461",
    "data-name": "\\uADF8\\uB8F9 2461",
    style: {
      isolation: "isolate"
    }
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12059",
    "data-name": "\\uD328\\uC2A4 12059",
    d: "M1082.869,4358.368l0,2.983a.331.331,0,0,0,.194.27,1.033,1.033,0,0,0,.94,0,.332.332,0,0,0,.2-.274l0-2.983a.335.335,0,0,1-.2.275,1.041,1.041,0,0,1-.941,0,.332.332,0,0,1-.193-.271Z",
    fill: "#2e2e37"
  }))))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2464",
    "data-name": "\\uADF8\\uB8F9 2464"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12061",
    "data-name": "\\uD328\\uC2A4 12061",
    d: "M1083.065,4358.094a.288.288,0,0,0,0,.545,1.041,1.041,0,0,0,.941,0,.288.288,0,0,0,0-.545A1.032,1.032,0,0,0,1083.065,4358.094Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2510",
    "data-name": "\\uADF8\\uB8F9 2510"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2497",
    "data-name": "\\uADF8\\uB8F9 2497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2472",
    "data-name": "\\uADF8\\uB8F9 2472"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2471",
    "data-name": "\\uADF8\\uB8F9 2471",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2469",
    "data-name": "\\uADF8\\uB8F9 2469",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2468",
    "data-name": "\\uADF8\\uB8F9 2468",
    clipPath: "url(#clip-path-75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2467",
    "data-name": "\\uADF8\\uB8F9 2467",
    style: {
      isolation: "isolate"
    }
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12062",
    "data-name": "\\uD328\\uC2A4 12062",
    d: "M1081.612,4358.252l0,.5a.954.954,0,0,0,.559.781,2.7,2.7,0,0,0,1.255.325v-.5a2.708,2.708,0,0,1-1.256-.325.954.954,0,0,1-.559-.781Z",
    fill: "#2e2e37"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12063",
    "data-name": "\\uD328\\uC2A4 12063",
    d: "M1083.427,4359.358v.5a2.834,2.834,0,0,0,1.463-.324,1.354,1.354,0,0,0,.407-.345v-.5a1.346,1.346,0,0,1-.408.345,2.809,2.809,0,0,1-1.462.324Z",
    fill: "#3b3b45"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12064",
    "data-name": "\\uD328\\uC2A4 12064",
    d: "M1085.3,4358.689v.5a.738.738,0,0,0,.16-.448v-.5a.734.734,0,0,1-.16.448Z",
    fill: "#2e2e37"
  }))))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2470",
    "data-name": "\\uADF8\\uB8F9 2470"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12066",
    "data-name": "\\uD328\\uC2A4 12066",
    d: "M1082.18,4357.46a.831.831,0,0,0-.009,1.573,3,3,0,0,0,2.718,0,.832.832,0,0,0,.009-1.575A2.993,2.993,0,0,0,1082.18,4357.46Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2478",
    "data-name": "\\uADF8\\uB8F9 2478"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2477",
    "data-name": "\\uADF8\\uB8F9 2477",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2475",
    "data-name": "\\uADF8\\uB8F9 2475",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2474",
    "data-name": "\\uADF8\\uB8F9 2474",
    clipPath: "url(#clip-path-76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2473",
    "data-name": "\\uADF8\\uB8F9 2473",
    style: {
      isolation: "isolate"
    }
  }, _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12067",
    "data-name": "\\uD328\\uC2A4 12067",
    d: "M1081.943,4357.624v.413a.792.792,0,0,0,.463.647,2.261,2.261,0,0,0,1.04.269v-.412a2.246,2.246,0,0,1-1.04-.27.789.789,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12068",
    "data-name": "\\uD328\\uC2A4 12068",
    d: "M1083.446,4358.541v.412a2.346,2.346,0,0,0,1.211-.269,1.118,1.118,0,0,0,.337-.285v-.412a1.131,1.131,0,0,1-.337.285,2.341,2.341,0,0,1-1.211.269Z",
    fill: "#3b3b45"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12069",
    "data-name": "\\uD328\\uC2A4 12069",
    d: "M1084.994,4357.987v.412a.617.617,0,0,0,.133-.372v-.412a.615.615,0,0,1-.133.372Z",
    fill: "#2e2e37"
  }))))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2476",
    "data-name": "\\uADF8\\uB8F9 2476"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12071",
    "data-name": "\\uD328\\uC2A4 12071",
    d: "M1082.413,4356.968a.688.688,0,0,0-.007,1.3,2.479,2.479,0,0,0,2.251,0,.689.689,0,0,0,.007-1.3A2.479,2.479,0,0,0,1082.413,4356.968Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2484",
    "data-name": "\\uADF8\\uB8F9 2484"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2483",
    "data-name": "\\uADF8\\uB8F9 2483",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2481",
    "data-name": "\\uADF8\\uB8F9 2481",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2480",
    "data-name": "\\uADF8\\uB8F9 2480",
    clipPath: "url(#clip-path-77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2479",
    "data-name": "\\uADF8\\uB8F9 2479",
    style: {
      isolation: "isolate"
    }
  }, _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12072",
    "data-name": "\\uD328\\uC2A4 12072",
    d: "M1081.619,4357v.5a.951.951,0,0,0,.557.779,2.7,2.7,0,0,0,1.252.324l0-.5a2.7,2.7,0,0,1-1.251-.324.951.951,0,0,1-.557-.779Z",
    fill: "#2e2e37"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12073",
    "data-name": "\\uD328\\uC2A4 12073",
    d: "M1083.427,4358.1l0,.5a2.817,2.817,0,0,0,1.457-.323,1.333,1.333,0,0,0,.406-.344v-.5a1.333,1.333,0,0,1-.406.344,2.815,2.815,0,0,1-1.458.323Z",
    fill: "#3b3b45"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12074",
    "data-name": "\\uD328\\uC2A4 12074",
    d: "M1085.291,4357.432v.5a.733.733,0,0,0,.16-.447v-.5a.739.739,0,0,1-.16.447Z",
    fill: "#2e2e37"
  }))))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2482",
    "data-name": "\\uADF8\\uB8F9 2482"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12076",
    "data-name": "\\uD328\\uC2A4 12076",
    d: "M1082.185,4356.207a.828.828,0,0,0-.009,1.568,2.983,2.983,0,0,0,2.709,0,.829.829,0,0,0,.009-1.57A2.98,2.98,0,0,0,1082.185,4356.207Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2490",
    "data-name": "\\uADF8\\uB8F9 2490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2489",
    "data-name": "\\uADF8\\uB8F9 2489",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2487",
    "data-name": "\\uADF8\\uB8F9 2487",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2486",
    "data-name": "\\uADF8\\uB8F9 2486",
    clipPath: "url(#clip-path-78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2485",
    "data-name": "\\uADF8\\uB8F9 2485",
    style: {
      isolation: "isolate"
    }
  }, _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12077",
    "data-name": "\\uD328\\uC2A4 12077",
    d: "M1081.943,4356.473v.412a.792.792,0,0,0,.463.647,2.243,2.243,0,0,0,1.04.269v-.412a2.246,2.246,0,0,1-1.04-.269.792.792,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12078",
    "data-name": "\\uD328\\uC2A4 12078",
    d: "M1083.446,4357.389v.412a2.341,2.341,0,0,0,1.211-.269,1.091,1.091,0,0,0,.337-.285v-.412a1.1,1.1,0,0,1-.337.285,2.346,2.346,0,0,1-1.211.269Z",
    fill: "#3b3b45"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12079",
    "data-name": "\\uD328\\uC2A4 12079",
    d: "M1084.994,4356.835v.412a.615.615,0,0,0,.133-.371v-.412a.615.615,0,0,1-.133.371Z",
    fill: "#2e2e37"
  }))))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2488",
    "data-name": "\\uADF8\\uB8F9 2488"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12081",
    "data-name": "\\uD328\\uC2A4 12081",
    d: "M1082.413,4355.817a.688.688,0,0,0-.007,1.3,2.479,2.479,0,0,0,2.251,0,.689.689,0,0,0,.007-1.3A2.479,2.479,0,0,0,1082.413,4355.817Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2496",
    "data-name": "\\uADF8\\uB8F9 2496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2495",
    "data-name": "\\uADF8\\uB8F9 2495",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2493",
    "data-name": "\\uADF8\\uB8F9 2493",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2492",
    "data-name": "\\uADF8\\uB8F9 2492",
    clipPath: "url(#clip-path-79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2491",
    "data-name": "\\uADF8\\uB8F9 2491",
    style: {
      isolation: "isolate"
    }
  }, _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12082",
    "data-name": "\\uD328\\uC2A4 12082",
    d: "M1081.639,4355.847l0,.491a.937.937,0,0,0,.551.77,2.668,2.668,0,0,0,1.238.321v-.491a2.693,2.693,0,0,1-1.239-.32.944.944,0,0,1-.551-.771Z",
    fill: "#2e2e37"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12083",
    "data-name": "\\uD328\\uC2A4 12083",
    d: "M1083.429,4356.938v.491a2.793,2.793,0,0,0,1.442-.32,1.3,1.3,0,0,0,.4-.34v-.491a1.319,1.319,0,0,1-.4.34,2.775,2.775,0,0,1-1.441.32Z",
    fill: "#3b3b45"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12084",
    "data-name": "\\uD328\\uC2A4 12084",
    d: "M1085.272,4356.278v.491a.731.731,0,0,0,.159-.442l0-.491a.721.721,0,0,1-.158.442Z",
    fill: "#2e2e37"
  }))))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2494",
    "data-name": "\\uADF8\\uB8F9 2494"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12086",
    "data-name": "\\uD328\\uC2A4 12086",
    d: "M1082.2,4355.066a.82.82,0,0,0-.009,1.552,2.953,2.953,0,0,0,2.68,0,.821.821,0,0,0,.009-1.553A2.953,2.953,0,0,0,1082.2,4355.066Z",
    fill: "#434851"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2509",
    "data-name": "\\uADF8\\uB8F9 2509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2503",
    "data-name": "\\uADF8\\uB8F9 2503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2502",
    "data-name": "\\uADF8\\uB8F9 2502",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2500",
    "data-name": "\\uADF8\\uB8F9 2500"
  }, _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12087",
    "data-name": "\\uD328\\uC2A4 12087",
    d: "M1082.913,4354.144l-.921,1.512a.769.769,0,0,0,.448.628,2.407,2.407,0,0,0,2.182,0,.775.775,0,0,0,.456-.636l-.931-1.507a.309.309,0,0,1-.182.254.959.959,0,0,1-.873,0A.3.3,0,0,1,1082.913,4354.144Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2499",
    "data-name": "\\uADF8\\uB8F9 2499",
    clipPath: "url(#clip-path-80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2498",
    "data-name": "\\uADF8\\uB8F9 2498",
    style: {
      isolation: "isolate"
    }
  }, _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12088",
    "data-name": "\\uD328\\uC2A4 12088",
    d: "M1082.913,4354.144l-.921,1.512a.769.769,0,0,0,.448.628,2.407,2.407,0,0,0,2.182,0,.775.775,0,0,0,.456-.636l-.931-1.507a.309.309,0,0,1-.182.254.959.959,0,0,1-.873,0,.3.3,0,0,1-.179-.251Z",
    fill: "#3b3b45"
  }))))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2501",
    "data-name": "\\uADF8\\uB8F9 2501"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12090",
    "data-name": "\\uD328\\uC2A4 12090",
    d: "M1083.095,4353.889a.267.267,0,0,0,0,.506.959.959,0,0,0,.873,0,.267.267,0,0,0,0-.506A.963.963,0,0,0,1083.095,4353.889Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2508",
    "data-name": "\\uADF8\\uB8F9 2508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2507",
    "data-name": "\\uADF8\\uB8F9 2507",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2506",
    "data-name": "\\uADF8\\uB8F9 2506"
  }, _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12091",
    "data-name": "\\uD328\\uC2A4 12091",
    d: "M1082.917,4353.488l0,.651a.306.306,0,0,0,.179.251.966.966,0,0,0,.875,0,.311.311,0,0,0,.183-.255l0-.6a.311.311,0,0,1-.183.255.966.966,0,0,1-.875,0A.369.369,0,0,1,1082.917,4353.488Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2505",
    "data-name": "\\uADF8\\uB8F9 2505",
    clipPath: "url(#clip-path-81)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2504",
    "data-name": "\\uADF8\\uB8F9 2504",
    style: {
      isolation: "isolate"
    }
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12092",
    "data-name": "\\uD328\\uC2A4 12092",
    d: "M1082.913,4353.533l0,.606a.306.306,0,0,0,.179.251.966.966,0,0,0,.875,0,.311.311,0,0,0,.183-.255l0-.6a.311.311,0,0,1-.183.255.966.966,0,0,1-.875,0,.308.308,0,0,1-.179-.252Z",
    fill: "#e4e6f0"
  }))))))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_80",
    "data-name": "\\uD0C0\\uC6D0 80",
    cx: 0.62,
    cy: 0.62,
    r: 0.62,
    transform: "translate(1082.916 4352.91)",
    fill: "#e4e6f0"
  }))))), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12094",
    "data-name": "\\uD328\\uC2A4 12094",
    d: "M1073.565,4359.355a.165.165,0,0,0,.083-.022l9.615-5.552a.167.167,0,1,0-.167-.289l-9.615,5.551a.167.167,0,0,0,.084.312Z",
    fill: "#35353f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2615",
    "data-name": "\\uADF8\\uB8F9 2615"
  }, _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_975",
    "data-name": "\\uC0AC\\uAC01\\uD615 975",
    width: 8.038,
    height: 0.335,
    transform: "translate(1093.061 4352.012) rotate(-30)",
    fill: "#35353f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2563",
    "data-name": "\\uADF8\\uB8F9 2563"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2518",
    "data-name": "\\uADF8\\uB8F9 2518"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2517",
    "data-name": "\\uADF8\\uB8F9 2517",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2515",
    "data-name": "\\uADF8\\uB8F9 2515"
  }, _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12095",
    "data-name": "\\uD328\\uC2A4 12095",
    d: "M1092.883,4356.534l0,2.982a.332.332,0,0,0,.193.271,1.041,1.041,0,0,0,.941,0,.335.335,0,0,0,.2-.275l0-2.982a.332.332,0,0,1-.2.274,1.041,1.041,0,0,1-.941,0A.332.332,0,0,1,1092.883,4356.534Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2514",
    "data-name": "\\uADF8\\uB8F9 2514",
    clipPath: "url(#clip-path-82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2513",
    "data-name": "\\uADF8\\uB8F9 2513",
    style: {
      isolation: "isolate"
    }
  }, _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12096",
    "data-name": "\\uD328\\uC2A4 12096",
    d: "M1092.883,4356.534l0,2.982a.332.332,0,0,0,.193.271,1.041,1.041,0,0,0,.941,0,.335.335,0,0,0,.2-.275l0-2.982a.332.332,0,0,1-.2.274,1.041,1.041,0,0,1-.941,0,.332.332,0,0,1-.193-.27Z",
    fill: "#2e2e37"
  }))))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2516",
    "data-name": "\\uADF8\\uB8F9 2516"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12098",
    "data-name": "\\uD328\\uC2A4 12098",
    d: "M1093.079,4356.259a.288.288,0,0,0,0,.545,1.041,1.041,0,0,0,.941,0,.288.288,0,0,0,0-.545A1.041,1.041,0,0,0,1093.079,4356.259Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2562",
    "data-name": "\\uADF8\\uB8F9 2562"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2549",
    "data-name": "\\uADF8\\uB8F9 2549"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2524",
    "data-name": "\\uADF8\\uB8F9 2524"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2523",
    "data-name": "\\uADF8\\uB8F9 2523",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2521",
    "data-name": "\\uADF8\\uB8F9 2521",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2520",
    "data-name": "\\uADF8\\uB8F9 2520",
    clipPath: "url(#clip-path-83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2519",
    "data-name": "\\uADF8\\uB8F9 2519",
    style: {
      isolation: "isolate"
    }
  }, _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12099",
    "data-name": "\\uD328\\uC2A4 12099",
    d: "M1091.626,4356.417l0,.5a.951.951,0,0,0,.559.781,2.7,2.7,0,0,0,1.255.325v-.5a2.726,2.726,0,0,1-1.256-.325.957.957,0,0,1-.559-.782Z",
    fill: "#2e2e37"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12100",
    "data-name": "\\uD328\\uC2A4 12100",
    d: "M1093.441,4357.524v.5a2.82,2.82,0,0,0,1.463-.324,1.333,1.333,0,0,0,.407-.345v-.5a1.346,1.346,0,0,1-.408.345,2.819,2.819,0,0,1-1.462.325Z",
    fill: "#3b3b45"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12101",
    "data-name": "\\uD328\\uC2A4 12101",
    d: "M1095.311,4356.854v.5a.735.735,0,0,0,.16-.448v-.5a.741.741,0,0,1-.16.448Z",
    fill: "#2e2e37"
  }))))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2522",
    "data-name": "\\uADF8\\uB8F9 2522"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12103",
    "data-name": "\\uD328\\uC2A4 12103",
    d: "M1092.194,4355.625a.832.832,0,0,0-.009,1.574,3,3,0,0,0,2.718,0,.832.832,0,0,0,.009-1.575A2.993,2.993,0,0,0,1092.194,4355.625Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2530",
    "data-name": "\\uADF8\\uB8F9 2530"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2529",
    "data-name": "\\uADF8\\uB8F9 2529",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2527",
    "data-name": "\\uADF8\\uB8F9 2527",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2526",
    "data-name": "\\uADF8\\uB8F9 2526",
    clipPath: "url(#clip-path-84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2525",
    "data-name": "\\uADF8\\uB8F9 2525",
    style: {
      isolation: "isolate"
    }
  }, _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12104",
    "data-name": "\\uD328\\uC2A4 12104",
    d: "M1091.957,4355.79v.412a.792.792,0,0,0,.463.647,2.249,2.249,0,0,0,1.04.269v-.412a2.258,2.258,0,0,1-1.04-.269.79.79,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12105",
    "data-name": "\\uD328\\uC2A4 12105",
    d: "M1093.46,4356.706v.412a2.346,2.346,0,0,0,1.211-.269,1.1,1.1,0,0,0,.337-.285v-.412a1.1,1.1,0,0,1-.338.285,2.336,2.336,0,0,1-1.21.269Z",
    fill: "#3b3b45"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12106",
    "data-name": "\\uD328\\uC2A4 12106",
    d: "M1095.008,4356.152v.412a.615.615,0,0,0,.133-.371v-.412a.612.612,0,0,1-.133.371Z",
    fill: "#2e2e37"
  }))))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2528",
    "data-name": "\\uADF8\\uB8F9 2528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12108",
    "data-name": "\\uD328\\uC2A4 12108",
    d: "M1092.427,4355.134a.688.688,0,0,0-.007,1.3,2.477,2.477,0,0,0,2.25,0,.689.689,0,0,0,.008-1.3A2.479,2.479,0,0,0,1092.427,4355.134Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2536",
    "data-name": "\\uADF8\\uB8F9 2536"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2535",
    "data-name": "\\uADF8\\uB8F9 2535",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2533",
    "data-name": "\\uADF8\\uB8F9 2533",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2532",
    "data-name": "\\uADF8\\uB8F9 2532",
    clipPath: "url(#clip-path-85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2531",
    "data-name": "\\uADF8\\uB8F9 2531",
    style: {
      isolation: "isolate"
    }
  }, _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12109",
    "data-name": "\\uD328\\uC2A4 12109",
    d: "M1091.633,4355.162v.5a.95.95,0,0,0,.557.778,2.694,2.694,0,0,0,1.252.324l0-.5a2.7,2.7,0,0,1-1.251-.324.947.947,0,0,1-.557-.778Z",
    fill: "#2e2e37"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12110",
    "data-name": "\\uD328\\uC2A4 12110",
    d: "M1093.441,4356.264l0,.5a2.812,2.812,0,0,0,1.457-.323,1.334,1.334,0,0,0,.406-.344v-.5a1.346,1.346,0,0,1-.406.344,2.813,2.813,0,0,1-1.458.323Z",
    fill: "#3b3b45"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12111",
    "data-name": "\\uD328\\uC2A4 12111",
    d: "M1095.305,4355.6v.5a.736.736,0,0,0,.16-.446v-.5a.738.738,0,0,1-.16.446Z",
    fill: "#2e2e37"
  }))))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2534",
    "data-name": "\\uADF8\\uB8F9 2534"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12113",
    "data-name": "\\uD328\\uC2A4 12113",
    d: "M1092.2,4354.372a.828.828,0,0,0-.009,1.568,2.981,2.981,0,0,0,2.709,0,.829.829,0,0,0,.009-1.57A2.983,2.983,0,0,0,1092.2,4354.372Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2542",
    "data-name": "\\uADF8\\uB8F9 2542"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2541",
    "data-name": "\\uADF8\\uB8F9 2541",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2539",
    "data-name": "\\uADF8\\uB8F9 2539",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2538",
    "data-name": "\\uADF8\\uB8F9 2538",
    clipPath: "url(#clip-path-86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2537",
    "data-name": "\\uADF8\\uB8F9 2537",
    style: {
      isolation: "isolate"
    }
  }, _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12114",
    "data-name": "\\uD328\\uC2A4 12114",
    d: "M1091.957,4354.638v.412a.791.791,0,0,0,.463.647,2.226,2.226,0,0,0,1.04.269v-.412a2.234,2.234,0,0,1-1.04-.269.79.79,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12115",
    "data-name": "\\uD328\\uC2A4 12115",
    d: "M1093.46,4355.554v.412a2.341,2.341,0,0,0,1.211-.268,1.126,1.126,0,0,0,.337-.286V4355a1.112,1.112,0,0,1-.338.286,2.34,2.34,0,0,1-1.21.268Z",
    fill: "#3b3b45"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12116",
    "data-name": "\\uD328\\uC2A4 12116",
    d: "M1095.008,4355v.412a.612.612,0,0,0,.133-.371v-.412a.615.615,0,0,1-.133.371Z",
    fill: "#2e2e37"
  }))))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2540",
    "data-name": "\\uADF8\\uB8F9 2540"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12118",
    "data-name": "\\uD328\\uC2A4 12118",
    d: "M1092.427,4353.982a.688.688,0,0,0-.007,1.3,2.48,2.48,0,0,0,2.25,0,.69.69,0,0,0,.008-1.305A2.482,2.482,0,0,0,1092.427,4353.982Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2548",
    "data-name": "\\uADF8\\uB8F9 2548"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2547",
    "data-name": "\\uADF8\\uB8F9 2547",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2545",
    "data-name": "\\uADF8\\uB8F9 2545",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2544",
    "data-name": "\\uADF8\\uB8F9 2544",
    clipPath: "url(#clip-path-87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2543",
    "data-name": "\\uADF8\\uB8F9 2543",
    style: {
      isolation: "isolate"
    }
  }, _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12119",
    "data-name": "\\uD328\\uC2A4 12119",
    d: "M1091.653,4354.013v.49a.942.942,0,0,0,.552.771,2.679,2.679,0,0,0,1.238.32l0-.491a2.664,2.664,0,0,1-1.238-.32.942.942,0,0,1-.551-.77Z",
    fill: "#2e2e37"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12120",
    "data-name": "\\uD328\\uC2A4 12120",
    d: "M1093.442,4355.1l0,.491a2.783,2.783,0,0,0,1.442-.32,1.313,1.313,0,0,0,.4-.34v-.49a1.334,1.334,0,0,1-.4.34,2.786,2.786,0,0,1-1.442.319Z",
    fill: "#3b3b45"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12121",
    "data-name": "\\uD328\\uC2A4 12121",
    d: "M1095.286,4354.444v.49a.73.73,0,0,0,.159-.442l0-.49a.725.725,0,0,1-.158.442Z",
    fill: "#2e2e37"
  }))))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2546",
    "data-name": "\\uADF8\\uB8F9 2546"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12123",
    "data-name": "\\uD328\\uC2A4 12123",
    d: "M1092.213,4353.231a.82.82,0,0,0-.009,1.552,2.953,2.953,0,0,0,2.68,0,.821.821,0,0,0,.009-1.553A2.95,2.95,0,0,0,1092.213,4353.231Z",
    fill: "#434851"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2561",
    "data-name": "\\uADF8\\uB8F9 2561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2555",
    "data-name": "\\uADF8\\uB8F9 2555"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2554",
    "data-name": "\\uADF8\\uB8F9 2554",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2552",
    "data-name": "\\uADF8\\uB8F9 2552"
  }, _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12124",
    "data-name": "\\uD328\\uC2A4 12124",
    d: "M1092.926,4352.309l-.92,1.513a.765.765,0,0,0,.448.627,2.407,2.407,0,0,0,2.182,0,.776.776,0,0,0,.456-.636l-.931-1.507a.31.31,0,0,1-.182.254.959.959,0,0,1-.873,0A.307.307,0,0,1,1092.926,4352.309Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2551",
    "data-name": "\\uADF8\\uB8F9 2551",
    clipPath: "url(#clip-path-88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2550",
    "data-name": "\\uADF8\\uB8F9 2550",
    style: {
      isolation: "isolate"
    }
  }, _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12125",
    "data-name": "\\uD328\\uC2A4 12125",
    d: "M1092.926,4352.309l-.92,1.513a.765.765,0,0,0,.448.627,2.407,2.407,0,0,0,2.182,0,.776.776,0,0,0,.456-.636l-.931-1.507a.31.31,0,0,1-.182.254.959.959,0,0,1-.873,0,.307.307,0,0,1-.18-.251Z",
    fill: "#3b3b45"
  }))))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2553",
    "data-name": "\\uADF8\\uB8F9 2553"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12127",
    "data-name": "\\uD328\\uC2A4 12127",
    d: "M1093.109,4352.055a.266.266,0,0,0,0,.5.959.959,0,0,0,.873,0,.267.267,0,0,0,0-.5A.957.957,0,0,0,1093.109,4352.055Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2560",
    "data-name": "\\uADF8\\uB8F9 2560"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2559",
    "data-name": "\\uADF8\\uB8F9 2559",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2558",
    "data-name": "\\uADF8\\uB8F9 2558"
  }, _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12128",
    "data-name": "\\uD328\\uC2A4 12128",
    d: "M1092.931,4351.653l0,.651a.312.312,0,0,0,.18.252.966.966,0,0,0,.875,0,.312.312,0,0,0,.183-.256l0-.6a.311.311,0,0,1-.183.255.966.966,0,0,1-.875,0A.368.368,0,0,1,1092.931,4351.653Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2557",
    "data-name": "\\uADF8\\uB8F9 2557",
    clipPath: "url(#clip-path-89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2556",
    "data-name": "\\uADF8\\uB8F9 2556",
    style: {
      isolation: "isolate"
    }
  }, _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12129",
    "data-name": "\\uD328\\uC2A4 12129",
    d: "M1092.926,4351.7l0,.6a.312.312,0,0,0,.18.252.966.966,0,0,0,.875,0,.312.312,0,0,0,.183-.256l0-.6a.311.311,0,0,1-.183.255.966.966,0,0,1-.875,0,.31.31,0,0,1-.18-.251Z",
    fill: "#e4e6f0"
  }))))))), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12131",
    "data-name": "\\uD328\\uC2A4 12131",
    d: "M1093.549,4352.315a.62.62,0,1,1,.62-.62.62.62,0,0,1-.62.62Z",
    fill: "#e4e6f0"
  }))))), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12132",
    "data-name": "\\uD328\\uC2A4 12132",
    d: "M1087.018,4355.862a.157.157,0,0,0,.083-.023l6.127-3.537a.167.167,0,0,0-.167-.29l-6.127,3.538a.167.167,0,0,0,.084.312Z",
    fill: "#35353f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2614",
    "data-name": "\\uADF8\\uB8F9 2614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2569",
    "data-name": "\\uADF8\\uB8F9 2569"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2568",
    "data-name": "\\uADF8\\uB8F9 2568",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2566",
    "data-name": "\\uADF8\\uB8F9 2566"
  }, _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12133",
    "data-name": "\\uD328\\uC2A4 12133",
    d: "M1086.707,4360.426l0,2.983a.332.332,0,0,0,.193.27,1.035,1.035,0,0,0,.941,0,.334.334,0,0,0,.2-.274l0-2.983a.331.331,0,0,1-.2.275,1.038,1.038,0,0,1-.941,0A.331.331,0,0,1,1086.707,4360.426Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2565",
    "data-name": "\\uADF8\\uB8F9 2565",
    clipPath: "url(#clip-path-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2564",
    "data-name": "\\uADF8\\uB8F9 2564",
    style: {
      isolation: "isolate"
    }
  }, _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12134",
    "data-name": "\\uD328\\uC2A4 12134",
    d: "M1086.707,4360.426l0,2.983a.332.332,0,0,0,.193.27,1.035,1.035,0,0,0,.941,0,.334.334,0,0,0,.2-.274l0-2.983a.331.331,0,0,1-.2.275,1.038,1.038,0,0,1-.941,0,.331.331,0,0,1-.193-.271Z",
    fill: "#2e2e37"
  }))))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2567",
    "data-name": "\\uADF8\\uB8F9 2567"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12136",
    "data-name": "\\uD328\\uC2A4 12136",
    d: "M1086.9,4360.152a.288.288,0,0,0,0,.545,1.038,1.038,0,0,0,.941,0,.288.288,0,0,0,0-.545A1.035,1.035,0,0,0,1086.9,4360.152Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2613",
    "data-name": "\\uADF8\\uB8F9 2613"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2600",
    "data-name": "\\uADF8\\uB8F9 2600"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2575",
    "data-name": "\\uADF8\\uB8F9 2575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2574",
    "data-name": "\\uADF8\\uB8F9 2574",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2572",
    "data-name": "\\uADF8\\uB8F9 2572",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2571",
    "data-name": "\\uADF8\\uB8F9 2571",
    clipPath: "url(#clip-path-91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2570",
    "data-name": "\\uADF8\\uB8F9 2570",
    style: {
      isolation: "isolate"
    }
  }, _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12137",
    "data-name": "\\uD328\\uC2A4 12137",
    d: "M1085.45,4360.31l0,.5a.955.955,0,0,0,.559.781,2.713,2.713,0,0,0,1.255.325v-.5a2.708,2.708,0,0,1-1.256-.325.954.954,0,0,1-.559-.781Z",
    fill: "#2e2e37"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12138",
    "data-name": "\\uD328\\uC2A4 12138",
    d: "M1087.265,4361.416v.5a2.834,2.834,0,0,0,1.463-.324,1.354,1.354,0,0,0,.407-.345v-.5a1.338,1.338,0,0,1-.408.345,2.824,2.824,0,0,1-1.462.324Z",
    fill: "#3b3b45"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12139",
    "data-name": "\\uD328\\uC2A4 12139",
    d: "M1089.135,4360.747v.5a.738.738,0,0,0,.16-.448v-.5a.741.741,0,0,1-.16.448Z",
    fill: "#2e2e37"
  }))))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2573",
    "data-name": "\\uADF8\\uB8F9 2573"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12141",
    "data-name": "\\uD328\\uC2A4 12141",
    d: "M1086.018,4359.518a.831.831,0,0,0-.009,1.573,2.993,2.993,0,0,0,2.718,0,.832.832,0,0,0,.009-1.575A2.993,2.993,0,0,0,1086.018,4359.518Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2581",
    "data-name": "\\uADF8\\uB8F9 2581"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2580",
    "data-name": "\\uADF8\\uB8F9 2580",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2578",
    "data-name": "\\uADF8\\uB8F9 2578",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2577",
    "data-name": "\\uADF8\\uB8F9 2577",
    clipPath: "url(#clip-path-92)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2576",
    "data-name": "\\uADF8\\uB8F9 2576",
    style: {
      isolation: "isolate"
    }
  }, _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12142",
    "data-name": "\\uD328\\uC2A4 12142",
    d: "M1085.781,4359.682v.412a.789.789,0,0,0,.463.647,2.246,2.246,0,0,0,1.04.27v-.412a2.246,2.246,0,0,1-1.04-.27.791.791,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12143",
    "data-name": "\\uD328\\uC2A4 12143",
    d: "M1087.284,4360.6v.412a2.346,2.346,0,0,0,1.211-.269,1.131,1.131,0,0,0,.337-.285v-.413a1.112,1.112,0,0,1-.338.286,2.34,2.34,0,0,1-1.21.269Z",
    fill: "#3b3b45"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12144",
    "data-name": "\\uD328\\uC2A4 12144",
    d: "M1088.832,4360.044v.413a.617.617,0,0,0,.133-.372v-.412a.612.612,0,0,1-.133.371Z",
    fill: "#2e2e37"
  }))))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2579",
    "data-name": "\\uADF8\\uB8F9 2579"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12146",
    "data-name": "\\uD328\\uC2A4 12146",
    d: "M1086.251,4359.026a.688.688,0,0,0-.007,1.3,2.477,2.477,0,0,0,2.25,0,.689.689,0,0,0,.008-1.3A2.479,2.479,0,0,0,1086.251,4359.026Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2587",
    "data-name": "\\uADF8\\uB8F9 2587"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2586",
    "data-name": "\\uADF8\\uB8F9 2586",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2584",
    "data-name": "\\uADF8\\uB8F9 2584",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2583",
    "data-name": "\\uADF8\\uB8F9 2583",
    clipPath: "url(#clip-path-93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2582",
    "data-name": "\\uADF8\\uB8F9 2582",
    style: {
      isolation: "isolate"
    }
  }, _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12147",
    "data-name": "\\uD328\\uC2A4 12147",
    d: "M1085.457,4359.054v.5a.951.951,0,0,0,.557.779,2.7,2.7,0,0,0,1.252.324l0-.5a2.7,2.7,0,0,1-1.251-.324.95.95,0,0,1-.557-.779Z",
    fill: "#2e2e37"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12148",
    "data-name": "\\uD328\\uC2A4 12148",
    d: "M1087.265,4360.157l0,.5a2.821,2.821,0,0,0,1.457-.323,1.334,1.334,0,0,0,.406-.344v-.5a1.345,1.345,0,0,1-.406.344,2.823,2.823,0,0,1-1.458.323Z",
    fill: "#3b3b45"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12149",
    "data-name": "\\uD328\\uC2A4 12149",
    d: "M1089.129,4359.49v.5a.736.736,0,0,0,.16-.447v-.5a.739.739,0,0,1-.16.447Z",
    fill: "#2e2e37"
  }))))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2585",
    "data-name": "\\uADF8\\uB8F9 2585"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12151",
    "data-name": "\\uD328\\uC2A4 12151",
    d: "M1086.023,4358.265a.828.828,0,0,0-.009,1.568,2.983,2.983,0,0,0,2.709,0,.829.829,0,0,0,.009-1.57A2.981,2.981,0,0,0,1086.023,4358.265Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2593",
    "data-name": "\\uADF8\\uB8F9 2593"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2592",
    "data-name": "\\uADF8\\uB8F9 2592",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2590",
    "data-name": "\\uADF8\\uB8F9 2590",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2589",
    "data-name": "\\uADF8\\uB8F9 2589",
    clipPath: "url(#clip-path-94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2588",
    "data-name": "\\uADF8\\uB8F9 2588",
    style: {
      isolation: "isolate"
    }
  }, _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12152",
    "data-name": "\\uD328\\uC2A4 12152",
    d: "M1085.781,4358.531v.412a.791.791,0,0,0,.463.647,2.24,2.24,0,0,0,1.04.269v-.412a2.252,2.252,0,0,1-1.04-.269.792.792,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12153",
    "data-name": "\\uD328\\uC2A4 12153",
    d: "M1087.284,4359.447v.412a2.337,2.337,0,0,0,1.211-.269,1.1,1.1,0,0,0,.337-.285v-.412a1.11,1.11,0,0,1-.338.285,2.335,2.335,0,0,1-1.21.269Z",
    fill: "#3b3b45"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12154",
    "data-name": "\\uD328\\uC2A4 12154",
    d: "M1088.832,4358.893v.412a.615.615,0,0,0,.133-.371v-.412a.615.615,0,0,1-.133.371Z",
    fill: "#2e2e37"
  }))))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2591",
    "data-name": "\\uADF8\\uB8F9 2591"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12156",
    "data-name": "\\uD328\\uC2A4 12156",
    d: "M1086.251,4357.875a.688.688,0,0,0-.007,1.3,2.477,2.477,0,0,0,2.25,0,.689.689,0,0,0,.008-1.3A2.479,2.479,0,0,0,1086.251,4357.875Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2599",
    "data-name": "\\uADF8\\uB8F9 2599"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2598",
    "data-name": "\\uADF8\\uB8F9 2598",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2596",
    "data-name": "\\uADF8\\uB8F9 2596",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2595",
    "data-name": "\\uADF8\\uB8F9 2595",
    clipPath: "url(#clip-path-95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2594",
    "data-name": "\\uADF8\\uB8F9 2594",
    style: {
      isolation: "isolate"
    }
  }, _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12157",
    "data-name": "\\uD328\\uC2A4 12157",
    d: "M1085.477,4357.9l0,.491a.938.938,0,0,0,.551.77,2.661,2.661,0,0,0,1.238.321l0-.491a2.682,2.682,0,0,1-1.238-.32.942.942,0,0,1-.551-.771Z",
    fill: "#2e2e37"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12158",
    "data-name": "\\uD328\\uC2A4 12158",
    d: "M1087.266,4359l0,.491a2.788,2.788,0,0,0,1.442-.32,1.326,1.326,0,0,0,.4-.34v-.491a1.311,1.311,0,0,1-.4.34,2.776,2.776,0,0,1-1.442.32Z",
    fill: "#3b3b45"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12159",
    "data-name": "\\uD328\\uC2A4 12159",
    d: "M1089.11,4358.336v.491a.724.724,0,0,0,.158-.442v-.491a.721.721,0,0,1-.158.442Z",
    fill: "#2e2e37"
  }))))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2597",
    "data-name": "\\uADF8\\uB8F9 2597"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12161",
    "data-name": "\\uD328\\uC2A4 12161",
    d: "M1086.037,4357.124a.82.82,0,0,0-.009,1.552,2.95,2.95,0,0,0,2.68,0,.82.82,0,0,0,.009-1.553A2.95,2.95,0,0,0,1086.037,4357.124Z",
    fill: "#434851"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2612",
    "data-name": "\\uADF8\\uB8F9 2612"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2606",
    "data-name": "\\uADF8\\uB8F9 2606"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2605",
    "data-name": "\\uADF8\\uB8F9 2605",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2603",
    "data-name": "\\uADF8\\uB8F9 2603"
  }, _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12162",
    "data-name": "\\uD328\\uC2A4 12162",
    d: "M1086.75,4356.2l-.92,1.512a.767.767,0,0,0,.448.628,2.4,2.4,0,0,0,2.182,0,.774.774,0,0,0,.456-.637l-.931-1.507a.31.31,0,0,1-.182.255.962.962,0,0,1-.873,0A.308.308,0,0,1,1086.75,4356.2Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2602",
    "data-name": "\\uADF8\\uB8F9 2602",
    clipPath: "url(#clip-path-96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2601",
    "data-name": "\\uADF8\\uB8F9 2601",
    style: {
      isolation: "isolate"
    }
  }, _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12163",
    "data-name": "\\uD328\\uC2A4 12163",
    d: "M1086.75,4356.2l-.92,1.512a.767.767,0,0,0,.448.628,2.4,2.4,0,0,0,2.182,0,.774.774,0,0,0,.456-.637l-.931-1.507a.31.31,0,0,1-.182.255.962.962,0,0,1-.873,0,.308.308,0,0,1-.18-.251Z",
    fill: "#3b3b45"
  }))))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2604",
    "data-name": "\\uADF8\\uB8F9 2604"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12165",
    "data-name": "\\uD328\\uC2A4 12165",
    d: "M1086.933,4355.947a.268.268,0,0,0,0,.506.962.962,0,0,0,.873,0,.268.268,0,0,0,0-.506A.966.966,0,0,0,1086.933,4355.947Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2611",
    "data-name": "\\uADF8\\uB8F9 2611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2610",
    "data-name": "\\uADF8\\uB8F9 2610",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2609",
    "data-name": "\\uADF8\\uB8F9 2609"
  }, _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12166",
    "data-name": "\\uD328\\uC2A4 12166",
    d: "M1086.755,4355.546l0,.651a.31.31,0,0,0,.18.251.966.966,0,0,0,.875,0,.311.311,0,0,0,.183-.255l0-.6a.311.311,0,0,1-.183.255.963.963,0,0,1-.875,0A.368.368,0,0,1,1086.755,4355.546Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2608",
    "data-name": "\\uADF8\\uB8F9 2608",
    clipPath: "url(#clip-path-97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2607",
    "data-name": "\\uADF8\\uB8F9 2607",
    style: {
      isolation: "isolate"
    }
  }, _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12167",
    "data-name": "\\uD328\\uC2A4 12167",
    d: "M1086.75,4355.591l0,.606a.31.31,0,0,0,.18.251.966.966,0,0,0,.875,0,.311.311,0,0,0,.183-.255l0-.6a.311.311,0,0,1-.183.255.963.963,0,0,1-.875,0,.311.311,0,0,1-.18-.252Z",
    fill: "#e4e6f0"
  }))))))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_81",
    "data-name": "\\uD0C0\\uC6D0 81",
    cx: 0.62,
    cy: 0.62,
    r: 0.62,
    transform: "translate(1086.753 4354.968)",
    fill: "#e4e6f0"
  }))))), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12169",
    "data-name": "\\uD328\\uC2A4 12169",
    d: "M1077.549,4380.425a.167.167,0,0,0,.167-.166c.007-.75-.029-1.844-.07-3.111-.1-3.063-.237-7.257.192-9.208.724-3.29,2.861-8.017,8.935-11.86.406-.257.458-.29.416-.429a.175.175,0,0,0-.171-.124h0a.168.168,0,0,0-.148.094c-.056.039-.162.106-.272.176-6.172,3.9-8.346,8.719-9.084,12.071-.438,1.992-.306,6.039-.2,9.291.041,1.263.076,2.354.069,3.1a.168.168,0,0,0,.166.169Z",
    fill: "#35353f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2823",
    "data-name": "\\uADF8\\uB8F9 2823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2719",
    "data-name": "\\uADF8\\uB8F9 2719"
  }, _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_976",
    "data-name": "\\uC0AC\\uAC01\\uD615 976",
    width: 8.038,
    height: 0.335,
    transform: "translate(1057.097 4331.13) rotate(-30)",
    fill: "#35353f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2667",
    "data-name": "\\uADF8\\uB8F9 2667"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2622",
    "data-name": "\\uADF8\\uB8F9 2622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2621",
    "data-name": "\\uADF8\\uB8F9 2621",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2619",
    "data-name": "\\uADF8\\uB8F9 2619"
  }, _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12170",
    "data-name": "\\uD328\\uC2A4 12170",
    d: "M1056.919,4335.652l0,2.982a.332.332,0,0,0,.194.271,1.038,1.038,0,0,0,.941,0,.333.333,0,0,0,.2-.275l0-2.982a.332.332,0,0,1-.2.274,1.032,1.032,0,0,1-.941,0A.332.332,0,0,1,1056.919,4335.652Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2618",
    "data-name": "\\uADF8\\uB8F9 2618",
    clipPath: "url(#clip-path-98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2617",
    "data-name": "\\uADF8\\uB8F9 2617",
    style: {
      isolation: "isolate"
    }
  }, _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12171",
    "data-name": "\\uD328\\uC2A4 12171",
    d: "M1056.919,4335.652l0,2.982a.332.332,0,0,0,.194.271,1.038,1.038,0,0,0,.941,0,.333.333,0,0,0,.2-.275l0-2.982a.332.332,0,0,1-.2.274,1.032,1.032,0,0,1-.941,0,.332.332,0,0,1-.193-.27Z",
    fill: "#2e2e37"
  }))))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2620",
    "data-name": "\\uADF8\\uB8F9 2620"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12173",
    "data-name": "\\uD328\\uC2A4 12173",
    d: "M1057.116,4335.377a.288.288,0,0,0,0,.545,1.032,1.032,0,0,0,.941,0,.288.288,0,0,0,0-.545A1.039,1.039,0,0,0,1057.116,4335.377Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2666",
    "data-name": "\\uADF8\\uB8F9 2666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2653",
    "data-name": "\\uADF8\\uB8F9 2653"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2628",
    "data-name": "\\uADF8\\uB8F9 2628"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2627",
    "data-name": "\\uADF8\\uB8F9 2627",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2625",
    "data-name": "\\uADF8\\uB8F9 2625",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2624",
    "data-name": "\\uADF8\\uB8F9 2624",
    clipPath: "url(#clip-path-99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2623",
    "data-name": "\\uADF8\\uB8F9 2623",
    style: {
      isolation: "isolate"
    }
  }, _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12174",
    "data-name": "\\uD328\\uC2A4 12174",
    d: "M1055.663,4335.535v.5a.954.954,0,0,0,.559.781,2.7,2.7,0,0,0,1.256.325l0-.5a2.721,2.721,0,0,1-1.256-.325.954.954,0,0,1-.558-.782Z",
    fill: "#2e2e37"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12175",
    "data-name": "\\uD328\\uC2A4 12175",
    d: "M1057.477,4336.642l0,.5a2.819,2.819,0,0,0,1.462-.324,1.34,1.34,0,0,0,.407-.345v-.5a1.331,1.331,0,0,1-.408.344,2.819,2.819,0,0,1-1.462.325Z",
    fill: "#3b3b45"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12176",
    "data-name": "\\uD328\\uC2A4 12176",
    d: "M1059.347,4335.973v.5a.737.737,0,0,0,.161-.448l0-.5a.74.74,0,0,1-.16.449Z",
    fill: "#2e2e37"
  }))))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2626",
    "data-name": "\\uADF8\\uB8F9 2626"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12178",
    "data-name": "\\uD328\\uC2A4 12178",
    d: "M1056.23,4334.743a.831.831,0,0,0-.009,1.574,2.99,2.99,0,0,0,2.718,0,.832.832,0,0,0,.009-1.575A2.993,2.993,0,0,0,1056.23,4334.743Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2634",
    "data-name": "\\uADF8\\uB8F9 2634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2633",
    "data-name": "\\uADF8\\uB8F9 2633",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2631",
    "data-name": "\\uADF8\\uB8F9 2631",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2630",
    "data-name": "\\uADF8\\uB8F9 2630",
    clipPath: "url(#clip-path-100)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2629",
    "data-name": "\\uADF8\\uB8F9 2629",
    style: {
      isolation: "isolate"
    }
  }, _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12179",
    "data-name": "\\uD328\\uC2A4 12179",
    d: "M1055.993,4334.908v.412a.791.791,0,0,0,.463.647,2.243,2.243,0,0,0,1.04.269v-.412a2.249,2.249,0,0,1-1.04-.269.792.792,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12180",
    "data-name": "\\uD328\\uC2A4 12180",
    d: "M1057.5,4335.824v.412a2.334,2.334,0,0,0,1.211-.268,1.107,1.107,0,0,0,.337-.286v-.412a1.107,1.107,0,0,1-.337.286,2.346,2.346,0,0,1-1.211.268Z",
    fill: "#3b3b45"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12181",
    "data-name": "\\uD328\\uC2A4 12181",
    d: "M1059.044,4335.27v.412a.615.615,0,0,0,.133-.371v-.412a.614.614,0,0,1-.133.371Z",
    fill: "#2e2e37"
  }))))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2632",
    "data-name": "\\uADF8\\uB8F9 2632"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12183",
    "data-name": "\\uD328\\uC2A4 12183",
    d: "M1056.463,4334.252a.688.688,0,0,0-.007,1.3,2.482,2.482,0,0,0,2.251,0,.69.69,0,0,0,.007-1.305A2.482,2.482,0,0,0,1056.463,4334.252Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2640",
    "data-name": "\\uADF8\\uB8F9 2640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2639",
    "data-name": "\\uADF8\\uB8F9 2639",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2637",
    "data-name": "\\uADF8\\uB8F9 2637",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2636",
    "data-name": "\\uADF8\\uB8F9 2636",
    clipPath: "url(#clip-path-101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2635",
    "data-name": "\\uADF8\\uB8F9 2635",
    style: {
      isolation: "isolate"
    }
  }, _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12184",
    "data-name": "\\uD328\\uC2A4 12184",
    d: "M1055.669,4334.28v.5a.952.952,0,0,0,.557.778,2.708,2.708,0,0,0,1.252.324v-.5a2.711,2.711,0,0,1-1.252-.323.953.953,0,0,1-.557-.779Z",
    fill: "#2e2e37"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12185",
    "data-name": "\\uD328\\uC2A4 12185",
    d: "M1057.478,4335.382v.5a2.8,2.8,0,0,0,1.457-.323,1.346,1.346,0,0,0,.406-.343v-.5a1.345,1.345,0,0,1-.406.343,2.8,2.8,0,0,1-1.457.323Z",
    fill: "#3b3b45"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12186",
    "data-name": "\\uD328\\uC2A4 12186",
    d: "M1059.341,4334.716v.5a.735.735,0,0,0,.16-.447v-.5a.741.741,0,0,1-.16.447Z",
    fill: "#2e2e37"
  }))))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2638",
    "data-name": "\\uADF8\\uB8F9 2638"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12188",
    "data-name": "\\uD328\\uC2A4 12188",
    d: "M1056.235,4333.49a.829.829,0,0,0-.009,1.569,2.984,2.984,0,0,0,2.709,0,.83.83,0,0,0,.009-1.57A2.985,2.985,0,0,0,1056.235,4333.49Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2646",
    "data-name": "\\uADF8\\uB8F9 2646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2645",
    "data-name": "\\uADF8\\uB8F9 2645",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2643",
    "data-name": "\\uADF8\\uB8F9 2643",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2642",
    "data-name": "\\uADF8\\uB8F9 2642",
    clipPath: "url(#clip-path-102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2641",
    "data-name": "\\uADF8\\uB8F9 2641",
    style: {
      isolation: "isolate"
    }
  }, _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12189",
    "data-name": "\\uD328\\uC2A4 12189",
    d: "M1055.993,4333.756v.412a.791.791,0,0,0,.463.647,2.231,2.231,0,0,0,1.04.269v-.412a2.231,2.231,0,0,1-1.04-.269.79.79,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12190",
    "data-name": "\\uD328\\uC2A4 12190",
    d: "M1057.5,4334.672v.412a2.339,2.339,0,0,0,1.211-.268,1.108,1.108,0,0,0,.337-.286v-.412a1.106,1.106,0,0,1-.337.286,2.336,2.336,0,0,1-1.211.268Z",
    fill: "#3b3b45"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12191",
    "data-name": "\\uD328\\uC2A4 12191",
    d: "M1059.044,4334.118v.412a.61.61,0,0,0,.133-.371v-.412a.612.612,0,0,1-.133.371Z",
    fill: "#2e2e37"
  }))))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2644",
    "data-name": "\\uADF8\\uB8F9 2644"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12193",
    "data-name": "\\uD328\\uC2A4 12193",
    d: "M1056.463,4333.1a.688.688,0,0,0-.007,1.3,2.479,2.479,0,0,0,2.251,0,.689.689,0,0,0,.007-1.3A2.48,2.48,0,0,0,1056.463,4333.1Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2652",
    "data-name": "\\uADF8\\uB8F9 2652"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2651",
    "data-name": "\\uADF8\\uB8F9 2651",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2649",
    "data-name": "\\uADF8\\uB8F9 2649",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2648",
    "data-name": "\\uADF8\\uB8F9 2648",
    clipPath: "url(#clip-path-103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2647",
    "data-name": "\\uADF8\\uB8F9 2647",
    style: {
      isolation: "isolate"
    }
  }, _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12194",
    "data-name": "\\uD328\\uC2A4 12194",
    d: "M1055.689,4333.131l0,.49a.941.941,0,0,0,.551.771,2.683,2.683,0,0,0,1.238.32v-.49a2.675,2.675,0,0,1-1.239-.321.943.943,0,0,1-.551-.77Z",
    fill: "#2e2e37"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12195",
    "data-name": "\\uD328\\uC2A4 12195",
    d: "M1057.479,4334.222v.49a2.776,2.776,0,0,0,1.442-.32,1.305,1.305,0,0,0,.4-.34l0-.49a1.34,1.34,0,0,1-.4.34,2.793,2.793,0,0,1-1.442.32Z",
    fill: "#3b3b45"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12196",
    "data-name": "\\uD328\\uC2A4 12196",
    d: "M1059.322,4333.562l0,.49a.725.725,0,0,0,.158-.441l0-.491a.726.726,0,0,1-.158.442Z",
    fill: "#2e2e37"
  }))))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2650",
    "data-name": "\\uADF8\\uB8F9 2650"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12198",
    "data-name": "\\uD328\\uC2A4 12198",
    d: "M1056.249,4332.349a.82.82,0,0,0-.009,1.552,2.952,2.952,0,0,0,2.681,0,.82.82,0,0,0,.008-1.553A2.95,2.95,0,0,0,1056.249,4332.349Z",
    fill: "#434851"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2665",
    "data-name": "\\uADF8\\uB8F9 2665"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2659",
    "data-name": "\\uADF8\\uB8F9 2659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2658",
    "data-name": "\\uADF8\\uB8F9 2658",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2656",
    "data-name": "\\uADF8\\uB8F9 2656"
  }, _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12199",
    "data-name": "\\uD328\\uC2A4 12199",
    d: "M1056.963,4331.427l-.921,1.513a.766.766,0,0,0,.448.627,2.406,2.406,0,0,0,2.183,0,.77.77,0,0,0,.455-.636l-.931-1.507a.31.31,0,0,1-.182.254.962.962,0,0,1-.873,0A.306.306,0,0,1,1056.963,4331.427Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2655",
    "data-name": "\\uADF8\\uB8F9 2655",
    clipPath: "url(#clip-path-104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2654",
    "data-name": "\\uADF8\\uB8F9 2654",
    style: {
      isolation: "isolate"
    }
  }, _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12200",
    "data-name": "\\uD328\\uC2A4 12200",
    d: "M1056.963,4331.427l-.921,1.513a.766.766,0,0,0,.448.627,2.406,2.406,0,0,0,2.183,0,.77.77,0,0,0,.455-.636l-.931-1.507a.31.31,0,0,1-.182.254.962.962,0,0,1-.873,0,.306.306,0,0,1-.179-.251Z",
    fill: "#3b3b45"
  }))))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2657",
    "data-name": "\\uADF8\\uB8F9 2657"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12202",
    "data-name": "\\uD328\\uC2A4 12202",
    d: "M1057.145,4331.173a.267.267,0,0,0,0,.505.962.962,0,0,0,.873,0,.267.267,0,0,0,0-.505A.962.962,0,0,0,1057.145,4331.173Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2664",
    "data-name": "\\uADF8\\uB8F9 2664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2663",
    "data-name": "\\uADF8\\uB8F9 2663",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2662",
    "data-name": "\\uADF8\\uB8F9 2662"
  }, _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12203",
    "data-name": "\\uD328\\uC2A4 12203",
    d: "M1056.967,4330.771l0,.651a.308.308,0,0,0,.179.252.965.965,0,0,0,.876,0,.311.311,0,0,0,.182-.255l0-.606a.31.31,0,0,1-.183.255.963.963,0,0,1-.875,0A.367.367,0,0,1,1056.967,4330.771Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2661",
    "data-name": "\\uADF8\\uB8F9 2661",
    clipPath: "url(#clip-path-105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2660",
    "data-name": "\\uADF8\\uB8F9 2660",
    style: {
      isolation: "isolate"
    }
  }, _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12204",
    "data-name": "\\uD328\\uC2A4 12204",
    d: "M1056.963,4330.817l0,.6a.308.308,0,0,0,.179.252.965.965,0,0,0,.876,0,.311.311,0,0,0,.182-.255l0-.606a.31.31,0,0,1-.183.255.963.963,0,0,1-.875,0,.3.3,0,0,1-.179-.251Z",
    fill: "#e4e6f0"
  }))))))), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12206",
    "data-name": "\\uD328\\uC2A4 12206",
    d: "M1057.585,4331.433a.62.62,0,1,1,.62-.62.62.62,0,0,1-.62.62Z",
    fill: "#e4e6f0"
  }))))), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12207",
    "data-name": "\\uD328\\uC2A4 12207",
    d: "M1051.054,4334.98a.157.157,0,0,0,.083-.023l6.128-3.537a.168.168,0,1,0-.168-.29l-6.127,3.538a.167.167,0,0,0,.084.312Z",
    fill: "#35353f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2718",
    "data-name": "\\uADF8\\uB8F9 2718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2673",
    "data-name": "\\uADF8\\uB8F9 2673"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2672",
    "data-name": "\\uADF8\\uB8F9 2672",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2670",
    "data-name": "\\uADF8\\uB8F9 2670"
  }, _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12208",
    "data-name": "\\uD328\\uC2A4 12208",
    d: "M1050.743,4339.544l0,2.983a.327.327,0,0,0,.193.27,1.032,1.032,0,0,0,.941,0,.332.332,0,0,0,.2-.274l0-2.983a.335.335,0,0,1-.2.275,1.039,1.039,0,0,1-.94,0A.33.33,0,0,1,1050.743,4339.544Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2669",
    "data-name": "\\uADF8\\uB8F9 2669",
    clipPath: "url(#clip-path-106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2668",
    "data-name": "\\uADF8\\uB8F9 2668",
    style: {
      isolation: "isolate"
    }
  }, _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12209",
    "data-name": "\\uD328\\uC2A4 12209",
    d: "M1050.743,4339.544l0,2.983a.327.327,0,0,0,.193.27,1.032,1.032,0,0,0,.941,0,.332.332,0,0,0,.2-.274l0-2.983a.335.335,0,0,1-.2.275,1.039,1.039,0,0,1-.94,0,.33.33,0,0,1-.194-.271Z",
    fill: "#2e2e37"
  }))))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2671",
    "data-name": "\\uADF8\\uB8F9 2671"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12211",
    "data-name": "\\uD328\\uC2A4 12211",
    d: "M1050.94,4339.27a.288.288,0,0,0,0,.545,1.039,1.039,0,0,0,.94,0,.288.288,0,0,0,0-.545A1.033,1.033,0,0,0,1050.94,4339.27Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2717",
    "data-name": "\\uADF8\\uB8F9 2717"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2704",
    "data-name": "\\uADF8\\uB8F9 2704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2679",
    "data-name": "\\uADF8\\uB8F9 2679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2678",
    "data-name": "\\uADF8\\uB8F9 2678",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2676",
    "data-name": "\\uADF8\\uB8F9 2676",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2675",
    "data-name": "\\uADF8\\uB8F9 2675",
    clipPath: "url(#clip-path-107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2674",
    "data-name": "\\uADF8\\uB8F9 2674",
    style: {
      isolation: "isolate"
    }
  }, _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12212",
    "data-name": "\\uD328\\uC2A4 12212",
    d: "M1049.487,4339.428v.5a.955.955,0,0,0,.559.781,2.714,2.714,0,0,0,1.256.325l0-.5a2.708,2.708,0,0,1-1.256-.325.95.95,0,0,1-.558-.781Z",
    fill: "#2e2e37"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12213",
    "data-name": "\\uD328\\uC2A4 12213",
    d: "M1051.3,4340.534l0,.5a2.836,2.836,0,0,0,1.462-.324,1.354,1.354,0,0,0,.407-.345v-.5a1.332,1.332,0,0,1-.408.345,2.814,2.814,0,0,1-1.462.324Z",
    fill: "#3b3b45"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12214",
    "data-name": "\\uD328\\uC2A4 12214",
    d: "M1053.171,4339.865v.5a.738.738,0,0,0,.161-.448l0-.5a.736.736,0,0,1-.16.448Z",
    fill: "#2e2e37"
  }))))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2677",
    "data-name": "\\uADF8\\uB8F9 2677"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12216",
    "data-name": "\\uD328\\uC2A4 12216",
    d: "M1050.054,4338.636a.831.831,0,0,0-.009,1.573,2.993,2.993,0,0,0,2.718,0,.832.832,0,0,0,.009-1.575A3,3,0,0,0,1050.054,4338.636Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2685",
    "data-name": "\\uADF8\\uB8F9 2685"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2684",
    "data-name": "\\uADF8\\uB8F9 2684",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2682",
    "data-name": "\\uADF8\\uB8F9 2682",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2681",
    "data-name": "\\uADF8\\uB8F9 2681",
    clipPath: "url(#clip-path-108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2680",
    "data-name": "\\uADF8\\uB8F9 2680",
    style: {
      isolation: "isolate"
    }
  }, _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12217",
    "data-name": "\\uD328\\uC2A4 12217",
    d: "M1049.817,4338.8v.413a.791.791,0,0,0,.463.647,2.255,2.255,0,0,0,1.04.269v-.412a2.255,2.255,0,0,1-1.04-.269.792.792,0,0,1-.463-.648Z",
    fill: "#2e2e37"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12218",
    "data-name": "\\uD328\\uC2A4 12218",
    d: "M1051.32,4339.717v.412a2.334,2.334,0,0,0,1.211-.269,1.118,1.118,0,0,0,.337-.285v-.412a1.126,1.126,0,0,1-.337.285,2.341,2.341,0,0,1-1.211.269Z",
    fill: "#3b3b45"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12219",
    "data-name": "\\uD328\\uC2A4 12219",
    d: "M1052.868,4339.163v.412a.615.615,0,0,0,.133-.372v-.412a.617.617,0,0,1-.133.372Z",
    fill: "#2e2e37"
  }))))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2683",
    "data-name": "\\uADF8\\uB8F9 2683"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12221",
    "data-name": "\\uD328\\uC2A4 12221",
    d: "M1050.287,4338.144a.689.689,0,0,0-.007,1.3,2.482,2.482,0,0,0,2.251,0,.689.689,0,0,0,.007-1.3A2.482,2.482,0,0,0,1050.287,4338.144Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2691",
    "data-name": "\\uADF8\\uB8F9 2691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2690",
    "data-name": "\\uADF8\\uB8F9 2690",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2688",
    "data-name": "\\uADF8\\uB8F9 2688",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2687",
    "data-name": "\\uADF8\\uB8F9 2687",
    clipPath: "url(#clip-path-109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2686",
    "data-name": "\\uADF8\\uB8F9 2686",
    style: {
      isolation: "isolate"
    }
  }, _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12222",
    "data-name": "\\uD328\\uC2A4 12222",
    d: "M1049.493,4338.172v.5a.952.952,0,0,0,.557.779,2.7,2.7,0,0,0,1.252.324l0-.5a2.7,2.7,0,0,1-1.251-.324.951.951,0,0,1-.557-.779Z",
    fill: "#2e2e37"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12223",
    "data-name": "\\uD328\\uC2A4 12223",
    d: "M1051.3,4339.275l0,.5a2.812,2.812,0,0,0,1.457-.323,1.334,1.334,0,0,0,.406-.344v-.5a1.334,1.334,0,0,1-.406.344,2.813,2.813,0,0,1-1.458.323Z",
    fill: "#3b3b45"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12224",
    "data-name": "\\uD328\\uC2A4 12224",
    d: "M1053.165,4338.608v.5a.732.732,0,0,0,.16-.447v-.5a.738.738,0,0,1-.16.447Z",
    fill: "#2e2e37"
  }))))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2689",
    "data-name": "\\uADF8\\uB8F9 2689"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12226",
    "data-name": "\\uD328\\uC2A4 12226",
    d: "M1050.059,4337.383a.828.828,0,0,0-.009,1.568,2.986,2.986,0,0,0,2.709,0,.83.83,0,0,0,.009-1.57A2.983,2.983,0,0,0,1050.059,4337.383Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2697",
    "data-name": "\\uADF8\\uB8F9 2697"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2696",
    "data-name": "\\uADF8\\uB8F9 2696",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2694",
    "data-name": "\\uADF8\\uB8F9 2694",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2693",
    "data-name": "\\uADF8\\uB8F9 2693",
    clipPath: "url(#clip-path-110)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2692",
    "data-name": "\\uADF8\\uB8F9 2692",
    style: {
      isolation: "isolate"
    }
  }, _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12227",
    "data-name": "\\uD328\\uC2A4 12227",
    d: "M1049.817,4337.649v.412a.792.792,0,0,0,.463.647,2.249,2.249,0,0,0,1.04.269v-.412a2.255,2.255,0,0,1-1.04-.269.791.791,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12228",
    "data-name": "\\uD328\\uC2A4 12228",
    d: "M1051.32,4338.565v.412a2.339,2.339,0,0,0,1.211-.269,1.092,1.092,0,0,0,.337-.285v-.412a1.091,1.091,0,0,1-.337.285,2.341,2.341,0,0,1-1.211.269Z",
    fill: "#3b3b45"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12229",
    "data-name": "\\uD328\\uC2A4 12229",
    d: "M1052.868,4338.011v.412a.612.612,0,0,0,.133-.371v-.412a.615.615,0,0,1-.133.371Z",
    fill: "#2e2e37"
  }))))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2695",
    "data-name": "\\uADF8\\uB8F9 2695"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12231",
    "data-name": "\\uD328\\uC2A4 12231",
    d: "M1050.287,4336.993a.688.688,0,0,0-.007,1.3,2.477,2.477,0,0,0,2.251,0,.689.689,0,0,0,.007-1.3A2.476,2.476,0,0,0,1050.287,4336.993Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2703",
    "data-name": "\\uADF8\\uB8F9 2703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2702",
    "data-name": "\\uADF8\\uB8F9 2702",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2700",
    "data-name": "\\uADF8\\uB8F9 2700",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2699",
    "data-name": "\\uADF8\\uB8F9 2699",
    clipPath: "url(#clip-path-111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2698",
    "data-name": "\\uADF8\\uB8F9 2698",
    style: {
      isolation: "isolate"
    }
  }, _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12232",
    "data-name": "\\uD328\\uC2A4 12232",
    d: "M1049.513,4337.023l0,.491a.941.941,0,0,0,.551.77,2.676,2.676,0,0,0,1.238.321v-.491a2.68,2.68,0,0,1-1.239-.32.944.944,0,0,1-.551-.771Z",
    fill: "#2e2e37"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12233",
    "data-name": "\\uD328\\uC2A4 12233",
    d: "M1051.3,4338.114v.491a2.786,2.786,0,0,0,1.442-.32,1.331,1.331,0,0,0,.4-.34l0-.491a1.313,1.313,0,0,1-.4.34,2.781,2.781,0,0,1-1.442.32Z",
    fill: "#3b3b45"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12234",
    "data-name": "\\uD328\\uC2A4 12234",
    d: "M1053.146,4337.454l0,.491a.735.735,0,0,0,.158-.442l0-.491a.721.721,0,0,1-.158.442Z",
    fill: "#2e2e37"
  }))))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2701",
    "data-name": "\\uADF8\\uB8F9 2701"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12236",
    "data-name": "\\uD328\\uC2A4 12236",
    d: "M1050.073,4336.242a.82.82,0,0,0-.009,1.552,2.952,2.952,0,0,0,2.681,0,.82.82,0,0,0,.008-1.553A2.95,2.95,0,0,0,1050.073,4336.242Z",
    fill: "#434851"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2716",
    "data-name": "\\uADF8\\uB8F9 2716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2710",
    "data-name": "\\uADF8\\uB8F9 2710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2709",
    "data-name": "\\uADF8\\uB8F9 2709",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2707",
    "data-name": "\\uADF8\\uB8F9 2707"
  }, _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12237",
    "data-name": "\\uD328\\uC2A4 12237",
    d: "M1050.787,4335.32l-.921,1.512a.767.767,0,0,0,.448.628,2.406,2.406,0,0,0,2.183,0,.771.771,0,0,0,.455-.636l-.931-1.507a.309.309,0,0,1-.182.254.959.959,0,0,1-.873,0A.305.305,0,0,1,1050.787,4335.32Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2706",
    "data-name": "\\uADF8\\uB8F9 2706",
    clipPath: "url(#clip-path-112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2705",
    "data-name": "\\uADF8\\uB8F9 2705",
    style: {
      isolation: "isolate"
    }
  }, _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12238",
    "data-name": "\\uD328\\uC2A4 12238",
    d: "M1050.787,4335.32l-.921,1.512a.767.767,0,0,0,.448.628,2.406,2.406,0,0,0,2.183,0,.771.771,0,0,0,.455-.636l-.931-1.507a.309.309,0,0,1-.182.254.959.959,0,0,1-.873,0,.305.305,0,0,1-.179-.251Z",
    fill: "#3b3b45"
  }))))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2708",
    "data-name": "\\uADF8\\uB8F9 2708"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12240",
    "data-name": "\\uD328\\uC2A4 12240",
    d: "M1050.969,4335.066a.267.267,0,0,0,0,.5.959.959,0,0,0,.873,0,.267.267,0,0,0,0-.5A.959.959,0,0,0,1050.969,4335.066Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2715",
    "data-name": "\\uADF8\\uB8F9 2715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2714",
    "data-name": "\\uADF8\\uB8F9 2714",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2713",
    "data-name": "\\uADF8\\uB8F9 2713"
  }, _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12241",
    "data-name": "\\uD328\\uC2A4 12241",
    d: "M1050.791,4334.664l0,.651a.305.305,0,0,0,.18.251.963.963,0,0,0,.875,0,.308.308,0,0,0,.182-.255l0-.6a.31.31,0,0,1-.183.255.963.963,0,0,1-.875,0A.367.367,0,0,1,1050.791,4334.664Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2712",
    "data-name": "\\uADF8\\uB8F9 2712",
    clipPath: "url(#clip-path-113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2711",
    "data-name": "\\uADF8\\uB8F9 2711",
    style: {
      isolation: "isolate"
    }
  }, _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12242",
    "data-name": "\\uD328\\uC2A4 12242",
    d: "M1050.787,4334.709l0,.606a.305.305,0,0,0,.18.251.963.963,0,0,0,.875,0,.308.308,0,0,0,.182-.255l0-.6a.31.31,0,0,1-.183.255.963.963,0,0,1-.875,0,.307.307,0,0,1-.179-.252Z",
    fill: "#e4e6f0"
  }))))))), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12244",
    "data-name": "\\uD328\\uC2A4 12244",
    d: "M1050.79,4334.706a.62.62,0,1,1,.619.62A.62.62,0,0,1,1050.79,4334.706Z",
    fill: "#e4e6f0"
  }))))), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12245",
    "data-name": "\\uD328\\uC2A4 12245",
    d: "M1041.439,4340.531a.165.165,0,0,0,.083-.022l9.615-5.552a.167.167,0,1,0-.167-.289l-9.615,5.551a.167.167,0,0,0,.084.312Z",
    fill: "#35353f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2822",
    "data-name": "\\uADF8\\uB8F9 2822"
  }, _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_977",
    "data-name": "\\uC0AC\\uAC01\\uD615 977",
    width: 8.038,
    height: 0.335,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 1060.935, 4333.188)",
    fill: "#35353f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2770",
    "data-name": "\\uADF8\\uB8F9 2770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2725",
    "data-name": "\\uADF8\\uB8F9 2725"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2724",
    "data-name": "\\uADF8\\uB8F9 2724",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2722",
    "data-name": "\\uADF8\\uB8F9 2722"
  }, _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12246",
    "data-name": "\\uD328\\uC2A4 12246",
    d: "M1060.757,4337.709l0,2.983a.332.332,0,0,0,.194.271,1.039,1.039,0,0,0,.94,0,.332.332,0,0,0,.2-.275l0-2.982a.335.335,0,0,1-.2.274,1.035,1.035,0,0,1-.941,0A.332.332,0,0,1,1060.757,4337.709Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2721",
    "data-name": "\\uADF8\\uB8F9 2721",
    clipPath: "url(#clip-path-114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2720",
    "data-name": "\\uADF8\\uB8F9 2720",
    style: {
      isolation: "isolate"
    }
  }, _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12247",
    "data-name": "\\uD328\\uC2A4 12247",
    d: "M1060.757,4337.709l0,2.983a.332.332,0,0,0,.194.271,1.039,1.039,0,0,0,.94,0,.332.332,0,0,0,.2-.275l0-2.982a.335.335,0,0,1-.2.274,1.035,1.035,0,0,1-.941,0,.332.332,0,0,1-.193-.271Z",
    fill: "#2e2e37"
  }))))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2723",
    "data-name": "\\uADF8\\uB8F9 2723"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12249",
    "data-name": "\\uD328\\uC2A4 12249",
    d: "M1060.954,4337.435a.288.288,0,0,0,0,.545,1.035,1.035,0,0,0,.941,0,.288.288,0,0,0,0-.545A1.039,1.039,0,0,0,1060.954,4337.435Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2769",
    "data-name": "\\uADF8\\uB8F9 2769"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2756",
    "data-name": "\\uADF8\\uB8F9 2756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2731",
    "data-name": "\\uADF8\\uB8F9 2731"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2730",
    "data-name": "\\uADF8\\uB8F9 2730",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2728",
    "data-name": "\\uADF8\\uB8F9 2728",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2727",
    "data-name": "\\uADF8\\uB8F9 2727",
    clipPath: "url(#clip-path-115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2726",
    "data-name": "\\uADF8\\uB8F9 2726",
    style: {
      isolation: "isolate"
    }
  }, _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12250",
    "data-name": "\\uD328\\uC2A4 12250",
    d: "M1059.5,4337.593l0,.5a.955.955,0,0,0,.559.781,2.7,2.7,0,0,0,1.256.325l0-.5a2.72,2.72,0,0,1-1.256-.325.955.955,0,0,1-.559-.782Z",
    fill: "#2e2e37"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12251",
    "data-name": "\\uD328\\uC2A4 12251",
    d: "M1061.315,4338.7l0,.5a2.824,2.824,0,0,0,1.462-.324,1.341,1.341,0,0,0,.407-.345v-.5a1.334,1.334,0,0,1-.408.344,2.824,2.824,0,0,1-1.462.325Z",
    fill: "#3b3b45"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12252",
    "data-name": "\\uD328\\uC2A4 12252",
    d: "M1063.185,4338.031v.5a.735.735,0,0,0,.161-.448l0-.5a.738.738,0,0,1-.16.449Z",
    fill: "#2e2e37"
  }))))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2729",
    "data-name": "\\uADF8\\uB8F9 2729"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12254",
    "data-name": "\\uD328\\uC2A4 12254",
    d: "M1060.068,4336.8a.832.832,0,0,0-.009,1.574,2.993,2.993,0,0,0,2.718,0,.832.832,0,0,0,.009-1.575A3,3,0,0,0,1060.068,4336.8Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2737",
    "data-name": "\\uADF8\\uB8F9 2737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2736",
    "data-name": "\\uADF8\\uB8F9 2736",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2734",
    "data-name": "\\uADF8\\uB8F9 2734",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2733",
    "data-name": "\\uADF8\\uB8F9 2733",
    clipPath: "url(#clip-path-116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2732",
    "data-name": "\\uADF8\\uB8F9 2732",
    style: {
      isolation: "isolate"
    }
  }, _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12255",
    "data-name": "\\uD328\\uC2A4 12255",
    d: "M1059.831,4336.966v.412a.791.791,0,0,0,.463.647,2.243,2.243,0,0,0,1.04.269v-.412a2.24,2.24,0,0,1-1.04-.269.79.79,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12256",
    "data-name": "\\uD328\\uC2A4 12256",
    d: "M1061.334,4337.882v.412a2.339,2.339,0,0,0,1.211-.268,1.107,1.107,0,0,0,.337-.286v-.412a1.1,1.1,0,0,1-.337.285,2.337,2.337,0,0,1-1.211.269Z",
    fill: "#3b3b45"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12257",
    "data-name": "\\uD328\\uC2A4 12257",
    d: "M1062.882,4337.328v.412a.615.615,0,0,0,.133-.371v-.412a.615.615,0,0,1-.133.371Z",
    fill: "#2e2e37"
  }))))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2735",
    "data-name": "\\uADF8\\uB8F9 2735"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12259",
    "data-name": "\\uD328\\uC2A4 12259",
    d: "M1060.3,4336.31a.688.688,0,0,0-.007,1.3,2.476,2.476,0,0,0,2.251,0,.689.689,0,0,0,.007-1.3A2.479,2.479,0,0,0,1060.3,4336.31Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2743",
    "data-name": "\\uADF8\\uB8F9 2743"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2742",
    "data-name": "\\uADF8\\uB8F9 2742",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2740",
    "data-name": "\\uADF8\\uB8F9 2740",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2739",
    "data-name": "\\uADF8\\uB8F9 2739",
    clipPath: "url(#clip-path-117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2738",
    "data-name": "\\uADF8\\uB8F9 2738",
    style: {
      isolation: "isolate"
    }
  }, _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12260",
    "data-name": "\\uD328\\uC2A4 12260",
    d: "M1059.507,4336.338v.5a.95.95,0,0,0,.557.778,2.7,2.7,0,0,0,1.252.324l0-.5a2.7,2.7,0,0,1-1.251-.324.95.95,0,0,1-.557-.778Z",
    fill: "#2e2e37"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12261",
    "data-name": "\\uD328\\uC2A4 12261",
    d: "M1061.315,4337.44l0,.5a2.8,2.8,0,0,0,1.457-.323,1.326,1.326,0,0,0,.406-.344v-.5a1.334,1.334,0,0,1-.406.344,2.8,2.8,0,0,1-1.458.323Z",
    fill: "#3b3b45"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12262",
    "data-name": "\\uD328\\uC2A4 12262",
    d: "M1063.179,4336.773v.5a.731.731,0,0,0,.16-.446v-.5a.737.737,0,0,1-.16.446Z",
    fill: "#2e2e37"
  }))))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2741",
    "data-name": "\\uADF8\\uB8F9 2741"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12264",
    "data-name": "\\uD328\\uC2A4 12264",
    d: "M1060.073,4335.548a.828.828,0,0,0-.009,1.568,2.983,2.983,0,0,0,2.709,0,.83.83,0,0,0,.009-1.57A2.983,2.983,0,0,0,1060.073,4335.548Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2749",
    "data-name": "\\uADF8\\uB8F9 2749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2748",
    "data-name": "\\uADF8\\uB8F9 2748",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2746",
    "data-name": "\\uADF8\\uB8F9 2746",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2745",
    "data-name": "\\uADF8\\uB8F9 2745",
    clipPath: "url(#clip-path-118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2744",
    "data-name": "\\uADF8\\uB8F9 2744",
    style: {
      isolation: "isolate"
    }
  }, _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12265",
    "data-name": "\\uD328\\uC2A4 12265",
    d: "M1059.831,4335.814v.412a.792.792,0,0,0,.463.647,2.237,2.237,0,0,0,1.04.269v-.412a2.229,2.229,0,0,1-1.04-.269.791.791,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12266",
    "data-name": "\\uD328\\uC2A4 12266",
    d: "M1061.334,4336.73v.412a2.344,2.344,0,0,0,1.211-.268,1.108,1.108,0,0,0,.337-.286v-.412a1.119,1.119,0,0,1-.337.286,2.341,2.341,0,0,1-1.211.268Z",
    fill: "#3b3b45"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12267",
    "data-name": "\\uD328\\uC2A4 12267",
    d: "M1062.882,4336.176v.412a.61.61,0,0,0,.133-.371v-.412a.612.612,0,0,1-.133.371Z",
    fill: "#2e2e37"
  }))))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2747",
    "data-name": "\\uADF8\\uB8F9 2747"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12269",
    "data-name": "\\uD328\\uC2A4 12269",
    d: "M1060.3,4335.158a.688.688,0,0,0-.007,1.3,2.482,2.482,0,0,0,2.251,0,.689.689,0,0,0,.007-1.3A2.479,2.479,0,0,0,1060.3,4335.158Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2755",
    "data-name": "\\uADF8\\uB8F9 2755"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2754",
    "data-name": "\\uADF8\\uB8F9 2754",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2752",
    "data-name": "\\uADF8\\uB8F9 2752",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2751",
    "data-name": "\\uADF8\\uB8F9 2751",
    clipPath: "url(#clip-path-119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2750",
    "data-name": "\\uADF8\\uB8F9 2750",
    style: {
      isolation: "isolate"
    }
  }, _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12270",
    "data-name": "\\uD328\\uC2A4 12270",
    d: "M1059.527,4335.189l0,.49a.94.94,0,0,0,.551.771,2.685,2.685,0,0,0,1.238.32v-.49a2.669,2.669,0,0,1-1.239-.321.943.943,0,0,1-.551-.77Z",
    fill: "#2e2e37"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12271",
    "data-name": "\\uD328\\uC2A4 12271",
    d: "M1061.317,4336.28v.49a2.776,2.776,0,0,0,1.442-.32,1.319,1.319,0,0,0,.4-.34l0-.49a1.333,1.333,0,0,1-.4.34,2.8,2.8,0,0,1-1.441.32Z",
    fill: "#3b3b45"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12272",
    "data-name": "\\uD328\\uC2A4 12272",
    d: "M1063.16,4335.62l0,.49a.733.733,0,0,0,.158-.442l0-.49a.726.726,0,0,1-.158.442Z",
    fill: "#2e2e37"
  }))))), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2753",
    "data-name": "\\uADF8\\uB8F9 2753"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12274",
    "data-name": "\\uD328\\uC2A4 12274",
    d: "M1060.087,4334.407a.82.82,0,0,0-.009,1.552,2.95,2.95,0,0,0,2.68,0,.82.82,0,0,0,.009-1.553A2.95,2.95,0,0,0,1060.087,4334.407Z",
    fill: "#434851"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2768",
    "data-name": "\\uADF8\\uB8F9 2768"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2762",
    "data-name": "\\uADF8\\uB8F9 2762"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2761",
    "data-name": "\\uADF8\\uB8F9 2761",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2759",
    "data-name": "\\uADF8\\uB8F9 2759"
  }, _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12275",
    "data-name": "\\uD328\\uC2A4 12275",
    d: "M1060.8,4333.485l-.921,1.513a.766.766,0,0,0,.448.627,2.4,2.4,0,0,0,2.182,0,.769.769,0,0,0,.456-.636l-.931-1.507a.309.309,0,0,1-.182.254.959.959,0,0,1-.873,0A.3.3,0,0,1,1060.8,4333.485Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2758",
    "data-name": "\\uADF8\\uB8F9 2758",
    clipPath: "url(#clip-path-120)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2757",
    "data-name": "\\uADF8\\uB8F9 2757",
    style: {
      isolation: "isolate"
    }
  }, _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12276",
    "data-name": "\\uD328\\uC2A4 12276",
    d: "M1060.8,4333.485l-.921,1.513a.766.766,0,0,0,.448.627,2.4,2.4,0,0,0,2.182,0,.769.769,0,0,0,.456-.636l-.931-1.507a.309.309,0,0,1-.182.254.959.959,0,0,1-.873,0,.3.3,0,0,1-.179-.251Z",
    fill: "#3b3b45"
  }))))), _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2760",
    "data-name": "\\uADF8\\uB8F9 2760"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12278",
    "data-name": "\\uD328\\uC2A4 12278",
    d: "M1060.983,4333.231a.267.267,0,0,0,0,.5.959.959,0,0,0,.873,0,.267.267,0,0,0,0-.5A.959.959,0,0,0,1060.983,4333.231Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2767",
    "data-name": "\\uADF8\\uB8F9 2767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2766",
    "data-name": "\\uADF8\\uB8F9 2766",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2765",
    "data-name": "\\uADF8\\uB8F9 2765"
  }, _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12279",
    "data-name": "\\uD328\\uC2A4 12279",
    d: "M1060.805,4332.829l0,.651a.308.308,0,0,0,.179.252.963.963,0,0,0,.875,0,.311.311,0,0,0,.183-.255l0-.606a.31.31,0,0,1-.183.255.963.963,0,0,1-.875,0A.367.367,0,0,1,1060.805,4332.829Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2764",
    "data-name": "\\uADF8\\uB8F9 2764",
    clipPath: "url(#clip-path-121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2763",
    "data-name": "\\uADF8\\uB8F9 2763",
    style: {
      isolation: "isolate"
    }
  }, _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12280",
    "data-name": "\\uD328\\uC2A4 12280",
    d: "M1060.8,4332.875l0,.6a.308.308,0,0,0,.179.252.963.963,0,0,0,.875,0,.311.311,0,0,0,.183-.255l0-.606a.31.31,0,0,1-.183.255.963.963,0,0,1-.875,0,.305.305,0,0,1-.179-.251Z",
    fill: "#e4e6f0"
  }))))))), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12282",
    "data-name": "\\uD328\\uC2A4 12282",
    d: "M1061.423,4333.491a.62.62,0,1,1,.62-.62.62.62,0,0,1-.62.62Z",
    fill: "#e4e6f0"
  }))))), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12283",
    "data-name": "\\uD328\\uC2A4 12283",
    d: "M1054.892,4337.038a.161.161,0,0,0,.083-.023l6.127-3.537a.167.167,0,1,0-.167-.29l-6.127,3.538a.167.167,0,0,0,.084.312Z",
    fill: "#35353f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2821",
    "data-name": "\\uADF8\\uB8F9 2821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2776",
    "data-name": "\\uADF8\\uB8F9 2776"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2775",
    "data-name": "\\uADF8\\uB8F9 2775",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2773",
    "data-name": "\\uADF8\\uB8F9 2773"
  }, _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12284",
    "data-name": "\\uD328\\uC2A4 12284",
    d: "M1054.581,4341.6l0,2.983a.33.33,0,0,0,.194.27,1.033,1.033,0,0,0,.94,0,.331.331,0,0,0,.2-.274l0-2.983a.335.335,0,0,1-.2.275,1.041,1.041,0,0,1-.941,0A.331.331,0,0,1,1054.581,4341.6Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2772",
    "data-name": "\\uADF8\\uB8F9 2772",
    clipPath: "url(#clip-path-122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2771",
    "data-name": "\\uADF8\\uB8F9 2771",
    style: {
      isolation: "isolate"
    }
  }, _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12285",
    "data-name": "\\uD328\\uC2A4 12285",
    d: "M1054.581,4341.6l0,2.983a.33.33,0,0,0,.194.27,1.033,1.033,0,0,0,.94,0,.331.331,0,0,0,.2-.274l0-2.983a.335.335,0,0,1-.2.275,1.041,1.041,0,0,1-.941,0,.331.331,0,0,1-.193-.271Z",
    fill: "#2e2e37"
  }))))), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2774",
    "data-name": "\\uADF8\\uB8F9 2774"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12287",
    "data-name": "\\uD328\\uC2A4 12287",
    d: "M1054.778,4341.328a.288.288,0,0,0,0,.545,1.041,1.041,0,0,0,.941,0,.288.288,0,0,0,0-.545A1.03,1.03,0,0,0,1054.778,4341.328Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2820",
    "data-name": "\\uADF8\\uB8F9 2820"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2807",
    "data-name": "\\uADF8\\uB8F9 2807"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2782",
    "data-name": "\\uADF8\\uB8F9 2782"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2781",
    "data-name": "\\uADF8\\uB8F9 2781",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2779",
    "data-name": "\\uADF8\\uB8F9 2779",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2778",
    "data-name": "\\uADF8\\uB8F9 2778",
    clipPath: "url(#clip-path-123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2777",
    "data-name": "\\uADF8\\uB8F9 2777",
    style: {
      isolation: "isolate"
    }
  }, _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12288",
    "data-name": "\\uD328\\uC2A4 12288",
    d: "M1053.324,4341.486l0,.5a.955.955,0,0,0,.559.781,2.713,2.713,0,0,0,1.255.325v-.5a2.7,2.7,0,0,1-1.256-.325.954.954,0,0,1-.559-.781Z",
    fill: "#2e2e37"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12289",
    "data-name": "\\uD328\\uC2A4 12289",
    d: "M1055.139,4342.592v.5a2.834,2.834,0,0,0,1.463-.324,1.354,1.354,0,0,0,.407-.345v-.5a1.346,1.346,0,0,1-.408.345,2.819,2.819,0,0,1-1.462.324Z",
    fill: "#3b3b45"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12290",
    "data-name": "\\uD328\\uC2A4 12290",
    d: "M1057.009,4341.923v.5a.747.747,0,0,0,.161-.448l0-.5a.734.734,0,0,1-.16.448Z",
    fill: "#2e2e37"
  }))))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2780",
    "data-name": "\\uADF8\\uB8F9 2780"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12292",
    "data-name": "\\uD328\\uC2A4 12292",
    d: "M1053.892,4340.694a.831.831,0,0,0-.009,1.573,2.993,2.993,0,0,0,2.718,0,.832.832,0,0,0,.009-1.575A2.993,2.993,0,0,0,1053.892,4340.694Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2788",
    "data-name": "\\uADF8\\uB8F9 2788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2787",
    "data-name": "\\uADF8\\uB8F9 2787",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2785",
    "data-name": "\\uADF8\\uB8F9 2785",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2784",
    "data-name": "\\uADF8\\uB8F9 2784",
    clipPath: "url(#clip-path-124)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2783",
    "data-name": "\\uADF8\\uB8F9 2783",
    style: {
      isolation: "isolate"
    }
  }, _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12293",
    "data-name": "\\uD328\\uC2A4 12293",
    d: "M1053.655,4340.858v.412a.792.792,0,0,0,.463.648,2.261,2.261,0,0,0,1.04.269v-.412a2.24,2.24,0,0,1-1.04-.27.79.79,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12294",
    "data-name": "\\uD328\\uC2A4 12294",
    d: "M1055.158,4341.775v.412a2.339,2.339,0,0,0,1.211-.269,1.119,1.119,0,0,0,.337-.285v-.413a1.118,1.118,0,0,1-.337.286,2.337,2.337,0,0,1-1.211.269Z",
    fill: "#3b3b45"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12295",
    "data-name": "\\uD328\\uC2A4 12295",
    d: "M1056.706,4341.22v.413a.615.615,0,0,0,.133-.372v-.412a.612.612,0,0,1-.133.371Z",
    fill: "#2e2e37"
  }))))), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2786",
    "data-name": "\\uADF8\\uB8F9 2786"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12297",
    "data-name": "\\uD328\\uC2A4 12297",
    d: "M1054.125,4340.2a.688.688,0,0,0-.007,1.3,2.476,2.476,0,0,0,2.251,0,.689.689,0,0,0,.007-1.3A2.476,2.476,0,0,0,1054.125,4340.2Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2794",
    "data-name": "\\uADF8\\uB8F9 2794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2793",
    "data-name": "\\uADF8\\uB8F9 2793",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2791",
    "data-name": "\\uADF8\\uB8F9 2791",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2790",
    "data-name": "\\uADF8\\uB8F9 2790",
    clipPath: "url(#clip-path-125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2789",
    "data-name": "\\uADF8\\uB8F9 2789",
    style: {
      isolation: "isolate"
    }
  }, _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12298",
    "data-name": "\\uD328\\uC2A4 12298",
    d: "M1053.331,4340.23v.5a.953.953,0,0,0,.557.779,2.7,2.7,0,0,0,1.252.324l0-.5a2.7,2.7,0,0,1-1.251-.324.95.95,0,0,1-.557-.779Z",
    fill: "#2e2e37"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12299",
    "data-name": "\\uD328\\uC2A4 12299",
    d: "M1055.139,4341.333l0,.5a2.822,2.822,0,0,0,1.457-.323,1.333,1.333,0,0,0,.406-.344v-.5a1.326,1.326,0,0,1-.406.344,2.818,2.818,0,0,1-1.458.323Z",
    fill: "#3b3b45"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12300",
    "data-name": "\\uD328\\uC2A4 12300",
    d: "M1057,4340.666v.5a.731.731,0,0,0,.16-.447v-.5a.738.738,0,0,1-.16.447Z",
    fill: "#2e2e37"
  }))))), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2792",
    "data-name": "\\uADF8\\uB8F9 2792"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12302",
    "data-name": "\\uD328\\uC2A4 12302",
    d: "M1053.9,4339.441a.828.828,0,0,0-.009,1.568,2.984,2.984,0,0,0,2.709,0,.829.829,0,0,0,.009-1.57A2.98,2.98,0,0,0,1053.9,4339.441Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2800",
    "data-name": "\\uADF8\\uB8F9 2800"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2799",
    "data-name": "\\uADF8\\uB8F9 2799",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2797",
    "data-name": "\\uADF8\\uB8F9 2797",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2796",
    "data-name": "\\uADF8\\uB8F9 2796",
    clipPath: "url(#clip-path-126)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2795",
    "data-name": "\\uADF8\\uB8F9 2795",
    style: {
      isolation: "isolate"
    }
  }, _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12303",
    "data-name": "\\uD328\\uC2A4 12303",
    d: "M1053.655,4339.707v.412a.792.792,0,0,0,.463.647,2.261,2.261,0,0,0,1.04.269v-.412a2.258,2.258,0,0,1-1.04-.269.792.792,0,0,1-.463-.647Z",
    fill: "#2e2e37"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12304",
    "data-name": "\\uD328\\uC2A4 12304",
    d: "M1055.158,4340.623v.412a2.344,2.344,0,0,0,1.211-.269,1.092,1.092,0,0,0,.337-.285v-.412a1.117,1.117,0,0,1-.337.285,2.341,2.341,0,0,1-1.211.269Z",
    fill: "#3b3b45"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12305",
    "data-name": "\\uD328\\uC2A4 12305",
    d: "M1056.706,4340.069v.412a.615.615,0,0,0,.133-.371v-.412a.612.612,0,0,1-.133.371Z",
    fill: "#2e2e37"
  }))))), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2798",
    "data-name": "\\uADF8\\uB8F9 2798"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12307",
    "data-name": "\\uD328\\uC2A4 12307",
    d: "M1054.125,4339.051a.688.688,0,0,0-.007,1.3,2.479,2.479,0,0,0,2.251,0,.689.689,0,0,0,.007-1.3A2.479,2.479,0,0,0,1054.125,4339.051Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2806",
    "data-name": "\\uADF8\\uB8F9 2806"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2805",
    "data-name": "\\uADF8\\uB8F9 2805",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2803",
    "data-name": "\\uADF8\\uB8F9 2803",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2802",
    "data-name": "\\uADF8\\uB8F9 2802",
    clipPath: "url(#clip-path-127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2801",
    "data-name": "\\uADF8\\uB8F9 2801",
    style: {
      isolation: "isolate"
    }
  }, _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12308",
    "data-name": "\\uD328\\uC2A4 12308",
    d: "M1053.351,4339.081l0,.491a.937.937,0,0,0,.551.77,2.667,2.667,0,0,0,1.238.321v-.491a2.686,2.686,0,0,1-1.239-.32.945.945,0,0,1-.551-.771Z",
    fill: "#2e2e37"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12309",
    "data-name": "\\uD328\\uC2A4 12309",
    d: "M1055.141,4340.172v.491a2.786,2.786,0,0,0,1.442-.32,1.324,1.324,0,0,0,.4-.34l0-.491a1.326,1.326,0,0,1-.4.34,2.781,2.781,0,0,1-1.442.32Z",
    fill: "#3b3b45"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12310",
    "data-name": "\\uD328\\uC2A4 12310",
    d: "M1056.984,4339.512l0,.491a.737.737,0,0,0,.158-.442l0-.491a.722.722,0,0,1-.158.442Z",
    fill: "#2e2e37"
  }))))), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2804",
    "data-name": "\\uADF8\\uB8F9 2804"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12312",
    "data-name": "\\uD328\\uC2A4 12312",
    d: "M1053.911,4338.3a.82.82,0,0,0-.009,1.552,2.955,2.955,0,0,0,2.681,0,.821.821,0,0,0,.008-1.553A2.953,2.953,0,0,0,1053.911,4338.3Z",
    fill: "#434851"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2819",
    "data-name": "\\uADF8\\uB8F9 2819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2813",
    "data-name": "\\uADF8\\uB8F9 2813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2812",
    "data-name": "\\uADF8\\uB8F9 2812",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2810",
    "data-name": "\\uADF8\\uB8F9 2810"
  }, _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12313",
    "data-name": "\\uD328\\uC2A4 12313",
    d: "M1054.625,4337.378l-.921,1.512a.767.767,0,0,0,.448.628,2.4,2.4,0,0,0,2.182,0,.773.773,0,0,0,.456-.636l-.931-1.508a.31.31,0,0,1-.182.255.959.959,0,0,1-.873,0A.305.305,0,0,1,1054.625,4337.378Z",
    fill: "#3b3b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2809",
    "data-name": "\\uADF8\\uB8F9 2809",
    clipPath: "url(#clip-path-128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2808",
    "data-name": "\\uADF8\\uB8F9 2808",
    style: {
      isolation: "isolate"
    }
  }, _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12314",
    "data-name": "\\uD328\\uC2A4 12314",
    d: "M1054.625,4337.378l-.921,1.512a.767.767,0,0,0,.448.628,2.4,2.4,0,0,0,2.182,0,.773.773,0,0,0,.456-.636l-.931-1.508a.31.31,0,0,1-.182.255.959.959,0,0,1-.873,0,.305.305,0,0,1-.179-.251Z",
    fill: "#3b3b45"
  }))))), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2811",
    "data-name": "\\uADF8\\uB8F9 2811"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12316",
    "data-name": "\\uD328\\uC2A4 12316",
    d: "M1054.807,4337.123a.267.267,0,0,0,0,.506.959.959,0,0,0,.873,0,.267.267,0,0,0,0-.506A.963.963,0,0,0,1054.807,4337.123Z",
    fill: "#434851"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2818",
    "data-name": "\\uADF8\\uB8F9 2818"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2817",
    "data-name": "\\uADF8\\uB8F9 2817",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2816",
    "data-name": "\\uADF8\\uB8F9 2816"
  }, _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12317",
    "data-name": "\\uD328\\uC2A4 12317",
    d: "M1054.629,4336.722l0,.651a.306.306,0,0,0,.179.251.963.963,0,0,0,.875,0,.31.31,0,0,0,.183-.255l0-.6a.31.31,0,0,1-.183.255.963.963,0,0,1-.875,0A.369.369,0,0,1,1054.629,4336.722Z",
    fill: "#e4e6f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2815",
    "data-name": "\\uADF8\\uB8F9 2815",
    clipPath: "url(#clip-path-129)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2814",
    "data-name": "\\uADF8\\uB8F9 2814",
    style: {
      isolation: "isolate"
    }
  }, _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12318",
    "data-name": "\\uD328\\uC2A4 12318",
    d: "M1054.625,4336.767l0,.606a.306.306,0,0,0,.179.251.963.963,0,0,0,.875,0,.31.31,0,0,0,.183-.255l0-.6a.31.31,0,0,1-.183.255.963.963,0,0,1-.875,0,.308.308,0,0,1-.179-.252Z",
    fill: "#e4e6f0"
  }))))))), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12320",
    "data-name": "\\uD328\\uC2A4 12320",
    d: "M1054.628,4336.764a.619.619,0,1,1,.619.619A.62.62,0,0,1,1054.628,4336.764Z",
    fill: "#e4e6f0"
  }))))), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12321",
    "data-name": "\\uD328\\uC2A4 12321",
    d: "M1045.277,4342.589a.165.165,0,0,0,.083-.022l9.615-5.552a.167.167,0,0,0-.167-.289l-9.615,5.551a.167.167,0,0,0,.084.312Z",
    fill: "#35353f"
  })))), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12322",
    "data-name": "\\uD328\\uC2A4 12322",
    d: "M1072.346,4403.471a.669.669,0,0,0,.334-.09l4.089-2.361a3.428,3.428,0,0,0,1.834-2.345,2.7,2.7,0,0,0-.753-2.244.669.669,0,1,0-.987.9,1.4,1.4,0,0,1,.417,1.136,2.151,2.151,0,0,1-1.18,1.39l-4.09,2.361a.669.669,0,0,0,.336,1.249Z",
    fill: "#35353f"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12323",
    "data-name": "\\uD328\\uC2A4 12323",
    d: "M1071.225,4385.644a6.013,6.013,0,0,1,1.514-.534,8.245,8.245,0,0,1,1.535-.25,7.19,7.19,0,0,0,2.616-.523,2.1,2.1,0,0,0,1.124-1.908c.122-.079.252-.152.384-.222a2.7,2.7,0,0,1-.543,2,3.726,3.726,0,0,1-2.536,1.142,10.97,10.97,0,0,0-3.778.832A.314.314,0,0,1,1071.225,4385.644Z",
    fill: "#35353f"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12324",
    "data-name": "\\uD328\\uC2A4 12324",
    d: "M1070.659,4386.009a5.779,5.779,0,0,1,2.491-.182,5.728,5.728,0,0,0,3-.074,2,2,0,0,0,1.128-2.634c.1-.121.209-.229.307-.341a2.429,2.429,0,0,1-.274,2.664,3.47,3.47,0,0,1-3.016,1.019c-.647-.072-1.276-.158-1.929-.176a5.409,5.409,0,0,0-.92.023,2.14,2.14,0,0,1-.788.074C1070.453,4386.343,1070.5,4386.07,1070.659,4386.009Z",
    fill: "#35353f"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.1e37e24a638c65085d92ae6429d30931.svg";
export { ForwardRef as ReactComponent };